const zh = {
	storeManagement: {
		onvkg: 'Sila pilih penjual untuk inventori',
		hginvlg: 'sila pilih',
		gnivn: 'Sila pilih penjual',
		ggru: 'Sila pilih jenis gudang',
		yhgnmv: 'Kuantiti produk yang tinggal',
		okmv: 'Jumlah volum baki',
		hvkfb: 'Baki jumlah berat',
		rjbjh: 'Kuantiti yang diluluskan (tidak dikeluarkan)',
		trbv: 'Kuantiti tidak dihantar',
		ggdfj: 'Pindahkan segera',
		cancel: 'Batal',
		yriunv: 'Sahkan',
		ivnkf: 'Ubah suai inventori produk',
		ikgkvj: 'Sila masukkan sebab untuk mengubah suai inventori (diperlukan)',
		plhjkv: 'Kembangkan semua',
		tjbvl: 'Runtuhkan semua',
		uhjvhjf: 'Cari kod gudang, sku, nama produk',
		oknvk: 'Eksport keseluruhan gudang',
		ivlionr: 'Inventori gudang',
		uymbk: 'Sku induk gudang:',
		oknhgh: 'Kembangkan/Runtuhkan',
		kfiuhkg: 'Bilangan sub-sku gudang:',
		rhukfh: 'Baki jumlah inventori dalam gudang:',
		yttnkv: 'Nama penjual:',
		ighkv: 'Volume:',
		ibvnkf: 'Kedudukan:',
		oplmg: 'Sub-sku gudang:',
		iomnlgn: 'Simpan',
		fiklnmv: 'Edit',
		ouhkngj: 'Lihat log inventori',
		thbjv: 'Log inventori',
		kihk: 'Jumlah bilangan perubahan pesanan',
		ponkn: 'Perubahan inventori',
		dfggjk: 'Sebab untuk berubah',
		kgnmv: 'Tukar masa',
		fihgk: 'Yang terbaru ada di gudang',
		oooou: 'Penutupan',
		opmngh: 'Pengurusan inventori',
		ijkj: 'Perpustakaan produk tunggal',
		oikl: 'perpustakaan gabungan',
		ppki: 'Perpustakaan hadiah'




	},
	scanIntoStoreage: {
		ivnfiln: 'Nombor pesanan storan:',
		vklnf: 'Penjual:',
		oeknv: 'Jumlah pembelian penjual:',
		oevlknv: 'Jumlah bilangan cek gudang:',
		obvpkf: 'Kos tambahan tambahan gudang:',
		mmnnkv: 'Tetapkan semula pesanan storan',
		wiubvm: 'Semak semula',
		ornkf: 'Sahkan storan',
		wecbdk: 'Gudang telah disahkan',
		ovmoinv: 'Peringatan Penjual',
		ytbm: 'Kuantiti tidak normal',
		rebcd: 'Mesej daripada penjual',
		rebcj: 'Panjang/lebar/tinggi produk, berat diperlukan',
		nnbhg: 'Nombor yang diisi oleh penjual tidak konsisten dengan jumlah sebenar barang yang diterima, sahkan penerimaan? ',
		trbvcm: 'Ya',
		pomv: 'Batal',
		aswvcx: 'Sahkan penerimaan? ',
		dthj: 'Berjaya diserahkan kepada penjual untuk pengesahan! ',
		efhn: 'Pesanan storan semasa tidak membeli produk ini! ',
		treybvc: 'Sila imbas nombor resit',
		qwefc: 'Sila imbas kod bar produk',

	},
	distrustOrder: {
		returnMangement: 'Pengurusan pemulangan dan pertukaran',
		scan: 'Nombor pesanan, kawasan pengimbasan nombor bil laluan',
		status: 'Status Kembali:',
		sellerConfirm: 'Pemulangan untuk disahkan oleh penjual',
		hasConfirm: 'Penjual telah mengesahkan',
		aleadyAudit: 'Telah di proses',
		orderSearch: 'Carian nombor pesanan',
		serach: 'Cari',
		orderId: 'Nombor pesanan',
		orderStatus: 'Status pesanan',
		createdTimed: 'Masa pesanan',
		tosellerconfirm: 'Untuk disahkan oleh penjual',
		delete: 'Padam',
		position: 'Kedudukan:',
		cuscode: 'Kod gudang',
		originsku: 'Produk tunggal',
		purchaseNum: 'Kuantiti pembelian',
		jvknf: 'Kuantiti Konfigurasi',
		inlnv: 'Penjual memerlukan kaedah pemprosesan:',
		konmkf: 'Kuantiti di rak:',
		lkndv: 'Kaedah pemprosesan sebenar gudang:',
		oknlv: 'Kuantiti konfigurasi:',
		knvtr: 'Menerima pakej',
		knvfvtr: 'Untuk disahkan oleh penjual',
		pkjnmg: 'Untuk disahkan oleh gudang',
		bbnkf: 'Kenyataan gudang:',
		pombkg: 'Nota penjual:',
		bbvmkmg: 'Isi maklumat pemulangan',
		okjnmv: 'Mesej kepada penjual',
		momf: 'Klik untuk memuat naik',
		gytnv: 'Hanya muat naik fail jpg/png, dan tidak lebih daripada 8J',
		cancel: 'Batal',
		confirmBtn: 'Sahkan',
		okgnv: 'Pakej pemulangan',
		loknv: 'Serahkan',
		kvnkf: 'Tinggalkan mesej kepada penjual (pilihan)',
		ovbhkng: 'Belum ada pesanan, sila imbas dan masukkan! ',

	},
	processed: {
		cargoflow: 'Logistik penghantaran tunggal binaan sendiri',
		Thesellernote: 'Nota Penjual',
		Chooselogistics: 'Pilih Logistik',
		bulk: 'Volume/cm',
		length: 'Panjang/cm',
		width: 'lebar/cm',
		height: 'Tinggi/cm',
		weight: 'Berat/kg',
		actualfreight: 'Penghantaran Sebenar',
		waybillnumber: 'Nombor bil laluan',
		cancel: 'Batal',
		confirm: 'Sahkan',
		Scanningoutbound: 'Imbas perpustakaan',
		Orderarea: 'Nombor pesanan atau kawasan pengimbasan nombor bil laluan',
		Dateofpackaging: 'Tarikh pakej',
		outboundorders: 'Jumlah bilangan pesanan keluar',
		Themodified: 'Pesanan diubah suai oleh pengguna',
		enterheight: 'Sila masukkan ketinggian',
		enterlength: 'Sila masukkan panjang',
		enterwidth: 'Sila masukkan lebar',
		selectlogistics: 'Sila pilih logistik',
		enterweight: 'Sila masukkan berat',
		Logisticsdelivery: 'Maklumat logistik dan penghantaran pesanan yang dibina sendiri telah diserahkan! ',
		redasterisk: 'Asterisk merah diperlukan, sila isi! ',
		remarkspresent: "Belum ada nota penjual",
		details: ', Sila sahkan butiran pesanan! ',
		hint: 'Petunjuk',
		Isee: 'Saya faham',
		Processedorder: 'Pesanan diproses',
		optiondate: 'Pilih tarikh',
		startdate: 'Tarikh mula',
		dateclosed: 'Tarikh tamat',
		ordernumber: 'Nombor pesanan',
		Findnumber: 'Cari nombor pesanan',
		find: 'Cari',
		Warehouse: 'Gudang mengimbas keluar dari gudang (digunakan di gudang di luar negara)',
		Quantity: 'Kuantiti pesanan keluar',
		Numberof: 'Bilangan pembatalan selepas penghantaran',
		Expresscollection: 'Nombor koleksi kurier',
		money: 'Jumlah',
		deliveryfee: 'Yuran keluar',
		operation: 'Beroperasi',
		ViewOrder: 'Semak pesanan',
		Exportorders: 'Pesanan eksport',
		Print: 'Cetak Tanda Ekspres',
		all: 'Semua',
		Platformtype: 'Jenis platform:',
		single: 'Senarai binaan sendiri',
		Select: 'Pilih gudang:',
		Typofseller: 'Jenis Penjual:',
		Logisticstype: 'Jenis logistik:',
		Thegetsall: 'Penjual mendapat semua pesanan yang diproses',
		RecordDetails: 'Butiran rekod pakej',
		Couriername: 'Nama nyata',
		firstheavy: 'Kg berat pertama',
		heavycost: 'Berat pertama RMB/kg',
		Continuedheavy: 'Berat berterusan rmb/kg',
		chargemode: 'Kaedah pengebilan',
		volumeweight: 'Berat Isipadu',
		Takeofboth: 'Ambil maksimum kedua-duanya',
		actualweight: 'Berat Sebenar',
		actualvolume: 'Jumlah sebenar',
		actualcharges: 'Potongan sebenar',
		integral: 'Integral',
		Actualexpressfee: 'Yuran kurier sebenar',
		currency: 'Mata wang',
		Totalorders: 'Jumlah bilangan pesanan',
		Reprintthesheet: 'Cetak semula helaian muka',
		once: 'Kadar kedua',
		Unscannedoutgoing: 'Tidak diimbas keluar dari perpustakaan',
		LanShoutime: 'Masa pengumpulan',
		NotLanShou: 'Tidak dikumpul',
		Printcode: 'Cetak kod bar SKU produk',
		Printentry: 'Cetak kod bar pesanan storan',
		Barcodeprinting: 'Percetakan kod bar',
		printingquantity: 'Kuantiti cetak',
		Scanincoming: 'Imbas ke dalam storan',
		Thesellerside: 'Penjual',
		Estimatedvolume: 'Anggaran jumlah volum',
		viewdetails: 'Semak butiran',
		Guidethe: 'Eksport',
		Checkcurrency: 'Lihat set kadar pertukaran',
		summary: 'Ringkasan',
		local: 'Yuran platform dan yuran penghantaran telah ditolak, termasuk yuran komisen tambahan untuk aktiviti platform, dsb. (iaitu, pendapatan sebenar dompet kedai, dan ia adalah dalam RMB, dan kadar pertukaran tertentu boleh ditetapkan oleh pengguna dirinya)',
		localt: 'Kos pembelian, pengangkutan kaki pertama, keuntungan kasar dikira berdasarkan keluar dahulu masuk dahulu (iaitu, kumpulan pengangkutan udara dan laut yang berbeza menduduki kos yang berbeza, dan kosnya ialah RMB, dan kadar pertukaran tertentu boleh ditetapkan oleh pengguna sendiri)',
		localth: 'Mengikut nilai perakaunan, harga pembelian sebenar dan kos pengangkutan jalan raya dibezakan (nilai barang yang diangkut ke negara yang berbeza akan ditambah disebabkan oleh pengangkutan, dan ia adalah RMB, dan kadar pertukaran khusus boleh ditetapkan oleh pengguna itu sendiri)',
		shopId: 'ID Kedai',

		shopName: 'Nama kedai',
		country: 'Bangsa',
		platform: 'platform',
		turnover: 'Jumlah pesanan berbayar',
		advCost: 'Yuran pengiklanan Shoppe',
		returnAmount: 'Jumlah yang akan dikembalikan untuk pesanan pemulangan',
		orderCount: 'Semua pesanan (termasuk pembayaran yang belum selesai)',
		orderItemCount: 'Jualan pesanan berbayar',
		outboundCount: 'Jumlah bilangan pesanan keluar',
		outboundItemCount: 'Jumlah bilangan barang keluar dari gudang',
		shipCost: 'Yuran perjalanan pertama untuk barang keluar dari gudang',
		costCount: 'Kos pembelian produk keluar',
		Warehousestatus: 'Gudang - Status Inventori',
		storeid: 'ID Gudang',
		storeName: 'Nama gudang',
		volume: 'Volume (m³)',
		cost: 'Kos barangan',
		unshipped: 'Bilangan produk yang belum diproses',
		skunum: 'Bilangan sku',
		storenum: 'Jumlah kuantiti dalam gudang',
		weight: 'Jumlah berat dalam gudang (kg)',
		auditedstock: 'Kuantiti diaudit',
		expenditurecc: 'Tinjauan keseluruhan pendapatan dan perbelanjaan',
		payType: 'Jenis pembayaran',
		changeIntegral: 'Jumlah',
		operation: 'Beroperasi',
		chart: 'Trend',
		exchangerate: 'Kadar pertukaran',
		Modifyrate: 'Ubah suai kadar pertukaran',
		latestcurrency: 'Kadar pertukaran terkini',
		newexchange: 'Sila masukkan kadar pertukaran baharu',
		wechat: 'Perbelanjaan cas semula WeChat',
		Wechatincome: 'Pendapatan cas semula WeChat',
		Spendingorder: 'Perbelanjaan pesanan',
		Orderincome: 'Hasil pesanan',
		expenditure: 'Perbelanjaan pesanan resit',
		alipay: 'Perbelanjaan cas semula Alipay',
		Alipayincome: 'Pendapatan cas semula Alipay',
		Receiptentry: 'Pendapatan resit simpanan',
		rentalexpenses: 'Perbelanjaan sewa gudang',
		SMSscore: 'Pembayaran mata SMS',
		Smart: 'Perbelanjaan perkhidmatan pelanggan pintar',
		Spendingtranslation: 'Perbelanjaan terjemahan',
		handlingexpenses: 'Perbelanjaan pemprosesan pemulangan',
		Returnincome: 'Pulangan pendapatan pemprosesan',
		rentalincome: 'Pendapatan yuran sewa gudang',
		freightexpenses: 'Perbelanjaan pengangkutan untuk perjalanan pertama',
		revenue: 'Pendapatan fret headway',
		Preferentia: 'Perbelanjaan keutamaan',
		Preferentialincome: 'Pendapatan keutamaan',
		SMSrevenue: 'Pendapatan mata SMS',
		Inventory: 'Perbelanjaan perbelanjaan produk inventori',
		productincome: 'Pendapatan yuran produk inventori',
		Customerexpenses: 'Perbelanjaan aduan pelanggan',
		complaintrevenue: 'Pendapatan yuran aduan pelanggan',
		Revenueservice: 'Pendapatan perkhidmatan pelanggan pintar',
		Translationincome: 'Pendapatan terjemahan',
		Logisticsexpenses: 'Perbelanjaan logistik tunggal yang dibina sendiri',
		Logisticsfee: 'Pendapatan yuran logistik tunggal binaan sendiri',
		Cashspending: 'Bayaran balik tunai',
		Cashbackincome: 'Pendapatan balik tunai',
		Cashspendings: 'Perbelanjaan pengeluaran',
		Cashincome: 'Keluarkan pendapatan',
		temporalinterval: 'Julat tarikh',

	},

	stockProduct: {
		singlePro: 'Barang gudang',
		combo: 'Pakej gudang',
		gift: 'Hadiah gudang',
	},
	chat: {
		Allthequery: 'Tanya semua',
		Querymessage: 'Mesej pertanyaan',
		QueryingCustomername: 'Pertanyaan nama pelanggan',
		Authorizedshops: 'Kedai sah',
		Allunreadmessages: 'Semua mesej yang belum dibaca',
		Topnews: 'Mesej teratas',
		Thailand: 'Thailand',
		thePhilippines: 'Filipina',
		Malaysia: 'Melayu',
		Indonesia: 'Indonesia',
		Singapore: 'Singapura',
		Taiwan: 'Taiwan, China',
		Vietnam: 'Vietnam',
		Pleasefirst: 'Sila benarkan kedai itu dahulu',
		Managementgroup: 'Kumpulan pengurusan',
		Synchronizesessions: 'Segerakkan sesi shopee',
		Clickon: 'Klik pada mesej untuk menterjemah',
		Chinese: 'Cina',
		English: 'Bahasa Inggeris',
		intoEnglish: 'Terjemah ke Bahasa Inggeris',
		intoVietnamese: 'Diterjemah ke dalam bahasa Vietnam',
		intoChinese: 'Terjemah ke Bahasa Cina',
		intoIndonesian: 'Terjemah ke Bahasa Indonesia',
		intoSpanish: 'Terjemah ke Bahasa Sepanyol',
		intoPortuguese: 'Terjemah ke bahasa Portugis',
		original: 'Tunjukkan teks asal',
		commodity: 'Komoditi',
		order: 'Pesanan',
		product: 'Produk',
		Ordercreationtime: 'Masa membuat pesanan',
		DatetoPull: 'Tarikh penghantaran',
		why: 'Mengapa menggunakan sembang berbilang kedai Shopee yang dibenarkan secara rasmi?',
		reply: 'Buka balasan automatik',
		response: 'Tindak balas automatik',
		Automaticsetting: 'Tetapan tarikh balasan automatik',
		Modifyreply: 'Ubah suai kandungan balasan automatik',
		Addcontent: 'Tambah kandungan balasan automatik',
		Pleasereply: 'Sila masukkan kandungan balasan automatik',
		cancel: 'Batal',
		confirm: 'Tentu',
		Recommended: 'Balasan yang disyorkan',
		Fastreply: 'Balas Pantas',
		Machineresponse: 'Balasan pembelajaran mesin',
		beenmatched: 'Tiada balasan telah dipadankan',
		searchresult: 'Keputusan Carian',
		copy: 'Salinan',
		back: 'Kembali',
		Monday: 'Isnin',
		Tuesday: 'Selasa',
		Wednesday: 'Rabu',
		Thursday: 'Khamis',
		Friday: 'Jumaat',
		Saturday: 'Sabtu',
		Sunday: 'Ahad',
		CreateReply: 'Jawapan Pantas Baharu',
		issueofstandards: 'Soalan standard',
		messagetranslation: 'Buka mesej terjemahan automatik',
		language: 'Bahasa',
		send: 'Hantar',
		translate: 'Terjemah',
		original: 'Asal',
		Orderdata: 'Data pesanan',
		completed: 'Selesai',
		canceled: 'Dibatalkan',
		transport: 'Pengangkutan',
		uNPAID: 'Tidak dibayar',
		rEADY_TO_SHIP: 'Untuk dihantar',
		tO_CONFIRM_RECEIVE: 'Untuk ditandatangani',
		pROCESSED: 'Telah di proses',
		pending: 'Membatalkan',
		stepone: 'langkah 1',
		modification: 'Semakan semula',
		entercontent: 'Sila masukkan kandungan',
		cancellationorder: 'Batalkan pesanan',
		cause: 'Sila pilih sebab untuk membatalkan pesanan',
		Nouser: 'Tiada data pesanan pengguna',
		Nouserportrai: 'Tiada data potret pengguna',
		category: 'Kategori',
		powerofconsumption: 'Kuasa perbelanjaan',
		Totalconsumption: 'Jumlah jumlah penggunaan',
		common: 'Biasa',
		Priceinsensitive: 'Tidak sensitif harga',
		pricesensitive: 'Sensitif harga',
		Highspendingpower: 'Kuasa perbelanjaan tinggi',
		lowconsumption: 'Kuasa perbelanjaan rendah',
		Loyalty: 'Kesetiaan',
		Numbeconsumption: 'Bilangan pesanan (masa penggunaan)',
		rejectedorders: 'Bilangan pesanan yang ditolak',
		consumptioninterval: 'Purata selang penggunaan',
		Consumptioratio: 'Nisbah premium penggunaan purata harga kategori relatif',
		Lastdate: 'Selang dari penggunaan terakhir hingga kini',
		day: 'langit',
		Qamanagement: 'Pengurusan soal jawab',
		Selectgroup: 'Pilih kumpulan',
		questions: 'Soalan dan jawapan',
		searchquestion: 'Sila masukkan soalan carian',
		operationexecutive: 'Beroperasi',
		search: 'Cari',
		groupingmanagement: 'Pengurusan kumpulan',
		Thenewgrouping: 'Kumpulan baru',
		grouping: 'Kumpulan',
		compile: 'Edit',
		delete: 'Padam',
		Addanswer: 'Tambah soalan dan jawapan',
		groupname: 'Sila masukkan nama kumpulan',
		Pleaseentername: 'Sila masukkan nama kumpulan baharu',
		Thenewanswers: 'Soalan dan jawapan baharu',
		enterthekeyword: 'Sila masukkan kata kunci untuk mencari masalah',
		Thai: 'Bahasa Thai',
		Malay: 'Melayu',
		Similarproblems: 'Masalah yang serupa',
		add: 'Meningkat',
		answer: 'Jawapan',
		revert: 'Balas',
		thecurrentgroup: 'Tambahkan soalan dan jawapan untuk kumpulan semasa',
		Modifytheq: 'Ubah suai soalan dan jawapan',
		issue: 'Soalan',
		Addanewcustomgroup: 'Tambah kumpulan tersuai baharu',
		Groupdescription: 'Penerangan kumpulan',
		Addtogroup: 'Tambahkan pada kumpulan',
		Pleaseselectgroup: 'Sila pilih kumpulan (diperlukan)',
		Addgroup: 'Tambah kumpulan',
		AddingaNewGroup: 'Tambah kumpulan baharu',
		Userstories: 'Perihalan Pengguna',
		hint: 'Petunjuk',
		Vietnamese: 'Vietnam',
		Indonesian: 'Indonesia',
		spanish: 'Sepanyol',
		Portuguese: 'Portugis',
		image: "[Gambar]",
		order: "[Pesanan]",
		item: "[Komoditi]",
		sticker: "[Tekstur]",
		successfullyadded: 'Berjaya ditambahkan',
		successfullyset: 'Set berjaya',
		tips: 'Balasan automatik dihidupkan dan ia akan sepadan secara automatik dengan pengurusan soalan dan jawapan, dan jika ia tidak dapat dipadankan, ia akan membalas kepada "kandungan balasan automatik"',
		hasbeendisabled: 'Balasan automatik dimatikan',
		Sessionsucceeded: 'Penyegerakan sesi berjaya',
		additionfailed: 'Tambah gagal',
		Noisavailable: 'Belum ada hasil yang sepadan',
		modifysuccessfully: 'Berjaya diubah suai',
		changefailed: 'Gagal mengedit',
		cancelledsuccessfully: 'Batalkan pesanan berjaya',
		Copysuccess: 'Berjaya menyalin',
		successfullydelete: 'Berjaya dipadamkan',
		failtodelete: 'Gagal memadam',
		beempty: 'Soal jawab tidak boleh kosong',
		Confirmtoclose: 'Confirm tutup? ',
		Pleaseenterandmodify: 'Sila masukkan dan ubah suai',
		succeed: 'Kejayaan',
		sentsuccessfully: 'Hantar maklumat produk berjaya',
		Failepicture: 'Gagal memuat naik imej',
		Cancelledsend: 'Batalkan penghantaran',
		stick: 'Atas',
		Setasunread: 'Tetapkan sebagai belum dibaca',
		Deletethesession: 'Padamkan sesi',
		cancelauthorization: 'Batalkan kebenaran',
		Suretomodify: 'OK untuk mengubah suai',
		AddquickReplies: 'Tambah balasan pantas',
	},//多店聊模块
	allorders: {
		verification: "Sayang, awak belum mengikat shopee lagi!",
		notbound: "Sayang, awak belum mengikat shopee lagi!",
		shopx: 'Pergi ke kedai shopee terikat! ',
		allorder: 'Semua pesanan',
		rengtime: 'Julat masa pesanan:',
		regions: 'Negara / Wilayah',
		Platform: 'Jenis platform',
		Sestore: 'Pilih kedai',
		Ordertype: 'Jenis Pesanan',
		orderscheduling: 'Pesanan pesanan',
		Orderfind: 'Carian pesanan',
		SHOPEE: 'SHOPEE',
		LAZADA: 'LAZADA',
		manualorder: 'Senarai manual binaan sendiri',
		all: 'Semua',
		nopayment: 'Tidak dibayar',
		audit: 'Untuk disemak',
		insanity: 'Diaudit',
		collected: 'Kurier telah diterima',
		until: 'Tiba',
		starttime: 'Tarikh mula',
		endtime: 'Tarikh tamat',
		find: 'Cari',
		lookup: 'Masukkan nombor pesanan untuk mencari',
		Batcorders: 'Pesanan kumpulan eksport',
		modified: 'Pesanan diubah suai oleh pengguna',
		item: 'Produk tunggal',
		setmeal: 'Kombo',
		theitem: 'Produk tunggal',
		quantity: 'Kuantiti pembelian',
		description: 'Tiada',
		Morehere: 'Turun untuk mengembangkan lagi',
		Hideup: 'Bersembunyi',
		latestweek: 'Minggu lepas',
		Lastmonth: 'Bulan terakhir',
		Lastthreemonths: 'Tiga bulan terakhir',
		phonenumber: 'Nombor telefon',
		detailedaddress: 'Alamat',
		SkuNumbers: 'Kuantiti Sku',
		officialreceipts: 'Dikumpul',
		timepayment: 'Masa pembayaran',
		feature: 'Klik untuk menutup fungsi petua alat',
		Steamquantity: 'Kuantiti untuk dihantar',
		Onlineinventory: 'Inventori dalam talian',
		understock: 'Kekurangan inventori',
		Shopchoose: 'Pemilihan kedai',
		Theshipment: 'Baki penghantaran',
		Thecontaining: 'Pesanan mengandungi',
		pleasechoose: 'Sila pilih',
		show: 'Tunjukkan',
		hide: 'Sembunyi',
		Themarks: 'Tanda pesanan',
		nomarks: 'tidak bertanda',
		Themultiple: 'Buka mod berbilang pilihan',
		Isee: 'Saya faham',
		Therepository: 'Gudang audit yang dipilih pada masa ini',
		typegoods: 'Jenis kargo',
		warehouse: 'Diperlukan apabila jenis audit ialah gudang ujian',
		pastesheet: 'Sama ada hendak menampal satu',
		Batchopen: 'Batch terbuka',
		cause: 'Buka',
		Synchronizingorder: 'Segerakkan nombor pesanan tunggal',
		can: 'Ia boleh ditetapkan untuk menyemak pesanan secara automatik mengikut kedai dan menghantarnya ke gudang yang ditetapkan',
		Unboundproduct: 'Produk gudang tidak terikat',
		relationship: 'Ubah hubungan yang mengikat',
		Tobind: 'Mengikat',
		emptyproducts: 'Produk kosong',
		Deleteorder: 'Padam pesanan binaan sendiri',
		Hiddenorder: 'Sembunyikan pesanan',
		Accordingorder: 'Tunjukkan pesanan',
		Restoreorder: 'Pulihkan pesanan',
	},

	homeTwo: {

		title: 'Kedai/Gudang - Gambaran Keseluruhan',
		width: 'Lebar',
		Wholewarehousetransferinventoryandcorrespondingrelationship: 'Inventori pemindahan keseluruhan gudang dan hubungan yang sepadan',
		whitelist: 'Senarai putih',
		weight: 'Berat',
		Waybillnumber: 'Nombor bil laluan',
		Warehousetype: 'Jenis gudang',
		Warehousescanout: 'Gudang mengimbas keluar dari gudang (digunakan di gudang di luar negara)',
		Warehousemothersku: 'Ibu gudang sku',
		Warehousemother: 'Ibu Gudang',
		Warehousemessage: 'Mesej gudang',
		Warehousecode: 'Kod gudang',
		Warehouse: 'Gudang masuk',
		volume: 'Isipadu',
		vkf: 'Bantuan operasi',
		Viewselleroffers: 'Lihat tawaran penjual',
		Viewpreaccountedpointsdetails: 'Lihat butiran mata tempahan',
		Viewpointsdetails: 'Lihat butiran mata',
		Viewinventorydiary: 'Lihat diari inventori',
		View: 'Lihat/Ubah suai',
		Userportrait: 'Potret pengguna',
		Unpaid: 'Tidak dibayar',
		Unmarked: 'Tidak bertanda',
		Unfold: 'Kembangkan/Runtuhkan',
		Turnonautomaticmessagetranslation: 'Buka mesej terjemahan automatik',
		Turnon: 'Buka',
		Transportationcosts: 'Kos pengangkutan',
		translation: 'Terjemah',
		Totalsales: 'Jumlah jualan',
		Totalremaininginventory: 'Baki jumlah inventori dalam gudang',
		totalpoints: 'Jumlah mata',
		Totalpayment: 'Jumlah bayaran',
		Totalinventory: 'Jumlah inventori',
		Totalcurrentpurchases: 'Jumlah pembelian semasa',
		Totalconsumptionamount: 'Jumlah jumlah penggunaan',
		ToProcess: 'Gudang Thai',
		ToCheck: 'Pesanan belum selesai',
		Tobeconfirmedbytheseller: 'Untuk disahkan oleh penjual',
		Thesellerhasbeendetermined: 'Penjual telah disahkan',
		Theintervalbetweenthelastconsumptionandthepresent: 'Selang dari penggunaan terakhir hingga kini',
		Thaiselleruser: 'Pengguna penjual Thailand',
		Thailandwarehouse: 'Gudang Thai',
		Thailandtestwarehouse: 'Gudang Pengujian Thailand',
		Thailanddistributionwarehouse: 'Gudang pengedaran Thailand (ujian)',
		Thailand: 'Thailand',
		Thail: 'Thailand',
		Testingwarehouse: 'Gudang ujian',
		TechnicalSupport: 'Sokongan teknikal',
		Synchronizeshopeeconversation: 'Segerakkan dialog shopee',
		Successfullyreceived: 'Berjaya diterima',
		Successfullypaidtheorder: 'Berjaya membayar pesanan',
		Successfullyclaimedorder: 'Tuntutan berjaya - perintah',
		Successful: 'Tempahan berjaya telah dituntut',
		Subwarehouse: 'Sub-gudang di bawah akaun gudang semasa',
		SubInspection: 'Nombor pesanan',
		StoreName: 'Nama kedai',
		Stockreceipt: 'Pengurusan pesanan resit',
		Stockmanage: 'Pengurusan inventori',
		Spotinventory: 'Inventori stok',
		Spendingpower: 'Kuasa perbelanjaan',
		Specificationname: 'Nama spesifikasi',
		SmartChat: 'Kumpulan pengurusan',
		Singleproductlibrary: 'Perpustakaan produk tunggal',
		Singleproduct: 'Produk atau pakej tunggal',
		signout: 'Log keluar',
		Signforreminder: 'Tandatangan untuk peringatan',
		Showresults: 'Tunjukkan hasil',
		Shopfilter: 'Penapis kedai',
		Shop: 'Kedai',
		Shippingwarehouse: 'Gudang Penghantaran',
		Shipmentreminder: 'Peringatan Penghantaran',
		Setupselleroffers: 'Tetapkan diskaun penjual',
		Setupanemptypackage: 'Tetapkan pakej kosong',
		Setmeal: 'Kombo',
		Senttogether: 'Jumlah hantaran',
		Sensitivegoodsbyland: 'Barang sensitif diangkut melalui darat',
		send: 'Hantar',
		Sellingprice: 'Harga',
		Sellerusercurrentlybound: 'Pengguna penjual terikat pada masa ini',
		Sellertype: 'Jenis Penjual',
		Sellerside: 'Penjual',
		Sellerpurchasequantity: 'Kuantiti Pembelian Penjual',
		Sellernotes: 'Nota Penjual',
		SellerMessage: 'Mesej daripada penjual',
		Seller: 'Penjual',
		Selfbuiltorder: 'Senarai binaan sendiri',
		Selfbuiltmanualorder: 'Senarai manual binaan sendiri',
		Selectstorage: 'Pilih storan',
		Selectdate: 'Pilih tarikh',
		selectall: 'Pilih semua/terbalikkan',
		seedetails: 'Semak butiran',
		Search: 'Cari kod gudang, sku, nama produk',
		Scanarea: 'Kawasan pengimbasan',
		Returnstatus: 'Status Kembali',
		ReturnsManagement: 'Pengurusan pemulangan dan pertukaran',
		return: 'Kembali',
		Resetthepickedquantity: 'Tetapkan semula kuantiti pemilihan',
		Resetorder: 'Tetapkan semula pesanan',
		Required: 'Diperlukan',
		Remindertype: 'Jenis peringatan',
		Reminder: 'Peringatan untuk membayar',
		Remarks: 'Catatan',
		Remainingdeliverytimefrommoretoless: 'Baki masa penghantaran daripada lebih kepada kurang',
		Remainingdeliverytimefromlesstomore: 'Baki masa penghantaran daripada kurang kepada lebih',
		Remainingdeliverytime: 'Baki masa penghantaran',
		Relative: 'Nisbah premium penggunaan purata harga kategori relatif',
		Rechargenow: 'Cas semula sekarang',
		Receivefailed: 'Gagal menerima',
		reasonsforreturn: 'Sebab untuk kembali',
		Questionandanswermanagement: 'Pengurusan soal jawab',
		Quantitypicked: 'Memilih Kuantiti',
		Quantity: 'Kuantiti',
		Pushtime: 'Masa tekan',
		Purchasequantityinteger: 'Kuantiti pembelian (integer)',
		Purchasequantity: 'Kuantiti pembelian',
		productstatus: 'Status produk',
		productname: 'Nama Produk',
		Productcollection: 'Koleksi produk',
		Processed: 'Telah di proses',
		Processed: 'Pesanan diproses',
		Privatewarehouse: 'Gudang Persendirian',
		Printthecouriersign: 'Cetak Tanda Ekspres',
		printingtime: 'Masa Cetak',
		Printbarcode: 'Cetak kod bar',
		Pricesensitivity: 'Sensitiviti Harga',
		Pricesensitive: 'Sensitif harga',
		Priceinsensitive: 'Tidak sensitif harga',
		Presale: 'Sama ada untuk pra-jualan',
		Preemptivepoints: 'Mata simpanan',
		Position: 'Kedudukan',
		PointsAvailable: 'Mata Tersedia',
		Platformtype: 'Jenis platform',
		Personalcenter: 'Pusat Peribadi',
		Pendingthesellertoverifythreturn: 'Pemulangan untuk disahkan oleh penjual',
		Pendingreview: 'Untuk disemak',
		Paymenttime: 'Masa pembayaran',
		paymentsuccessful: 'Pembayaran berjaya',
		Packingdate: 'Tarikh pakej',
		OverseasWarehouseComplaintCenter: 'Pusat Aduan Gudang Luar Negara',
		Outboundfee: 'Yuran keluar',
		ordinary: 'Biasa',
		OrderType: 'Jenis Pesanan',
		OrderTracking: 'Penjejakan Pesanan',
		Ordertimerange: 'Julat masa pesanan',
		Ordertimefrommorningtonight: 'Tempah masa dari pagi hingga malam',
		Ordertimefromlatetoearly: 'Masa pesanan dari lewat hingga awal',
		Ordernumberorwaybillnumber: 'Nombor pesanan atau nombor bil laluan',
		ordernumber: 'Nombor pesanan',
		Orderlookup: 'Carian pesanan',
		Orderdata: 'Data pesanan',
		Orderactuallypaid: 'Pesanan dibayar',
		order: 'Pesanan Tuntutan Pengesahan Belum Selesai',
		operating: 'Beroperasi',
		Oneclickgenerationprice: 'Harga tawaran satu klik',
		Oneclickcollection: 'Koleksi satu klik',
		Offshelfdistribution: 'Pengedaran luar rak',
		Numberofwarehousesku: 'Kuantiti sub-sku gudang',
		Numberofoutboundorders: 'Kuantiti pesanan keluar',
		Numberofordersrejected: 'Bilangan pesanan yang ditolak',
		Numberofordersconsumptionnumber: 'Bilangan pesanan (bilangan penggunaan)',
		Numberofcancellationsafterdelivery: 'Bilangan pembatalan selepas penghantaran',
		Notprinted: 'Tidak dicetak',
		Notoutofstock: 'Tidak dilepaskan',
		Notgenerated: 'Tidak dihasilkan',
		Nomessage: 'Belum ada mesej',
		Nodata: 'Tiada data',
		No: 'Tiada',
		Newlyaddedproducts: 'Tambah produk baharu',
		Negotiate: 'Rundingan',
		Nationalcurrency: 'Mata Wang Negara',
		Multiplechoice: 'Buka mod berbilang pilihan',
		MonitoringPrice: 'Produk dalam talian',
		Monitoredproducts: 'Produk yang dipantau',
		Modifyorderinformation: 'Ubah suai maklumat pesanan',
		Middlevalue: 'Nilai sederhana',
		Memberrechargeinstructions: 'Arahan caj semula ahli: 1 yuan 1 mata, lebih banyak caj semula, lebih banyak mata bonus akan diberikan',
		Mediumloyaltyandhighprice: 'Kesetiaan sederhana dan harga tinggi',
		mark: 'Tanda',
		Malaysia: 'Melayu',
		Machinelearningautomaticclassification: 'Pengkelasan Automatik Pembelajaran Mesin',
		loyalty: 'Kesetiaan',
		lowvalue: 'Harga rendah',
		Lowconsumption: 'Penggunaan rendah',
		long: 'Panjang',
		Logisticstype: 'Jenis logistik',
		Logisticsinformation: 'Maklumat logistik',
		Logistics: 'Logistik',
		Linkcollection: 'Koleksi pautan',
		Limitationofclaims: 'Had tuntutan: Biasanya dalam masa 30 hari, jika anda tidak membuat tuntutan kepada perkhidmatan pelanggan platform selama lebih daripada 30 hari, maka ia akan dianggap sebagai penepian kelayakan tuntutan, dan penjual akhirnya akan kehilangan sejumlah pampasan (contohnya, sehingga 2,000 baht di Thailand)! Jika anda boleh membuat tuntutan kepada platform tepat pada masanya, ia akan segera membantu anda memulihkan kerugian anda dan meningkatkan keuntungan bersih anda serta-merta! ',
		kjbgf: 'Cod tunai untuk pesanan penghantaran di kedai tempatan Sebaik sahaja pembeli menolak pesanan, kebarangkalian kehilangan pakej meningkat, dan sistem secara automatik memantau kehilangan pakej dan kegagalan penghantaran. ',
		Iwanttodistribute: 'Saya mahu mengedarkan',
		Islosinghighprices: 'Sedang kehilangan harga tinggi',
		Islosing: 'Mengalirkan',
		Includequery: 'Mengandungi pertanyaan',
		InClaimOrder: 'Tuntutan - perintah',
		Inboundstatus: 'Status storan',
		Inboundproductdetails: 'Butiran produk masuk',
		Inboundordernumber: 'Nombor pesanan storan',
		Inboundordercreationtime: 'Masa membuat pesanan resit',
		Importproducts: 'Produk import',
		Ihaveacted: 'Saya telah diwakilkan',
		Icansupply: 'Saya boleh bekalkan',
		Highvaluelost: 'Telah kehilangan nilai tinggi',
		highvalue: 'Nilai tinggi',
		Highloyaltyandhighprice: 'Kesetiaan tinggi dan harga tinggi',
		high: 'Tinggi',
		Hideorder: 'Sembunyikan pesanan',
		GroupName: 'Nama kumpulan',
		Groupdescription: 'Penerangan kumpulan',
		Giveaway: 'Hadiah',
		Giftlibrary: 'Perpustakaan hadiah',
		Generatewarehousinglist: 'Jana pesanan storan',
		Generalcargo: 'Kargo am pengangkutan darat',
		Find: 'Cari',
		Filtertoshoworhideorders: 'Tapis untuk menunjukkan atau menyembunyikan pesanan',
		Exportorder: 'Pesanan eksport',
		Exportall: 'Eksport semua',
		Export: 'Eksport',
		Export: 'Eksport ke Excel',
		Expiredate: 'Tarikh luput',
		Expand: 'Kembangkan/Runtuhkan',
		Estimatedtotalvolume: 'Anggaran jumlah volum',
		EstimatedCompensationPoints: 'Anggaran mata pampasan',
		Edittemplate: 'Edit Templat',
		Editname: 'Ubah suai nama',
		edit: 'Edit',
		Distributionwarehousemerchandise: 'Komoditi Gudang Pengedaran',
		Distributionwarehouse: 'Gudang Pengedaran',
		Distributionselectionlibrary: 'Perpustakaan pengedaran',
		Distributionplatform: 'Platform pengedaran',
		description: 'Huraikan',
		Deliverytime: 'Masa keluar',
		Deliveryplace: 'Tempat penghantaran',
		DeliveryMethod: 'Kaedah Penghantaran',
		Deleteselectedproductsinbulk: 'Batch padamkan produk terpilih',
		delete: 'Padam',
		CustomerProfile: 'Kategori',
		Custombuyergrouping: 'Kumpulan pembeli tersuai',
		Currentlyselected: 'Dipilih pada masa ini',
		Currentlyonly: 'Pada masa ini hanya menyokong koleksi produk di platform shopee, sila masukkan pautan halaman butiran produk! ',
		CreatList: '8 rekod',
		Creationtime: 'Masa penciptaan',
		Courierhasbeendelivered: 'Penghantaran ekspres telah dihantar',
		Courierhasbeencollected: 'Kurier telah diterima',
		Couriercollection: 'Bilangan resit dari gudang',
		countryregion: 'Negara / Wilayah',
		container: 'Bekas',
		contactseller: 'Hubungi penjual',
		Confirmthechanges: 'Sahkan perubahan',
		Confirmreceipt: 'Sahkan penerimaan barang',
		Completetime: 'Masa yang lengkap',
		completed: 'Selesai',
		complete: 'Selesai',
		Complaints: 'Tuntutan aduan',
		Complaintorderstobeprocessedbythewarehouse: 'Pesanan aduan akan diproses oleh gudang',
		Compensation: 'Pampasan tiba di akaun: Selepas menyerahkan borang tuntutan perkhidmatan pelanggan platform, kedai Xiaosheng akan menilai secara automatik sama ada pesanan yang anda tuntut telah berjaya diberi pampasan, menjimatkan masa anda untuk menyemak, dan ia jelas sekali imbas. Klik pada bar menu yang sepadan di bawah "Tuntutan untuk disahkan - Pesanan", "Tuntutan - Pesanan", "Tuntutan Berjaya - Pesanan"',
		Commoditystatus: 'Status Komoditi',
		Commoditycollection: 'Koleksi Komoditi',
		Combinatoriallibrary: 'Perpustakaan gabungan',
		Cloudblacklist: 'Senarai hitam awan',
		Claimsuccessfultime: 'Tuntut masa kejayaan',
		ClaimAssistant: 'Pembantu Tuntutan',
		claim: 'Pembantu Tuntutan: Ia adalah fungsi khas yang direka khas oleh Dian Xiaosheng untuk penjual tempatan di Asia Tenggara. Ia boleh membantu penjual untuk mengetahui pesanan yang ditolak oleh COD atau hilang dalam penghantaran ekspres dalam masa, dan memudahkan penjual untuk mengeksport borang, yang boleh digunakan untuk menuntut pampasan daripada platform',
		Churn: 'Telah hilang',
		Chooseawarehouse: 'Pilih gudang',
		Chooseastore: 'Pilih kedai',
		checkorder: 'Semak pesanan',
		Checkcompleted: 'Semakan selesai',
		Changethetime: 'Tukar masa',
		CaringSMS: 'Penutupan',
		Cancelorder: 'Batalkan pesanan',
		Canceldetails: 'Batalkan butiran',
		Buyersname: 'Nama pembeli',
		Buyerpurchasequantity: 'Kuantiti pembelian pembeli',
		Buyermessage: 'Mesej pembeli',
		Buyerhasconfirmed: 'Pembeli disahkan',
		box: 'Kotak',
		blacklist: 'Senarai hitam',
		Bindingtime: 'Masa mengikat',
		Batchsettingofflags: 'Tanda tetapan kelompok',
		Batchoperation: 'Operasi kelompok',
		Batchexportorders: 'Pesanan eksport kelompok',
		Batchexportoforders: 'Pesanan kumpulan eksport',
		Barcode: 'Kod Bar',
		Averageconsumptiontimeinterval: 'Purata selang penggunaan',
		AuthorizeShop: 'Lihat butiran potongan mata',
		Audited: 'Diaudit',
		Applicationforcancellation: 'Borang pembatalan permohonan',
		Amount: 'Jumlah',
		Allsubskusinstorage: 'Masukkan semua sub-sku',
		Allsites: 'Semua tapak',
		Allsellers: 'Semua penjual',
		Allorders: 'Semua pesanan',
		AllLists: 'Kos kepala',
		Allcountries: 'Semua negara',
		All: 'Semua',
		agree: 'Setuju',
		Afterrecharging: 'Selepas mengecas semula, anda boleh segera menggunakan fungsi seperti storan awan luar negara, storan produk ujian dan storan peribadi',
		Addnotes: 'Tambah nota',
		Additnow: 'Tambahkannya sekarang',
		Addcustomgroup: 'Tambah kumpulan tersuai',
		Actualquantity: 'Kuantiti ketibaan sebenar',
		Actualpickingquantity: 'Kuantiti pemilihan sebenar',
		Actualarrivalquantityinwarehouse: 'Kuantiti ketibaan sebenar gudang',
		Activityprice: 'Harga aktiviti',
		Activityid: 'Id aktiviti',
		invitecashback: 'Jemputan ada hadiah',

		pointdetails: 'Lihat butiran potongan mata',
		Sellersname: 'Nama Penjual',
		SellersAccount: 'Akaun Penjual',
		boundtime: 'Masa mengikat',
		Sellersname: 'Nama Penjual',
		orderSearch: 'Pencarian nombor pesanan/nombor bil laluan',
		orthersSearch: 'Cari nama komoditi, sku komoditi, kedudukan',
		syncSingleOrder: 'Segerakkan nombor pesanan tunggal',
		urgent: 'Peringatan pengguna',
		checkTime: 'Semak masa',
		orderPrinted: 'Cetak tunggal',
		hasPrint: 'Dicetak, muat semula halaman semasa',
		returnReason: 'Isikan sebab semakan pemulangan',
		jkf: 'Kembali segera',
		scanArea: 'Nombor pesanan atau kawasan pengimbasan nombor bil laluan',
		scanProduct: 'Kawasan pengimbasan kod bar produk',
		returnReview: 'Kembali ke ulasan',
		resetorder: 'Tetapkan semula pesanan',
		resetPickingNum: 'Tetapkan semula kuantiti pemilihan',
		checkDone: 'Semakan selesai',
		purcahseNum: 'Kuantiti pembelian',
		singleOrSetmeal: 'Produk atau pakej tunggal',
		cusCode: 'CUSCODE/Barcode',
		sku: 'SKU',
		pickingNum: 'Memilih Kuantiti',
		retrunDesc: 'Alasan pemulangan untuk semakan diperlukan! ',
		nodata: 'Tiada data pesanan! ',
		descPicktip: 'Sila sahkan sama ada pengesahan pembungkusan kuantiti telah selesai? ',
		outProduct: 'Keluar segera',
		yes: 'Ya',
		cancel: 'Batal',
		noorderdata: 'Tiada data pesanan! ',
		comfirmCheck: 'Sila sahkan sama ada pengesahan pembungkusan kuantiti telah selesai? ',
		fkuvkf: 'Keluar segera',
		kvjjkf: 'Elesai',
		kvjfk: 'Checkout',
		vkjfhbvm: 'Sila imbas nombor pesanan dahulu! ',
		fikvnf: 'Kuantiti yang dipilih adalah sama dengan kuantiti yang dibeli oleh pembeli! ',
		vkhlf: 'Semakan selesai',
		systemNoorder: 'Sistem pada masa ini tidak mempunyai maklumat tentang pesanan ini, sila imbas nombor pesanan yang betul! ',



	},


	home: {
		title: 'Stor/Gudang - Gambaran Keseluruhan',
		allproduct: 'semua produk',
		inproduct: 'Barang dalam stok',
		allshop: 'Semua Kedai - Pesanan',
		sale: 'pendapatan penjual',
		quantity: 'Jumlah Jualan',
		grossprofit: 'untung kasar',
		grossmargin: 'margin untung kasar',
		allstorehuozhi: 'Semua Gudang - Nilai Tempat',
		houzhi: 'Nilai',
		shipingcost: 'Kos pengangkutan',
		allshopsales: 'Status kedai/kedai-jualan',
		allstoresales: 'Status jualan gudang/gudang',
		shopname: 'Nama kedai',
		shopsales: 'jualan',
		shopquantity: 'Jumlah Jualan',
		cost: 'Anggaran kos',
		avg: 'Jualan/hari (AVG)',
		operate: 'Beroperasi',
		linepic: 'Ikon putuskan sambungan',
		tipdialog: 'Gambar rajah jahitan jualan kedai',
		close: 'Penutupan',
		storename: 'Nama gudang',
		tip1: '(Ditolak: yuran penghantaran sebenar, anggaran yuran penghantaran, yuran transaksi platform)',
		tip2: 'Sudah ditolak: kos pembelian, pengangkutan kepala',
		tip3: 'Termasuk yuran pembelian tempat gudang sahaja',
		tip4: 'Anggaran kos = kos pembelian + pengangkutan kepala + yuran transaksi platform',
		secondPwsTip: 'Melibatkan privasi kewangan, sila masukkan kata laluan kedua',
		secondPws_Two: 'Baru didaftarkan lalai',
		secondChange: 'Klik untuk mengubah suai kata laluan kedua',
		secondPwsInput: 'Sila isikan kata laluan',
		confirm: 'Pasti'


	},
	header: {
		title: 'Sistem pengurusan rentas sempadan Dian Xiaosheng',
		huanyinru: 'Selamat Datang'
	},
	login: {
		system: 'Pusat Log Masuk',
		tip: 'Penghantar barang Asia Tenggara yang boleh meningkatkan keuntungan bersih anda',
		account: 'Masukkan akaun e-mel',
		passsword: 'Masukkan kata laluan',
		remember_password: 'Ingat kata laluan',
		login: 'Log masuk',
		desc: 'Dianxiaosheng-Fokus untuk melayani penjual tempatan Shopee/Lazada',
		desc1: 'Fokus pada perkhidmatan maya di Asia Tenggara / dropshipping gudang awan',
		desc2: 'Docking ERP yang dibangunkan sendiri dengan Shopee/Lazada untuk mengurus inventori yang tepat',
		desc3: 'Sediakan penyelesaian pertikaian perkhidmatan pelanggan tempatan, susulan semakan negatif',
		desc4: 'Ramalan perolehan pintar data besar',
		desc5: 'Ada banyak pulangan, tingkatkan keuntungan bersih anda',
		th: 'Thailand',
		my: 'Melayu',
		ph: 'Filipina',
		tw: 'Taiwan',
		sg: 'Singapura',
		vn: 'Vietnam',
		id: 'Indonesia',
		forget: 'lupa kata laluan',
		registor: 'Klik untuk mendaftar'
	},
	registor: {
		center: 'Pendaftaran (Penjual)',
		mail: 'Isikan e-mel',
		nickname: 'Nama Panggilan Penjual',
		passsword: 'Kata laluan penjual mestilah sekurang-kurangnya 6 aksara, gabungan huruf, nombor dan aksara',
		confirm_pws: 'Sahkan Kata Laluan',
		phone: 'Untuk pemberitahuan penting atau kenalan kecemasan',
		verification: 'Kod pengesahan e-mel',
		getCode: 'Dapatkan e-mel',
		register: 'Mendaftar',
		log: 'Klik di sini untuk melompat ke halaman log masuk',
		invitationCode: 'Jika tiada kod jemputan, anda boleh biarkan kosong'
	},
	aside: {
		home: 'Muka depan',
		invitecashback: 'Jemputan dengan hadiah',
		mysharePage: 'Jemput berkongsi halaman',
		myshareLink: 'Pautan jemputan eksklusif',
		dianpusouquan: ' Kebenaran kedai',
		wodedingdang: ' Arahan saya',
		allOrder: 'Semua pesanan',
		sellerManagement: ' Pengurusan Penjual',
		zhuanchuandan: ' Pemindahan gudang',
		shenghedang: 'Menunggu pesanan',
		chulidang: 'Menunggu pesanan',
		yifahuodingdang: 'Pesanan Diterima',
		wentidang: 'Lembaran soalan',
		zhenzifuwu: 'Perkhidmatan nilai tambah',
		xiangshangchanpin: '  Pengurusan gudang',
		shengchengchangkuchanpin: 'Produk import',
		changkunchanpin: 'Produk gudang',
		quanbuzhachanshanpin: 'Semua produk dalam stok',
		rukuguangli: ' Pembelian dan pergudangan',
		kuchuguanli: ' Pengurusan inventori',
		distribution: 'Platform pengedaran',
		localGoods: 'Sumber tempatan',
		mygoods: 'Bekalan saya',
		hasAgent: 'Saya telah diwakili',
		prductDev: 'Pembangunan produk',
		collectGoods: 'Koleksi produk',
		ProductPending: 'Produk belum selesai',
		productMGM: 'Pengurusan produk',
		godownentry: 'Pengurusan storan',
		processed: 'Pesanan diproses',
		recharge: 'Isi semula sekarang',
		yunweiguanli: 'Pengurusan Operasi',
		discountProducts: 'Produk diskaun',
		claimAssistant: 'Pembantu Tuntutan',
		Management: 'Pengurusan Operasi',
		purchaseMGM: 'Pengurusan Pembelian',
		transformStore: 'Pemindahan gudang',
		rollover: 'Pemindahan gudang',
		Performance_ranking: 'Kedudukan Prestasi Pasukan',
		Monitoring_Price: 'Bidaan pemantauan pintar',
		Customer_Service: 'Sembang Shopee',
		Customer_Profile: 'Potret pembeli',
		SmartChat: 'Sembang Shopee',
		CaringSMS: 'SMS penjagaan',
		Returned: 'Pengurusan Pemulangan',
		CreatList: 'Cipta storan',
		AllLists: 'Storan dalam transit',
		fenjianhedui: 'Pemeriksaan isihan',
		daibaochuku: 'Pakej keluar dari perpustakaan',
		tuhuanguanli: 'Pengurusan pemulangan',
		Relevantquotation: 'Tawaran berkaitan',
		ScanPrint: 'Imbasan Cetakan',

	},

	shopaccess: {
		diangpusouquan: 'Keizinan Kedai',
		bindshop: 'Kedai shopee yang sah',
		bindshop_LAZADA: 'Kedai LAZADA yang sah',
		shopify: 'Benarkan kedai shopify',
		bindstore: 'Ikat gudang',
		shopId: 'ID kedai',
		shopName: 'Nama kedai',
		shopSite: 'Tapak kedai',
		shopStatus: 'Negeri',
		accessTime: 'Masa kebenaran',
		Expiredate: 'Tarikh luput',
		operate: 'Beroperasi',
		storeID: 'ID Gudang',
		userId: 'ID Pengguna',
		userName: 'Nama pengguna',
		storeName: 'Nama gudang',
		createTime: 'Masa penciptaan',
		storeAdresse: 'Lokasi gudang',
		Untie: 'Buka ikatan kedai',
		UniteStore: 'Buka ikatan gudang',
		UniteStoreSuccess: 'Berjaya membuka ikatan gudang! ',
		UniteShopSuccess: 'Berjaya membuka ikatan kedai! ',
		selectStore: 'Sila pilih gudang untuk dijilid',
		cancel: 'Batal',
		comfirm: 'Pasti',
		bangdinSuccess: 'Ikat gudang dengan jayanya! ',
		enterStoreinfo: 'Sila masukkan maklumat gudang baharu',
		enterUserName: 'Sila masukkan nama pengguna',
		enterStoreName: 'Sila masukkan nama gudang',
		selected: 'Sila pilih negara',
		xinjian: 'Buat sub-gudang baharu',
		lazada_shortCode: 'ID Penjual',
		lazada_account: 'Pengguna akaun',
		lazada_name: 'Nama kedai',
		lazada_location: 'Lokasi',

	},
	pendingorder: {
		title: 'Menunggu pesanan',
		search: 'Cari',
		allcurrentpage: 'Pilih semua halaman semasa',
		Mass_review_orders: 'Pesanan semakan pukal',
		synchronize: 'Segerakkan status pesanan',
		last_3_days: '3 hari lepas',
		last_7_days: '7 hari lepas',
		last_1_month: 'Bulan lepas',
		last_3_month: '3 bulan lepas',
		orderSn: 'Nombor pesanan',
		status: 'Status pesanan',
		paytime: 'Masa pembayaran',
		delivery_time: 'Penghantaran lebih masa baki masa',
		sku: 'SKU',
		quantity: 'Kuantiti',
		shopName: 'Nama kedai',
		shopid: 'StoreId',
		recipient: 'Penerima',
		phone: 'Telefon',
		methods: 'Kaedah Penghantaran',
		actually_paid: 'Sebenarnya dibayar',
		waybill_number: 'Nombor bil laluan',
		review: 'Semak pesanan',
		search_tip: 'Sila masukkan nombor pesanan',
		nodata: 'Belum ada pesanan lagi',
		orderstotal: 'Pesanan',
		select: "Sila pilih gudang penghantaran",
		cancel: "Batal",
		confirm: 'Mengesahkan',
		UNAUDIT: "Semakan belum selesai",
		cash_on_delivery: 'Tunai semasa penghantaran',
		pending_upgrade: 'Menunggu naik taraf',
		notgenerated: "Tidak dijana",
		synchronized: "Pesanan telah disegerakkan ke status terkini, sila muat semula halaman selepas beberapa ketika! ",
		Successful_review: "Audit berjaya! ",
		day: 'Langit',
		hours: 'Jam',
		min: 'Titik',
		time_order: 'Pesanan masa pesanan',
		Positive: 'Masa pembayaran pesanan - dari pagi hingga malam',
		Reverse: 'Masa pembayaran pesanan - dari lewat hingga awal',
		Positive01: "Baki masa penghantaran - daripada lebih kepada kurang",
		Reverse01: 'Baki masa penghantaran - daripada kurang kepada lebih',
		auto_distribute: 'Semak pesanan secara automatik',
		Inventory: 'Inventori',
		In_warehouse: 'Dalam bin',
		committed: 'Bersedia untuk pergi',
		on_line: 'Dalam talian',
		Turn_on: 'Hidupkan/matikan fungsi semakan automatik pesanan',
		Store_Name: 'Nama kedai',
		warehouse: 'Gudang',
		un_include: 'Sama ada untuk mengecualikan pesanan kehabisan stok',
		yes: 'Ya',
		no: 'Tidak',
		auto_distribute: 'Semak pesanan secara automatik',
		open: 'Buka',
		Turned_on: 'Terangsang',
		shut_down: 'Penutupan',
		confirm: 'Mengesahkan',
		oop: 'Antara pesanan yang anda pilih, selepas menapis mengikut kuantiti inventori sebenar di gudang dan kesegeraan sehingga tarikh penghantaran:',
		llo: 'Pesanan segera yang boleh diluluskan',
		ggo: 'Nombor pesanan',
		prick: 'Jumlah',
		hho: 'Tarikh Akhir Penghantaran',
		pkl: 'Cadangan untuk pesanan kehabisan stok tidak diluluskan',
		cancel: 'Batal',
		uuo: 'Hanya dengan pesanan segera',
		iio: 'Teruskan sepanjang',
		addpackingfee: 'Sama ada untuk menampal bil',
		cancelTime: 'Batalkan masa',
		paydelivery: 'Tunai semasa penghantaran',



	},

	storePending: {
		Form: 'Jenis platform',
		UserName: 'Penjual memilih',
		shoptype: 'Pemilihan kedai',
		Warehouse_type: 'Jenis gudang',
		Loading_status: 'Keadaan memuatkan',
		Printstatus: 'Status cetakan',
		LogisticsType: 'Jenis logistik',
		orderMakr: 'Tanda pesanan',
		lastDeliveryTime: 'Penghantaran Terakhir',
		orderStatus: 'Status pesanan',
		exwarehouse: 'Sama ada di luar gudang',
		orderInclude: 'Perintah itu mengandungi',
		all: 'Semua',
		singlesku: 'Sku bujang',
		multiplesku: 'Berbilang sku',
		shipped: 'Dihantar',
		tobeshipped: 'Untuk dihantar',
		yes: 'Stok habis',
		notYet: 'Tidak dilepaskan',
		printed: 'Dicetak',
		notprinted: 'Tidak dicetak',
		notgenerated: "Tidak dijana",
		Generated: 'Dihasilkan',
		loading: 'Sedang menjana',
		massArrangeShipment: 'Hasilkan nombor bil laluan',
		drop_off: 'Turunkan menjana',
		pick_up: 'Angkat menjana',
		massprint: 'Senarai pengedaran cetakan kelompok',
		PrintPacklist: 'Senarai pilihan dicetak secara lalai',
		PrintPicklist: 'Cetak senarai pengedaran kelompok dengan cepat',
		MassPrintShipingLabel: 'Borang ekspres cetakan kelompok',
		PrintShipingLabel: 'Secara lalai, cetak helaian muka',
		ShipingLabel_Packlist: 'Cetak helaian muka & senarai pilihan dengan cepat',
		ReturnBacktoUser: 'Kembali ke ulasan',
		SynchronizeOrder: 'Segerakkan pesanan',
		desc: 'Pengedaran pertama, kemudian pengisihan, boleh mengurangkan kadar ralat (pembenihan WMS)',
		fisrtStep: 'Langkah 1: Hasilkan nombor bil laluan',
		secondStep: 'Langkah 2: Cetak senarai pengedaran dengan cepat',
		threeStep: 'Langkah 3: Cetak helaian muka + senarai pilihan dengan cepat',
		fourStep: 'Langkah 4: Pemeriksaan & Penghantaran',
		firstDesc: 'Pilih Ambil untuk penghantaran dari pintu ke pintu dengan penghantaran ekspres, dan Hantar OFF untuk penghantaran ke cawangan',
		secondDesc: 'Cetak senarai pengedaran kumpulan ini, mula-mula pilih jumlah dari gudang',
		threeDesc: 'Gunakan senarai permukaan cetakan pantas + senarai pilihan untuk meningkatkan kelajuan pencetakan ',
		fourDesc: 'Menggunakan pengisihan, pemeriksaan dan pembungkusan keluar dari gudang, proses itu boleh diuraikan dan kecekapan boleh dipertingkatkan ',
		Inventory: 'Adakah ia kehabisan stok',
		Enough: 'Inventori yang mencukupi',
		noEnough: 'Kekurangan inventori',
		pushTime: 'Tolak masa',
		tenBefore: 'Sebelum jam 10:00 hari itu',
		tenAfter: 'Selepas jam 10:00 hari itu',
		specialOrder: 'Adakah ia bungkusan kosong',
		norMall: 'Pakej tidak kosong',
		enptry: 'Bungkusan kosong'

	},

	unprocessedorder: {
		title: 'Menunggu pesanan',
		search: 'Cari',
		allcurrentpage: 'Pilih semua halaman semasa',
		Mass_review_orders: 'Pesanan semakan pukal',
		synchronize: 'Segerakkan status pesanan',
		last_3_days: '3 hari lepas',
		last_7_days: '7 hari lepas',
		last_1_month: 'Bulan lepas',
		orderSn: 'Nombor pesanan',
		status: 'Status pesanan',
		paytime: 'Masa pembayaran',
		delivery_time: 'Baki masa penghantaran lebih masa',
		sku: 'SKU',
		quantity: 'Kuantiti',
		shopName: 'Nama kedai',
		shopid: 'StoreId',
		recipient: 'Penerima',
		phone: 'Telefon',
		methods: 'Kaedah Penghantaran',
		actually_paid: 'Sebenarnya dibayar',
		waybill_number: 'Nombor bil laluan',
		review: 'Semak pesanan',
		search_tip: 'Sila masukkan nombor pesanan',
		nodata: 'Belum ada pesanan lagi',
		orderstotal: 'Pesanan',
		select: "Sila pilih gudang penghantaran",
		cancel: "Batal",
		confirm: 'Mengesahkan',
		UNAUDIT: "Semakan belum selesai",
		cash_on_delivery: 'Tunai semasa penghantaran',
		pending_upgrade: 'Menunggu naik taraf',
		notgenerated: "Tidak dijana",
		Mass_generate_waybill_number: "Hasilkan nombor bil laluan dalam kelompok",
		Mass_print_orders: "Pesanan cetakan berkelompok",
		Mass_print_picking_list: "Senarai Pilihan Cetak Berkelompok",
		pick_off: "Angkat dijana",
		drop_off: "Generasi drop off",
		allshops: 'Semua kedai',
		allorders: 'Semua pesanan',
		tobegenerated: 'Untuk dijana',
		tobeprinted: 'Untuk dicetak',
		Defaultprint: 'Cetakan lalai',
		fastprint: 'Cetakan cepat',
		viewhistory: 'Lihat rekod cetakan sejarah',
		logistic: 'Semua Logistik',
		printed: "Dicetak",
		printed_time: 'Masa Cetak',
		print_order: 'pesanan cetakan',
		print_picking_list: 'Cetak senarai pilihan',
		delivery_store: 'Gudang Penghantaran',
		todelivered: 'Untuk dihantar',
		all_store: 'Semua gudang',
		pingliancancelreview: 'Semakan pulangan kumpulan ',
		cancelreivew: 'Pesanan berjaya ditetapkan semula kepada semakan belum selesai!',
		initTrickingNo: {
			createNO: 'Menjana nombor bil laluan',
			main: 'Imej utama',
			ordersn: 'Nombor pesanan',
			trickingNo: 'Nombor bil laluan',
			ttp01: 'Selesai',
			ttp02: 'Pesanan',
			ttp03: 'Pesanan cetakan'

		},
		pingliandayin: 'Sila pilih pesanan!',
		pingliandayin01: 'Sila pilih pesanan dari kedai yang sama untuk dicetak!',
		haimeishenchendingdang: 'Sila jana nombor bil laluan dan cetak sekali lagi!',
		searchContent: 'Masukkan kandungan carian',
		Export: 'Eksport xlsx',
		fenle: 'Cari pesanan mengikut produk'

	},
	shippedorder: {
		title: 'Pesanan dihantar',
		search: 'Cari',
		allcurrentpage: 'Pilih semua halaman semasa',
		Mass_review_orders: 'Pesanan semakan kelompok',
		synchronize: 'Segerakkan status pesanan',
		last_3_days: '3 hari lepas',
		last_7_days: '7 hari lepas',
		last_1_month: 'Bulan lepas',
		orderSn: 'Nombor Pesanan',
		status: 'Status pesanan',
		paytime: 'Masa pembayaran',
		delivery_time: 'Baki masa penghantaran',
		sku: 'SKU',
		all_store: 'Semua gudang',
		quantity: 'Kuantiti',
		shopName: 'Nama kedai',
		shopid: 'StoreId',
		recipient: 'Penerima',
		phone: 'Telefon',
		methods: 'Kaedah Penghantaran',
		actually_paid: 'Sebenarnya dibayar',
		waybill_number: 'Nombor bil laluan',
		review: 'Semak pesanan',
		search_tip: 'Sila masukkan nombor pesanan',
		nodata: 'Belum ada pesanan lagi',
		orderstotal: 'pesanan',
		select: "Sila pilih gudang penghantaran",
		cancel: "Batal",
		confirm: 'Mengesahkan',
		UNAUDIT: "Semakan belum selesai",
		cash_on_delivery: 'Tunai semasa penghantaran',
		pending_upgrade: 'Menunggu naik taraf',
		notgenerated: "Tidak dijana",
		Mass_generate_waybill_number: "Hasilkan nombor bil laluan dalam kelompok",
		Mass_print_orders: "Pesanan cetakan berkelompok",
		Mass_print_picking_list: "Senarai pemilihan cetakan kelompok",
		pick_off: "Pilih generasi",
		drop_off: "Generasi drop off",
		allshops: 'Semua kedai',
		allorders: 'Semua pesanan',
		shipped: 'Dihantar',
		pending_receipt: 'Ketibaan untuk disahkan',
		confirm_receipt: "Selesai disahkan",
		printed_time: 'Masa Cetak',
		print_order: 'pesanan cetakan',
		print_picking_list: 'Cetak senarai pilihan',
		delivery_store: 'Gudang Penghantaran',
		todelivered: 'Untuk dihantar',
		view_logistics: "Semak logistik"




	},
	problemorder: {
		title: 'Urutan masalah',
		tap_tuhuoguanli: 'Pengurusan Pemulangan',
		tap_tuhuobaoguo: 'Pakej pemulangan gudang',
		tap_maijiaqueren: 'Penjual telah mengesahkan',
		tap_audited: 'Telah di proses',
		tap_canceled: 'Pesanan telah dibatalkan',
		tap_return: 'Kembalikan pesanan',
		tap_in_cancel: 'Permohonan untuk membatalkan pesanan',
		tap_in_cancel01: 'Memohon',
		tap_alerdy_return: 'Pemulangan diterima',
		tap_cancel_return: 'Batalkan pemulangan',
		tap_in_return: 'Memulangkan barang',
		tap_dispute: 'Pertikaian Penjual',
		tap_ruling: 'Memerintah',
		tap_returned_money: 'Dikembalikan',
		tap_close: 'Ditutup',
		tap_return_bysellser: 'Penjual Mengesahkan Pemulangan',
		tap_seller_comfirm: 'Penjual telah mengesahkan',
		tap_processed: 'Telah di proses',
		tap_delivery_failed: 'Penghantaran gagal',
		tap_courier_loss: 'Ekspres bungkusan hilang',
		tap_delivery_timeout: 'Penghantaran tamat masa',
		tap_pay_timeout: 'Pembayaran tamat masa',
		tap_seller_cancel: 'Pembeli dibatalkan',
		tap_others: 'Lain',
		tap_ordered: 'Gudang telah membuat pesanan (tidak boleh dibatalkan)',
		tap_nerver_order: 'Gudang belum mencetak pesanan (boleh dibatalkan)',
		nodata: 'Belum ada pesanan lagi',
		return_trickNO: 'Nombor penghantaran pemulangan',
		original_order: 'Nombor pesanan asal',
		return_order: 'Kembalikan nombor pesanan',
		order_status: 'Status pesanan',
		cancel_time: 'Batalkan masa',
		print_time: 'Masa Cetak',
		quantity: 'Kuantiti',
		return_quantity: 'Kuantiti Pulangan',
		cancel_reason: 'Sebab Pembatalan',
		shop: 'Kedai',
		receipent: 'Penerima',
		phone: 'Telefon',
		return_reason: 'Alasan untuk kembali',
		seller_name: 'Nama Panggilan Pembeli',
		seller_Email: 'Pembeli Eamil',
		deliver_store: 'Gudang Penghantaran',
		delivery_method: 'Kaedah Penghantaran',
		actuall_pay: 'Sebenarnya dibayar',
		trickNO: 'Nombor bil laluan',
		return_count: 'Jumlah pulangan',
		origin_prick: 'Harga tempahan sebelum diskaun',
		buyer_delivery_deadline: 'Tarikh Akhir Penghantaran Pembeli',
		seller_processing_return_due: 'Penjual adalah kerana proses pemulangan',
		view_logistics: "Semak logistik",
		return_package: 'Kembalikan foto',
		confirmed_by_seller: 'Penyenaraian atau pemusnahan sekunder',
		be_processed_by_store: 'Untuk diproses oleh gudang',
		search_tip: 'Nombor pesanan pertanyaan',
		search: 'Cari',
		no: 'Tidak',
		price: 'Harga'

	},
	mygoods: {
		allShop: 'Semua Kedai',
		ppo: 'Rekod',
		search: 'Cari',
		search_tip: 'Nama produk yang boleh dicari, sku',
		synchronize: 'Segerakkan produk shopee',
		Generate_warehouse_items: 'Import produk gudang',
		itemID: 'ID Komoditi',
		shop: 'Kedai',
		price: 'Harga',
		stock: 'Dalam stok',
		cusCode: 'Kod gudang',
		sales: 'Jumlah jualan',
		status: 'Negeri',
		update: 'Masa kemas kini',
		sku: 'Sku',
		Whether_to_booking: 'Sama ada untuk pra-menjual',
		yes: 'Ya',
		no: 'Tidak',
		more: 'Lagi',
		viewOrder: 'Lihat pesanan produk',
		viewSales: 'Lihat jualan',
		generated: 'Produk gudang telah diimport',
		isTarget: 'Produk telah dipilih',
		vieworder: 'Lihat pesanan produk',
		viewsales: 'Lihat jualan',

		qingdang: {
			title: "Senarai produk",
			Img: 'Gambar',
			name: 'Nama Produk',
			cost: 'Harga kos',
			operate: 'Beroperasi',
			dele: 'Padam',
			store: 'Menerima Gudang',
			qingkong: 'Kosong',
			submit: 'Menyerahkan',
			choose: 'Pilih gudang...'
		},
		details: {
			title: "Butiran Senarai Gudang",
			Img: 'Gambar',
			name: 'Nama Produk',
			SKU: 'SKU',
			cusCode: 'CusCode',
			ok: 'Pasti',
			success: 'Berjaya masuk ke dalam gudang',
			fail: 'Kemasukan gagal (sudah di gudang)',
		}
	},

	binditems: {
		allShop: 'Semua Kedai',
		ppo: 'Rekod',
		search: 'Cari',
		search_tip: 'Masukkan nama produk untuk dicari',
		Generate_warehouse_items: 'Pengikat pelbagai komoditi',
		itemID: 'ID Komoditi',
		shop: 'Kedai',
		price: 'Harga',
		stock: 'Dalam stok',
		cusCode: 'Kod gudang',
		sales: 'Jumlah jualan',
		satus: 'Negeri',
		update: 'Masa kemas kini',
		sku: 'Sku',
		generated: 'Terikat',
		bind: 'Mengikat',
		jieban: 'Buka ikatan',
		isTarget: 'Dipilih',
		bindDetexl: {
			title: "Pengikatan pelbagai komoditi",
			tip: 'Sila masukkan kod komoditi',
			search: 'Cari',
			Img: 'Gambar',
			shopId: 'StoreId',
			name: 'Nama Produk',
			SKU: 'Sku',
			dele: 'Padam',
			operate: 'Beroperasi',
			qingkong: 'Kosong',
			submit: 'Menyerahkan',
			cusCode: 'Kod gudang',
			store: 'Gudang'
		},
		details: {
			title: "Keadaan yang mengikat",
			Img: 'Gambar',
			name: 'Nama Produk',
			SKU: 'SKU',
			cusCode: 'Kod gudang',
			ok: 'Pasti',
			success: 'Pengikatan berjaya',
			fail: 'Pengikatan gagal (komoditi sudah terikat)',
		}
	},
	userStoreItems: {
		ok: 'Saya faham',
		Prompt: 'Petunjuk',
		ppo: 'Rekod',
		search: 'Cari',
		search_tip: 'Boleh mencari kod gudang, sku, nama komoditi, kod bar produk',
		synchronize: 'Segerakkan kuantiti yang akan dihantar',
		Generate_warehouse_items: 'Jana pesanan storan',
		stock_suggestion: 'Nasihat Pembelian',
		allcurrentpage: 'Pilih semua halaman semasa',
		mass_open_updata_stock: 'Dayakan kemas kini automatik dalam kelompok dalam gudang',
		mass_close_updata_stock: 'Kemas kini automatik tutup kumpulan di gudang',
		kki: 'Inventori dalam talian bagi produk yang dibundel akan sentiasa dikemas kini kepada inventori sebenar di gudang (kecuali produk pra-jualan). ',
		shop: 'Kedai',
		userName: 'Nama pengguna',
		warehouse: 'Gudang',
		cost: 'Harga kos',
		cusCode: 'Kod gudang',
		online_stock: 'Inventori dalam talian',
		shipping_stock: 'Semua penghantaran yang belum selesai',
		total_stock: 'Simpan di gudang',
		auto_update: 'Kemas kini automatik disimpan dalam gudang',
		create_ruku: 'Cipta storan',
		selected: 'Dipilih',
		edit: 'Edit',
		nodata: 'Tiada produk lagi',
		all: 'Semua gudang',
		confirmBtn: 'Mengesahkan',
		binditems: 'Ikat sub SKU ini',
		caigoudangtip: 'Pesanan belian telah berjaya dibuat, dan nombor pesanan pembelian adalah',
		delet: 'Padam',
		on: 'Buka',
		off: 'Dekat',
		caigou: {
			title: "Pesanan Belian",
			Img: 'Gambar',
			name: 'Nama Produk',
			caigouqunatity: 'Kuantiti beli',
			anthreName: 'Alias komoditi',
			operate: 'Beroperasi',
			dele: 'Padam',
			tip: 'Sila masukkan nota ke gudang',
			qingkong: 'Kosong',
			submit: 'Menyerahkan',
		},
		bindItem: {
			title: 'Ikat maklumat komoditi',
			xinzhen: 'Tambah produk terikat baharu',
			anthreName: 'Nama Produk',
			operate: 'Beroperasi',
			shopName: 'Nama kedai',
			jieban: 'Buka ikatan',
			tip: 'Produk gudang perlu terikat kepada sekurang-kurangnya satu produk dalam talian, jika anda tidak memerlukan produk ini, anda boleh memadam terus produk di gudang',
			jiebansuccess: 'Lepas ikatan berjaya'
		},
		update: {
			tip: 'Peringatan Kemas Kini Inventori',
			open: 'Lupakan, ia masih hidup',
			close: 'Penutupan',
			close01: 'Lupakan, jangan buka',
			open01: 'Faham, masih hidup',
			text01: 'Apabila kemas kini automatik inventori dalam gudang didayakan, inventori shopee semua produk yang terikat pada produk gudang akan disegerakkan secara automatik kepada baki inventori sebenar produk gudang. Sila sahkan sama ada untuk mendayakannya? ',
			text02: 'Sila pilih item yang perlu mematikan kemas kini inventori automatik! ',
			text03: 'Apabila kemas kini automatik inventori dalam gudang dimatikan, inventori produk gudang tidak akan menjejaskan inventori shopee semua produk terikat. Sila sahkan sama ada untuk mendayakannya? ',
			text04: 'Sila pilih produk yang perlu mendayakan kemas kini inventori automatik! ',
			text05: 'Apabila kemas kini automatik inventori dalam gudang didayakan, inventori shopee semua produk yang terikat pada produk gudang akan disegerakkan secara automatik kepada baki inventori sebenar produk gudang:',
			text06: ', Sila sahkan sama ada untuk membuka? ',
			text07: 'Apabila kemas kini automatik inventori dalam gudang dimatikan, inventori produk gudang tidak akan menjejaskan inventori shopee semua produk terikat. Sila sahkan sama ada untuk mendayakannya? '
		},
		Quantitytobeshipped: 'Diluluskan untuk penghantaran',
		long: 'Panjang',
		width: 'Lebar',
		height: 'Tinggi',
		weight: 'Berat',
		more: 'Lebih banyak operasi',
		vieworder: 'Lihat pesanan produk',
		viewsales: 'Lihat jualan',
		viewstockstore: 'Lihat log inventori',
		del: 'Padam',
		quehuo: 'Peringatan kehabisan stok'


	},

	complaint: {
		complaintReasonTip1: "Sila isikan sebab rayuan",
		complaintReasonTip2: "Sila isikan sebab aduan penjual (diperlukan)",
		cancel: "Batal",
		determine: "Pasti",
		close: "",
		complaintDetailTip: "Butiran Aduan",
		sellerLeaveMessage: "Mesej penjual",
		sellerLeaveMessageTip: "Sila isikan mesej penjual (diperlukan)",
		WarehouseLeaveMessage: "Mesej Gudang",
		WarehouseLeaveMessageTip: "Sila isikan mesej gudang (diperlukan)",
		PlatformLeaveMessage: "Mesej platform",
		PlatformLeaveMessageTip: "Sila isi mesej platform (diperlukan)",
		overseasWarehouseComplaints: "Pusat Aduan Gudang Luar Negara",
		orderQuery: "Carian Pesanan",
		orderQueryTip: "Masukkan nombor pesanan untuk mencari",
		query: "Cari",

		wareHouseHaveEx: "Semua pesanan telah dihantar dari gudang",
		sellerComplaint: "Penjual mengadu tentang pesanan",

		haveFinish: "Selesai",
		orderId: "Nombor pesanan",
		orderStatus: "Status pesanan",
		orderPaid: "Pesanan dibayar",
		warehouseHaveCompensation: "Gudang telah dibayar",
		specificationName: "Nama spesifikasi",
		number: "Kuantiti",
		orderTime: "Masa pesanan",
		payTime: "Masa pembayaran",
		printTime: "Masa Cetak",
		warehouseExTime: "Masa berlepas",
		deliveryTime: "Masa penghantaran",
		storeName: "Nama kedai",
		deliveryMethod: "Kaedah Penghantaran",
		WaybillNum: "Nombor bil laluan",
		PlatformType: "Jenis platform",
		sellerLeaveMessage: "Mesej penjual",
		complaintCompensate: "Tuntutan Aduan",
		waitWarehouseConfirm: "Untuk disahkan oleh gudang",
		waitPlatformType: "Untuk diproses oleh platform",
		haveCompensation: "Dibayar",
		integral: "Integral",
		viewDetail: "Semak butiran",
		confirmTip: "Pesanan telah memulakan aduan dan tuntutan kepada gudang, menunggu gudang memproses! ",

	},
	sellerpurchase: {
		All_warehouses: 'Semua gudang',
		All_inbound_orders: 'Semua pesanan storan',
		Warehousing: 'Cari nombor pesanan storan',
		Find: 'Cari',
		Create_warehouse_receipt: 'Buat pesanan storan',
		order_number: 'Nombor pesanan storan',
		infact_time: 'Masa ketibaan sebenar',
		status: 'Status pesanan masuk',
		Creation_time: 'Jenis masa',
		Warehouse: 'Gudang Masuk',
		country: 'Jumlah pembelian',
		message: 'Mesej',
		operating: 'Beroperasi',
		ship: 'Jumlah Kos Penghantaran',
		View_items: 'Lihat item',
		delet: 'Padam',
		wait_store_check: 'Untuk diperiksa oleh gudang',
		wait_check_in: 'Menunggu penjual mengesahkan penyimpanan',
		aleady_check_in: 'Storan yang disahkan',
		comfirm: 'Semak storan',
		cusCode: 'Kod gudang',
		name: 'Nama Produk',
		Purchase_quantity: 'Kuantiti beli',
		Purchase_information: 'Maklumat pembelian item',
		rukudanghao: 'Nombor pesanan storan',
		create_time: 'Masa pembuatan pesanan beli',
		rukustore: 'Gudang Masuk',
		sellerMessage: 'Mesej penjual',
		rukushuliangcomfirm: 'Pengesahan kuantiti simpanan pesanan pembelian',
		confirm_time: 'Masa pengesahan pesanan pembelian',
		rukustore: 'Gudang Masuk',
		storeMessage: 'Mesej gudang',
		rukuNo: 'Kuantiti Masuk',
		actualNo: 'Kuantiti ketibaan sebenar',
		ok: 'Disahkan, produk telah meningkatkan inventori',
		I_know: 'Saya faham',
		warn: 'Petunjuk',
		sub: 'Serahkan kepada penjual untuk pengesahan',
		tosellermsg: "Masukkan mesej kepada penjual",
		anthoeName: 'Alias komoditi',
		check: 'Semak',
		payondelivery: 'Tunai semasa penghantaran (COD)',
	},
	lazada: {
		time: 'Masa pesanan',
		total: 'Sekali gus',
		paytotal: 'Jumlah pembayaran',
		shippingfee: 'Bayaran kurier',
		fahuoleixi: 'Jenis Penghantaran',
		zuihoufahuo: 'Baki masa penghantaran',
		shop: 'Kedai',
		shopid: 'ID kedai',
		paymenthod: 'Kaedah pembayaran',
		receipt: 'Penerima',
		phone: 'Telefon',
		trickno: 'Nombor bil laluan',
		printTime: 'Masa Cetak',
		choose: 'Pilih kaedah logistik',
		generate: 'Menjana',
		pendinggenerate: 'Tidak dijana'
	},
	orderPrint: {
		WarehouseType: 'Jenis gudang: ',
		LoadingStatus: 'Memuatkan status:',
		PrintStatus: 'Status cetakan:',
		LogisticsType: 'Jenis logistik:',
		FinalDelivery: 'Penghantaran terakhir:',
		OrderStatus: 'Status pesanan:',
		OrderContains: 'Perintah itu mengandungi:',
		Searchquery: 'Pertanyaan carian:',
		Includequery: 'Sertakan pertanyaan:',
		exclude: 'Tidak termasuk',
		Precise: 'Tepat',
		generatingWaybillNo: 'Mula menjana nombor bil laluan',
		Default_printing: 'Cetakan lalai',
		Ordertimeorder01: 'Isih mengikut masa pesanan (dari awal hingga lewat)',
		Ordertimeorder02: 'Isih mengikut masa pesanan (dari lewat hingga awal)',
		Sortbyquantity01: 'Pengisihan kuantiti (daripada lebih kepada kurang)',
		Sortbyquantity02: 'Isih mengikut kuantiti (dari kurang kepada lebih)',
		Sort_by_number_ofsku01: 'Isih nombor Sku (daripada lebih kepada kurang)',
		Sort_by_number_ofsku02: 'Isih nombor Sku (dari kurang kepada lebih)',
		Sort_by_pushtime_early: 'Push time sorting (dari lewat hingga awal)',
		Sort_by_pushtime_late: 'Tekan pengisihan masa (awal hingga lewat)',
		MassSetPickupTime: 'Tetapkan kaedah pengambilan (Ambil atau Turun) dalam kelompok:',
		Unselect_current_page: 'Songsang halaman semasa',
		Select_current_page: 'Pilih semua halaman semasa',
		Order_is_scheduled: 'Pesanan semasa dijadualkan',
		all: 'Semua',
		Loaded: 'Dimuatkan',
		not_loaded: 'Tidak dimuatkan',
		Generated: 'Dihasilkan',
		Not_generated: 'Tidak dijana',
		Printed: 'Dicetak',
		To_print: 'Tidak dicetak',
		To_delivered: 'Untuk dihantar',
		Pickup_failed: 'Pickup gagal',
		Multiple_SKU: 'Berbilang SKU',
		Single_SKU: 'SKU tunggal',
		select_Order: 'Sila pilih pesanan!',
		waybill_No: 'Sistem sedang menjana nombor bil laluan, sila muat semula halaman semasa selepas beberapa ketika! ',
		Copy: 'Berjaya disalin',
		Order_sorting: 'Susunan urutan',
		Pickup_time: 'Masa pengambilan',
		Order_scheduled: 'Pesanan semasa dijadualkan',
		Print_status: 'Status cetakan',
		Packaged: 'Stok habis',
		Unpackaged: 'Tidak dilepaskan',
		Combine_print_orders: 'Gabungkan pesanan cetakan',
		Combined_print_picklist: 'Gabung senarai pilihan cetakan',
		Regenerate_order: 'Menjana semula helaian muka',
		tip: 'Pesanan tiada atau sistem melaporkan ralat, sila jana semula pesanan dan cetak semula!',
		Print_name: 'Cetak nama',
		shop: 'Kedai',
		latest_time: 'Masa cetakan - (masa terkini)',
		operare: 'Beroperasi',
		print_order: 'Pesanan cetakan',
		Printed_order: 'Dicetak(pesanan)',
		Print_picklist: 'Senarai pemilihan cetakan kelompok',
		Printed_picklist: 'Dicetak (Senarai Pilihan)',
		close: 'Penutupan',
		Order_acquisition_status: 'Status perolehan pesanan:',
		completed: 'Selesai',
		order: 'Buka',
		total: 'Biasa',
		tip02: 'Pesanan tidak menyokong penjadualan sehingga masa ini',
		search_tip: 'Sila masukkan nombor pesanan',
		search_tip02: "Sila masukkan nama produk, ID produk, SKU",
		open01: 'Dayakan mod berbilang pilihan',
		open02: 'Pilih semua',
		open03: 'Pemilihan songsang',
		already: 'Nombor bil laluan telah dijana',
		default_second: 'Jangan tetapkan lalai pada hari berikutnya',
		store: 'Pilihan kedai:',
		stock: 'Jenis gudang:'



	},

	distribution: {
		//erp系统中的分销平台三个页面
		// Community
		shipmentPlace: "Tempat penghantaran",
		generateH5: "Hasilkan 'halaman eksklusif pengedar' ",
		searchStore: "Cari kod gudang, sku, nama produk",
		mSKU: "SKU ibu bapa",
		price: "Harga",
		oneOffer: "Harga generasi",
		stockNum: "Spot inventori",
		haveDistribution: "Saya sudah edarkan",
		havenDistribution: "Saya nak edarkan",
		//Tab
		distributionProduct: "Produk Gudang Pengedaran",
		distributionLibrary_tab: "Perpustakaan pemilihan pengedaran",
		distributionHaveSupply_tab: "Saya boleh bekalkan",
		distributionHaveAgent: "Saya telah mewakilkan",
		//hasAgent
		stockType: "Jenis gudang",
		selectAll: "Pilih semua halaman semasa",
		operationBatch: "Operasi kelompok",
		operationBatchDelete: "Padamkan kumpulan produk terpilih",
		sSKUNum: "Bilangan sub sku",
		totalStock: "Jumlah Inventori",
		releaseProduct: "keluaran produk",
		updateItemTip1: "Produk dalam gudang pengedaran semasa tidak terikat dengan maklumat templat, sila ikat produk dan lepaskan! ",
		updateItemTip3: "Pergi ke pengikatan pengurusan templat",
		cancel: "Batal",
		tip: "Petunjuk",
		determine: "Pasti",
		confirmDelete: "Adakah anda pasti mahu memadamkan produk yang dipilih? ",
		deleteSuccess: "Berjaya dipadamkan",
		//myselfproduct
		distributionH5Link: "Pautan halaman jemputan h5 produk pengedaran",
		copy: "Salinan",
		deleteFileTip: "Padamkan gesaan yang gagal! ",
		failReason: "Sebab kegagalan",
		nowSelect: "Pada masa ini dipilih",
		importProducts: "Import produk",
		havenProduct: "Buat masa ini tiada produk",
		offshelfdistribution: "Pengedaran luar rak",
		Onshelfdistribution: "Pengedaran di rak",
		confirmOffshelf: "Adakah anda pasti akan mengalih keluar produk ini? ",
		confirmOnshelf: "Adakah anda pasti menambah produk ini pada perpustakaan pemilihan pengedaran? ",
		successOnshelf: "Pengedaran yang berjaya di rak! ",
		successOffShelf: "Pengedaran luar rak berjaya! ",
		successCopy: "Berjaya disalin"
	},
	remind: {
		header: 'Fungsi peringatan',
		remind_message: 'Menghidupkan fungsi peringatan pintar akan menolak yuran mengikut jumlah SMS yang dihantar secara automatik, dan harga SMS dicaj mengikut negara yang berbeza. ',
		charge: '(Sebut harga SMS antarabangsa: Malaysia 0.25 mata/mesej, Thailand 0.15 mata/mesej)',
		seller_back: 'Tetapan peringatan',
		shopee: 'kedai shopee',
		orderCare: 'Penjagaan Pesanan',
		record: "Gunakan rekod",
		paymentRemind: "Peringatan",
		open: "Buka",
		close: "Penutupan",
		displayEchart: "Tunjukkan hasil",
		totalSend: "Bilangan barang yang dihantar",
		successRecive: "Berjaya menerima nombor",
		edit: "Edit Templat",
		remindType: "Jenis peringatan",
		orderId: "Nombor pesanan",
		orderIdPlaceholder: "Sila masukkan nombor pesanan",
		buyerName: "Nama Pembeli",
		buyerPlaceholder: "Cari Nama Pembeli",
		tableTypt: "Taip",
		tableChargeNum: "Nombor pengebilan",
		integralCost: "Mata penggunaan",
		status: "Hasil penghantaran",
		arriveTime: "Masa penghantaran",
		shipReminder: "Peringatan Penghantaran",
		signRemind: "Peringatan Resit",
		displayEffect: "Tunjukkan hasil",
		succseePayOrdersNum: "Bilangan pesanan yang berjaya dibayar dalam masa",
		successSendMessage: "Selepas menghantar SMS dalam ",
		pleaseSelect: "Sila pilih",
		lately: "Baru-baru ini",
		totalSend: "Dihantar secara keseluruhan",
		strip: "Jalur",
		successRecive_: "Diterima dengan jayanya",
		successPayOrder: "Berjaya membayar pesanan",
		successPay: "Pembayaran berjaya",
		sendAndSuccessSendCount: "Bilangan mesej teks yang dihantar dan bilangan mesej yang berjaya dihantar",
		ifOnlyRemindCod: "Sama ada untuk mengingatkan hanya pesanan COD",
		orderId: "Nombor pesanan",
		buyerName: "Nama Pembeli",
		Type: "Taip",
		CountNum: "Nombor pengebilan",
		CountIntegral: "Mata penggunaan",
		deliveryResult: "Hasil penghantaran",
		arriveTime: "Masa penghantaran",
		acceptFail: "Terima kejayaan",
		acceptSuccess: "Terima kejayaan",
		sending: "Menghantar",
		acceptOutTime: "Terima tamat masa",
		latelySendAndSuccessCount: "Bilangan SMS baru-baru ini dihantar dan bilangan yang berjaya dihantar",
		sendMessageTotal: "Jumlah bilangan mesej teks yang dihantar",
		sendSuccessCount: "Bilangan penghantaran yang berjaya",
		successPayCount: "Bilangan pembayaran yang berjaya",
		toData: "Dari sekarang",
		setCountOption_tip1: "Ke hadapan",
		setCountOption_tip2: "Hantar kesemuanya",
		setCountOption_tip3: "SMS, berjaya dihantar",
		In: 'Wujud',
		seccessPay: 'Jumlah pembayaran yang berjaya',
		order: "Satu",
		queryTime: "",
		//remind_Template
		back: "Pulang",
		currentTemplate: "Templat SMS semasa",
		Bracket_tip: "(Pembolehubah pesanan dalam kurungan segi empat sama akan diperoleh secara automatik oleh sistem)",
		currentSelectTemplate: "Templat yang dipilih pada masa ini",
		testTemplate: "Uji Templat SMS",
		sentTestMessage: "Hantar mesej ujian",
		systemTemplate: "Templat Sistem",
		customTemplate: "Templat tersuai",
		defaultLanguage_tip: "Bahasa lalai awal ialah bahasa Inggeris",
		customTemplateLanguage_tip: "Templat tersuai tidak menyokong penyesuaian berbilang bahasa",
		saveSetting: "Simpan Tetapan",
		insertLabel: "Masukkan tag",
		what_label: "Apa itu label",
		label_tip: "Selepas memasukkan label, Teknologi Xiangrong secara automatik akan mengisi data pesanan atau nama yang sepadan dalam label apabila menghantar mesej teks, menghapuskan keperluan untuk mengedit pelbagai kandungan secara manual. ",
		haveInput: "Sudah masuk",
		character: "Watak",
		countCharacterTip: "Jika ID pembeli terlalu panjang, ia boleh mengakibatkan berbilang bil",
		limitLengthTip: "Hadkan panjang SMS kepada 536 aksara",
		messageChargeTip: "Sebut harga SMS antarabangsa: Malaysia 0.25 mata/mesej, Thailand 0.15 mata/mesej",
		messageCount: "Bilangan mesej teks",
		paymentRemind_tip1: "Pembeli secara automatik akan menghantar mesej teks selepas 30 minit mengambil gambar dan belum membayar (jumlah pesanan lebih daripada 0 dolar AS untuk diingatkan). ",
		paymentRemind_tip2: "Pembeli yang sama boleh menghantar peringatan paling banyak sekali sehari. ",
		paymentRemind_tip3: "Jika pembeli telah membayar lebih daripada 1 pesanan di kedai kami pada hari yang sama, peringatan akan dibatalkan secara automatik. ",
		shipRemind_tip1: "Selepas penjual menghantar barang, ia akan menghantar mesej teks secara automatik untuk memberitahu pembeli (ingatkan hanya jika jumlah pesanan melebihi $0). ",
		shipRemind_tip2: "Jika kurier telah ditandatangani atau telah tiba di bandar pembeli, ia tidak akan dihantar",
		signRemind_tip1: "Dalam masa 72 jam selepas pembeli menandatangani untuk bayi, mesej teks akan dihantar secara automatik untuk memaklumkan penjagaan (jika pembeli telah mengesahkan resit, ia tidak akan dihantar), dan jumlah pesanan akan lebih daripada 0 dolar AS untuk diingatkan . ",
		sendCondition: "syarat hantar",
		chargeStandard: "Caj",
		addTemplate: "Tambah Templat",
		messageType: "Jenis SMS",
		chargeCountStandard: "Standard nombor pengebilan",
		messageType_tip1: "Tidak mengandungi aksara khas",
		messageType_tip2: "Aksara/bar",
		templateChoose: "Pemilihan templat",
		testPhoneNum_tip: "Sila masukkan nombor telefon bimbit ujian",
		English: "Inggeris",
		Chinese: "Cina",
		My: "Melayu",
		Th: "Thai",
		recipientName: "Nama penerima",
		OrderId: "Nombor pesanan",
		shopName: "Nama kedai",
		purchaseDate: "Tarikh pembelian",
		selectTemplate: "Sila pilih templat",
		failSaveTemplate: "Gagal menyimpan templat",
		confirmButtonText: "Pasti",
		inputeContent: "Sila masukkan kandungan",
		addCustomFail: "Gagal menambah templat tersuai",
		outLimit: "Panjang aksara SMS tersuai melebihi had",
		confirmDeleteCustom: "Operasi ini akan memadamkan templat tersuai, adakah anda mahu meneruskan Halaman?",
		tip: "Petunjuk",
		cancel: "Batal",
		successDelete: "Berjaya dipadamkan",
		haveCancelDelete: "Tidak dipadamkan",
		haveSendTestMessage: "Mesej ujian telah dihantar",
		failSendTestMessage: "Gagal menghantar mesej ujian",
		phoneFormatErr: "Nombor telefon bimbit adalah dalam format yang salah atau tiada templat ujian telah dipilih"
	},

	h5: {
		verification: 'Kod pengesahan SMS',
		phone: 'Nombor telefon',
		login: 'Log masuk segera',
		send: 'Hantar kod pengesahan',
		phoneDesc: 'Masukkan nombor telefon bimbit',
		passWordeDesc: 'Masukkan kod pengesahan',
		DSX_index_note: 'Sayang~ Anda belum log masuk! ',
		DSX_index_log: "Log masuk segera",
		DSX: 'Ceruk kedai',
		DSX_title: 'Dianxiaosheng platform pengedaran sumber tempatan Asia Tenggara',
		DSX_qty: 'Kuantiti Spot',
		DSX_dropship: 'Sebarkan sekarang',
		DSX_specification: 'Spesifikasi(1)',
		DSX_price: '1 keping bagi pihak harga',
		DSX_qty1: 'Stok:',
		DSX_des: 'Penerangan Produk',
		DSX_details: 'Maklumat produk',
		DSX_index_slogn: 'Senarai pengedaran barangan spot Asia Tenggara',
		DSX_index_recommendation: 'Senarai cadangan hangat',
		DSX_index_th: 'Thailand',
		DSX_index_my: 'Malaysia',
		DSX_index_ph: 'Filipina',
		DSX_index_tw: 'Taiwan',
		DSX_index_id: 'Indonesia',
		DSX_index_vn: 'Vietnam',
		DSX_index_bz: 'Brazil',
		DSX_index_cn: 'Gudang Pengujian China',
		DSX_index_price: '1 keping bagi pihak harga',
		DSX_index_profit: 'Margin Kasar',
		DSX_index_qty: 'Spot inventori',
		DSX_index_country: 'Analisis Pasaran Melayu',
		DSX_index_sample: 'Saya mahu sampel',
		DSX_index_dropship: 'Saya ingin mengedarkan',
		DSX_index_welcome: 'Selamat datang',
		DSX_index_signout: 'Berhenti',
		DSX_index_back: 'Kembali',
		DSX_index_Quote: 'Dapatkan pertanyaan',
		DSX_index_detail: 'Maklumat produk',
		DSX_index_distribute: 'Sebarkan sekarang',
		DSX_index_tips: 'Produk telah berjaya diedarkan ke akaun shopee anda. Untuk mengeluarkan produk ke platform shopee, sila ke platform pengedaran di PC: Saya ejen, teruskan beroperasi! ',
		a1736: 'ssss'


	},

	other: {
		a1: 'Pemuatan imej gagal...',
		a2: 'Memuatkan imej...',
		a3: 'Hubungi Khidmat Pelanggan',
		a4: 'Perkhidmatan Pelanggan Gudang Luar Negara',
		a5: 'penutupan',
		a6: 'Klik untuk memuat turun pakej pemasangan CRX pemalam',
		a7: 'Pengenalan Plugin',
		a8: 'Beianalysis ialah alat operasi yang disediakan khas untuk penjual Shopee, yang boleh membantu penjual Shopee memilih produk dengan cekap dan menganalisis data produk. Berkenaan dengan Shopee Thailand, Malaysia, Indonesia, Vietnam dan lapan tapak lain, anda boleh mengalaminya dengan yakin. Ia boleh memaparkan data berkaitan berikut pada mana-mana halaman butiran produk Shopee',
		a9: '①产品上架日期；销量/Indeks Jualan/Pelawat/Penukaran; Kecurigaan untuk memberus pesanan. ',
		a10: '②Ia boleh memantau produk di Shopee dalam masa nyata, mencari sumber barangan dengan gaya yang sama, produk pesaing dengan gaya yang sama, dsb.',
		a11: 'Arahan penggunaan:',
		a12: '点击查看:Syor industri/syor carian/syor kedai tiga senario penggunaan',
		a13: 'Panduan pemasangan',
		a14: 'Kaedah 1: Selepas menyahmampat fail yang dimuat turun, letakkan pada desktop komputer yang disyorkan untuk pengendalian yang mudah. Langkah-langkah operasi adalah seperti berikut:',
		a15: 'Buka Google Chrome --> Cari sudut kanan atas...> Kemudian klik Buka untuk mencari "Lagi Alat" --> Kemudian cari "Sambungan" --> Hidupkan mod pembangun --> Seret fail .CRX pada desktop terus Hantar ke antara muka di bawah mod pembangun, dan pemasangan boleh diselesaikan!',
		a16: 'Kaedah 2: Selepas pergi ke dalam talian secara saintifik,',
		a17: 'klik pautan',
		a18: 'Pergi ke Google Mall untuk memasang terus:',
		a19: 'Imbas kod untuk memuat turun APP platform pengedaran Android',
		a20: 'Apl Penjual (Android)',
		a21: 'Apl Gudang (Android)',
		a22: 'Peringatan',
		a23: 'APP sebelah penjual: Ia boleh merealisasikan pengurusan pesanan/pemulangan semakan dan sembang berbilang kedai Shopee, termasuk terjemahan automatik, balasan automatik, penukaran berbilang kedai, dsb.',
		a24: 'APP sisi gudang: Dengan pengimbas PDA atau Bluetooth, ia boleh merealisasikan pengisihan dan pemeriksaan pesanan, mengimbas keluar dari gudang, mengimbas pemulangan dan pertukaran, dsb.',
		a25: 'Cetak sejarah',
		a26: 'Carian nombor pesanan',
		a27: 'Cari',
		a28: 'Cantumkan cetakan',
		a29: 'Pilih',
		a30: 'Nama',
		a31: 'Masa Cetakan - (masa terkini)',
		a32: 'Masa cetak',
		a33: 'Beroperasi',
		a34: 'Semak',
		a35: 'Tambah nombor bil laluan',
		a36: 'Sila masukkan nombor bil laluan untuk ditambahkan:',
		a37: 'Sila masukkan nombor bil laluan',
		a38: 'Mengesahkan',
		a39: 'Semak dan terima barang yang dibungkus',
		a40: 'Sila sahkan nombor bil laluan barang yang diterima:',
		a41: 'Sila pilih nombor bil laluan',
		a42: 'Butiran cas semula',
		a43: 'Cari mengikut masa transaksi',
		a44: 'Cari mengikut masa pembayaran',
		a45: 'Tarikh mula',
		a46: 'Tarikh tamat',
		a47: 'Kepada',
		a48: 'Kaedah pembayaran:',
		a49: 'Status bayaran:',
		a50: 'sila pilih',
		a51: 'Isih:',
		a52: 'Perintah',
		a53: 'Nombor pesanan pembayaran',
		a54: 'Integral',
		a55: 'Negeri',
		a56: 'Kaedah pembayaran',
		a57: 'Masa penciptaan',
		a58: 'Butiran potongan mata',
		a59: 'Jenis Transaksi',
		a60: 'Nombor pesanan',
		a61: 'Jam transaksi',
		a62: 'Baki mata',
		a63: 'Pemilihan klasifikasi produk',
		a64: 'Susunan urutan',
		a65: 'Cari nama produk, SKU',
		a66: 'Gambar',
		a67: 'kod gudang',
		a68: 'ID Komoditi',
		a69: 'ID kedai',
		a70: 'Penapis kedai:',
		a71: 'Penapis sebab pulangan: ',
		a72: 'Eksport Excel',
		a73: 'Eksport semua',
		a74: 'Semua Tuntutan',
		a75: 'Selepas mengeksport Excel dan menyerahkannya kepada perkhidmatan pelanggan platform, anda boleh mengklik butang Mulakan Tuntutan untuk menyenaraikan pesanan ini sebagai tuntutan belum selesai untuk mengelakkan kekeliruan dengan pesanan pakej baharu yang hilang',
		a76: 'Alasan untuk kembali',
		a77: 'Jumlah',
		a78: 'Masa kemas kini',
		a79: 'Menuntut masa kejayaan',
		a80: 'Baki masa sah tuntutan',
		a81: 'Mulakan tuntutan',
		a82: 'Semak logistik',
		a83: 'Untuk dihubungi perkhidmatan pelanggan platform',
		a84: 'Tuntutan berjaya',
		a85: 'Maklumat logistik',
		a86: 'Nombor bil laluan:',
		a87: 'Nombor pesanan:',
		a88: 'Status semasa: ',
		a89: 'Masa',
		a90: 'Butiran logistik',
		a91: 'Isikan maklumat resit',
		a92: 'Jenis kargo:',
		a93: 'Semak semula',
		a94: 'panjang:',
		a95: 'Isikan panjang item',
		a96: 'Lebar:',
		a97: 'Isikan lebar item',
		a98: 'Tinggi:',
		a99: 'Isikan ketinggian item',
		a100: 'Berat:',
		a101: 'Isikan berat barang',
		a102: 'Klik untuk memuat naik gambar',
		a103: 'Hanya fail jpg/png boleh dimuat naik, dan tidak melebihi 500kb',
		a104: 'Peringatan',
		a105: 'Adalah disyorkan untuk mengeksport pesanan semasa untuk dituntut ke helaian excel untuk penyimpanan data sebelum membuat semua tuntutan. Selepas pengesahan, data akan memasuki senarai pesanan di bawah tuntutan! ',
		a106: 'Batal',
		a107: 'Sahkan tuntutan mula',
		a108: 'Muat semula pesanan',
		a109: 'Pilih kedai:',
		a110: 'Isikan pesanan:',
		a111: 'Isikan nombor pesanan',
		a112: 'Muatkan sekarang',
		a113: 'Semua',
		a114: 'Pakej telah hilang',
		a115: 'Penghantaran gagal',
		a116: 'WeChat Pay',
		a117: 'Alipay',
		a118: 'Tidak dibayar',
		a119: 'Selesai',
		a120: 'Ditutup',
		a121: 'Digunakan',
		a122: 'Mengikut mata - daripada lebih kepada kurang',
		a123: 'Mengikut mata - daripada kurang kepada lebih',
		a124: 'Masa penjanaan pesanan - dari pagi hingga malam',
		a125: 'Masa penjanaan pesanan - dari lewat hingga awal',
		a126: 'Mengikut kuantiti pembelian - daripada lebih kepada kurang',
		a127: 'Mengikut kuantiti pembelian - daripada kurang kepada lebih',
		a128: 'Mengikut SKU - daripada kurang kepada lebih',
		a129: 'Pembelian melalui SKU-daripada banyak kepada sedikit',
		a130: 'Minggu lepas',
		a131: 'Bulan lepas',
		a132: 'Tiga bulan lepas',
		a133: 'Tuntutan yang belum selesai',
		a134: 'Tuntutan belum selesai',
		a135: 'Tuntutan telah berjaya',
		a136: 'Perkhidmatan pelanggan platform pengedaran',
		a137: 'Cas semula',
		a138: 'Penggunaan',
		a139: 'Isu logistik',
		a140: 'Tiada',
		a141: 'Melakukan operasi ini akan meninggalkan tuntutan untuk pesanan ini, mengesahkan untuk meninggalkan tuntutan? ',
		a142: 'Petunjuk',
		a143: 'Sila isi maklumat penerimaan seperti yang diperlukan',
		a144: 'Melakukan operasi ini akan meninggalkan tuntutan untuk pesanan ini, mengesahkan untuk meninggalkan tuntutan? ',
		a145: 'Pasti',
		a146: 'Batal',
		a147: 'Tidak dibayar',
		a148: 'Telah dibayar',
		a149: 'WeChat',
		a150: 'Sila tandakan item',
		a151: 'Buat masa ini tiada pesanan yang boleh dituntut! ',
		a152: 'Sila pilih pesanan',
		a153: 'Pemalam sub-papan data Bayanalysis',
		a154: 'Pilih Kaedah Pembayaran',
		a155: 'Kod QR pembayaran gagal dimuatkan',
		a156: 'Jumlah pembayaran:',
		a157: 'Yuan',
		a158: 'Sila gunakan kod imbasan Alipay untuk membayar',
		a159: 'Sila gunakan kod imbasan WeChat untuk membayar',
		a160: 'Lepaskan bayaran',
		a161: 'Pembayaran selesai',
		a162: 'Jualan',
		a163: 'Pusing ganti inventori:',
		a164: 'Kitaran pengisian semula:',
		a165: 'Masukkan tempoh pengisian semula (nombor tulen)',
		a166: 'Sahkan perubahan',
		a167: 'Potong inventori dalam transit',
		a168: 'Nombor Pembelian yang Dicadangkan',
		a169: 'Kuantiti di tangan',
		a170: 'Kuantiti dalam transit',
		a171: 'Purata jualan/hari',
		a172: 'Kitaran pengisian semula',
		a173: 'Anggaran jualan 7 hari',
		a174: 'Anggaran jualan 14 hari',
		a175: 'Anggaran jualan 30 hari',
		a176: 'Baki hari tersedia untuk dijual',
		a177: 'Langit',
		a178: 'Buat Pesanan Belian',
		a179: 'Nama Produk',
		a180: 'Pusing ganti inventori',
		a181: 'Masa penghantaran terkini',
		a182: 'Status jualan kedai',
		a183: 'Eksport',
		a184: 'Atribusi pesanan',
		a185: 'Pesanan ejen',
		a186: 'Pesanan yang dibina sendiri',
		a187: 'Pesanan penjual',
		a188: 'Pengikat komoditi',
		a189: 'Tambah pengikat komoditi',
		a190: 'Produk pra-jualan',
		a191: 'Ya',
		a192: 'Tidak',
		a193: 'Lepaskan ikatan',
		a194: 'Semua pesanan milik',
		a195: 'Semua jenis',
		a196: 'Permulaan sistem',
		a197: 'Pesanan akan ditolak dari gudang atau diletakkan semula di rak',
		a198: 'Pesanan storan ditambah',
		a199: 'Pindahkan semakan pesanan',
		a200: 'Pemindahan Stok',
		a201: 'pengubahsuaian gudang',
		a202: 'Peringatan kehabisan stok',
		a203: 'Peringatan Tidak Boleh Dijual',
		a204: 'Jumlah Jualan',
		a205: 'Jualan',
		a206: 'Masa',
		a207: 'Jualan',
		a208: 'Peringatan kehabisan stok--',
		a209: 'Adakah anda pasti mahu melepaskan ikatan?',
		a210: 'Berjaya melepaskan ikatan! ',
		a211: 'Sila pilih produk',
		a212: 'Sebulan yang lalu',
		a213: 'Pengurusan kawalan harga',
		a214: 'Tetapkan harga kawalan',
		a215: 'Tetapkan kuantiti',
		a216: 'Simpan',
		a217: 'Peta harta benda',
		a218: 'Nama sku',
		a219: 'Harga bekalan',
		a220: 'Harga borong',
		a221: 'Had bawah kawalan harga pengagihan',
		a222: 'Tetapkan had bawah harga jualan produk di rak ejen',
		a223: 'Maklumat Ejen',
		a224: 'Agensi:',
		a225: 'Nombor akaun:',
		a226: 'Kod gudang:',
		a227: 'Bilangan kedai di rak:',
		a228: 'Harga diskaun dalam talian',
		a229: 'Keluarkan produk ejen',
		a230: 'Sila masukkan bilangan ejen (apabila -1 bermakna tidak terhad)',
		a231: 'kejayaan! ',
		a232: 'Berjaya diserahkan! ',
		a233: 'Sahkan bahawa anda mahu mengalih keluar pengedar secara paksa:',
		a234: 'Produk? ',
		a235: 'Ya',
		a236: 'Penyingkiran berjaya! ',
		a237: 'Agensi',
		a238: 'Edit',
		a239: 'Simpan kemas kini',
		a240: 'Had bawah harga jualan dalam talian untuk pengedaran di rak oleh ejen',
		a241: 'Ubah suai maklumat pesanan',
		a242: 'Adakah ia satu produk:',
		a243: 'Pemilihan gudang:',
		a244: 'Masukkan aksara carian',
		a245: 'Cari',
		a246: 'Dipilih:',
		a247: 'Tiada produk gudang',
		a248: 'Di mana gudang itu terletak:',
		a249: 'Ibu sku:',
		a250: 'Simpan di gudang:',
		a251: 'Produk tunggal',
		a252: 'Kombo',
		a253: 'Produk biasa',
		a254: 'Mengedarkan Produk',
		a255: 'Cari mengikut nama produk',
		a256: 'Cari mengikut kod gudang',
		a257: 'Cari mengikut produk sku',
		a258: 'Sistem telah mengesan gudang yang anda belum aktifkan lagi, sila pergi ke kedai untuk membenarkan dan membolehkan gudang yang anda perlukan!',
		a259: 'Akaun semasa tidak mempunyai akaun yang dikaitkan dengan gudang! ',
		a260: 'Tiada penerangan lagi',
		a261: 'Tetapkan formula harga untuk harga runcit',
		a262: 'Kadar pertukaran: kadar pertukaran RMB kepada mata wang tempatan, seperti 1rmb=5.19 baht, iaitu: 0.192 kadar pertukaran',
		a263: 'Diskaun: Jika ia adalah produk potongan 40%, iaitu: potongan 40',
		a264: 'Yuran keluar: Negara yang berbeza mempunyai harga yang berbeza',
		a265: 'Formula pengiraan baharu',
		a266: 'Formula',
		a267: 'Yuran berlepas rmb',
		a268: 'Kadar pertukaran',
		a269: 'Kawasan',
		a270: 'Kadar keuntungan %',
		a271: 'Diskaun',
		a272: 'Tetapkan lalai',
		a273: 'Padam',
		a274: 'Mengesahkan',
		a275: 'Gantikan imej utama dari pautan shopee',
		a276: 'Sila masukkan url pautan halaman butiran produk shopee',
		a277: 'Sila tunggu, memuatkan aset imej. . .',
		a278: 'Dimuatkan!',
		a279: 'Pasti',
		a280: 'Muat naik imej atribut',
		a281: 'Hanya muat naik fail jpg, dan tidak lebih daripada 10J',
		a282: 'Cadangan pengisian komoditi',
		a283: '1. Bilangan aksara dalam tajuk produk adalah lebih daripada 20 tetapi kurang daripada 120',
		a284: '2. Panjang sku tidak melebihi 20 aksara',
		a285: 'Keluaran produk',
		a286: 'Ubah suai kategori',
		a287: '1 maklumat asas',
		a288: 'Terbitkan kedai',
		a289: 'Imej utama komoditi',
		a290: 'Susun gambar secara rawak',
		a291: 'Tambahkan tera air imej',
		a292: 'Gantikan gambar dari pautan shopee',
		a293: 'Hanya 8 fail jpg/png boleh dimuat naik paling banyak, dan tidak melebihi 10M',
		a294: 'Muat naik imej',
		a295: 'Tajuk produk',
		a296: 'Bilangan aksara tajuk hendaklah dikawal antara 20~120',
		a297: 'Atribut komoditi',
		a298: 'Sila masukkan',
		a299: '2 stok spesifikasi',
		a300: 'Pengiraan harga runcit: (harga bekalan',
		a301: 'Margin Kasar',
		a302: 'Diskaun',
		a303: 'Kira secara automatik formula harga runcit',
		a304: 'Pembantu kumpulan',
		a305: 'Batch padam aksara sku yang sama',
		a306: 'Inventori Harga',
		a307: 'Tetapan kelompok',
		a308: 'Panjang aksara dalam 5~20',
		a309: 'Harga runcit (mata wang tempatan)',
		a310: 'Dalam stok',
		a311: 'CusCode terikat',
		a312: 'Padam',
		a313: 'Pakej_spesifikasi',
		a314: 'Berat (kg):',
		a315: 'Isipadu (cm):',
		a316: 'Jenis logistik:',
		a317: 'Gudang penghantaran:',
		a318: 'Penerangan Produk',
		a319: 'Sila masukkan kandungan',
		a320: 'Terbitkan produk sekarang',
		a321: 'Terbitkan produk shopee',
		a322: 'Terbitkan produk Kedai TikTok',
		a323: 'Sila tambah gambar atribut produk sebelum menyiarkan',
		a324: 'Ejen produk ini tidak normal, sila ejen semula, dan kemudian lepaskannya di rak',
		a325: 'Sila pergi ke latar belakang TIKTOK untuk menyediakan gudang penghantaran. Jika anda tidak tahu alamat gudang penghantaran, sila hubungi perkhidmatan pelanggan Xiaosheng',
		a326: 'Produk tersebut telah berjaya disenaraikan di TikTok Shop Merchandise',
		a327: 'Sila isikan harga runcit!',
		a328: 'Produk tidak normal, sila ejen semula atau hubungi perkhidmatan pelanggan platform untuk menanganinya! ',
		a329: 'Sku produk tidak boleh kosong',
		a330: 'Berat, isipadu tidak boleh kosong! ',
		a331: 'Gambar utama produk tidak boleh melebihi 8 gambar',
		a332: 'Sila muat naik fail .xlsx di bawah 2M',
		a333: 'Saiz gambar avatar yang dimuat naik tidak boleh melebihi 10MB!',
		a334: 'Atribut jualan',
		a335: 'Spesifikasi',
		a336: 'Terbitkan produk Lazada',
		a337: 'Sila isikan harga runcit',
		a338: 'Bilangan maksimum gambar utama tidak boleh melebihi 8! ',
		a339: 'Muka depan',
		a340: 'Saya telah proksi',
		a341: 'Pusat Peribadi',
		a342: 'Cetak',
		a343: 'Eksport PDF',
		a344: 'Jumlah bilangan kotak:',
		a345: 'Kotak',
		a346: 'Saiz kertas:',
		a347: 'Lebar Kertas:',
		a348: 'Ketinggian kertas:',
		a349: 'Mm',
		a350: 'Kertas Terma',
		a351: 'Menyesuaikan',
		a352: 'Kod Bar Produk',
		a353: 'Fail saya',
		a354: 'Tidak',
		a355: 'Induk gudang sku:',
		a356: 'Sub-sku gudang:',
		a357: 'Jawatan:',
		a358: 'Semua',
		a359: 'Pilih kedai',
		a360: 'Status komoditi',
		a361: 'Kembangkan kedai yang tinggal',
		a362: 'Pada masa ini dengan:',
		a363: 'Dalam sesi',
		a364: 'Senarai sesi',
		a365: 'Dah baca',
		a366: 'Mesej ini ialah mesej suara, sila log masuk ke APP untuk melihat',
		a367: 'Belum dibaca',
		a368: 'Klik untuk memuat naik',
		a369: 'Hantar',
		a370: 'Kandungan yang dihantar tidak boleh kosong! ',
		a371: 'Sambungan websock berjaya',
		a372: 'Sambungan websock gagal',
		a373: 'Sila pilih spesifikasi produk',
		a374: 'Dian Xiaosheng Distribution Mall',
		a375: 'Troli beli-belah',
		a376: 'Semua produk (0)',
		a377: 'Produk terpilih',
		a378: 'Pilih semua',
		a379: 'Informasi produk',
		a380: 'Harga seunit',
		a381: 'Kuantiti',
		a382: 'Keizinan berjaya! ',
		a383: 'Mesej ralat',
		a384: 'Maaf, halaman kedai Xiaosheng yang anda lawati tidak wujud! ',
		a385: 'Klik di sini untuk kembali ke laman utama Xiaosheng! ',
		a386: 'Pilihan kedai:',
		a387: 'Memuatkan pesanan',
		a388: 'Dayakan mod berbilang pilihan',
		a389: 'Muat semula halaman semasa',
		a390: 'Tanda tetapan kelompok',
		a391: 'Tiada',
		a392: 'Mengambil data...',
		a393: 'Memuatkan...',
		a394: 'Pusat pendaftaran',
		a395: 'Nombor telefon:',
		a396: 'Kata laluan pengguna:',
		a397: 'Sahkan Kata Laluan:',
		a398: 'Kod pengesahan:',
		a399: 'Nombor telefon',
		a400: 'Kata laluan pengguna',
		a401: 'Kod pengesahan',
		a402: 'Dapatkan',
		a403: 'Daftarlah sekarang',
		a404: 'Sudah mempunyai akaun, sila pergi ke PC untuk log masuk! ',
		a405: 'Dapatkan pek hadiah sekarang',
		a406: 'Ceruk kedai',
		a407: 'Provide cross-border localization of overseas warehouse and distribution solutions',
		a408: 'Focus on small and medium parts of the United States/Southeast Asia localization services',
		a409: '① To provide local exclusive new strange supply in the United States, can be customized flexible production, a batch.',
		a410: '② Provide overseas warehouse services in the United States, specializing in small and medium-sized pieces (clothing, home, mobile phone shells, etc.).',
		a411: '③ It can support sellers to build their own family warehouse/overseas warehouse, and provide ERP/WMS pure system services.',
		a412: 'Penyegerakan Inventori Tepat',
		a413: '99.99% kadar ketepatan inventori, mengikat inventori dalam talian berbilang kedai, untuk mengelakkan potongan mata terlebih jual',
		a414: 'Pembantu Tuntutan',
		a415: 'Penjual mengetahui pesanan ditolak oleh COD atau hilang dalam penghantaran ekspres dalam masa, yang memudahkan penjual untuk menuntut pampasan daripada platform tepat pada masanya, memulihkan kerugian dan meningkatkan keuntungan bersih anda! ',
		a416: 'Platform pengedaran',
		a417: 'Tempat tempatan di Asia Tenggara, satu bahagian pengedaran di rak, inventori yang tepat, pengikat persatuan, untuk mengelakkan terlalu banyak jualan',
		a418: 'Berbual dengan Kedai Shopee',
		a419: 'Thai, Vietnam, Indonesia, Melayu, Inggeris Terjemahan automatik, balasan automatik, penukaran berbilang kedai, balasan pantas',
		a420: 'Selamat datang untuk log masuk ke Xiaosheng',
		a421: 'Akaun',
		a422: 'Daftar Akaun',
		a423: 'Masukkan akaun pengguna',
		a424: 'Masukkan kata laluan pengguna',
		a425: 'Akaun:',
		a426: 'Kata laluan:',
		a427: 'Luas nombor:',
		a428: 'Daftar Akaun:',
		a429: 'Masukkan nombor telefon atau e-mel',
		a430: 'Nama Panggilan Pengguna',
		a431: 'Sahkan Kata Laluan',
		a432: 'Sila masukkan kod pengesahan',
		a433: 'Bidang yang diperlukan, jika tidak, sila hubungi khidmat pelanggan',
		a434: 'Kod Jemputan',
		a435: 'Daftar sekarang',
		a436: 'Klik untuk menghantar kod pengesahan',
		a437: 'Sila masukkan nombor akaun atau kata laluan! ',
		a438: 'Sila masukkan nombor telefon',
		a439: 'Baki akaun tidak mencukupi',
		a440: 'Kod pengesahan telah berjaya dihantar, sila beri perhatian untuk menyemak! ',
		a441: 'Sila masukkan nombor e-mel anda untuk mendapatkan kod pengesahan! ',
		a442: 'Sila isi akaun pengguna! ',
		a443: 'Sila isi kata laluan pengguna! ',
		a444: 'Sila isikan kod pengesahan! ',
		a445: 'Kata laluan yang dimasukkan dua kali tidak konsisten, sila sahkan semula kata laluan! ',
		a446: 'Pendaftaran berjaya',
		a447: 'Sila isikan nama panggilan pengguna! ',
		a448: 'Sila isi kata laluan akaun yang betul! ',
		a449: 'Log masuk berjaya, melompat ke halaman utama',
		a450: '③ERP menyokong penyegerakan automatik inventori item yang sama pada platform Shopee/Lazade yang berbeza untuk mengelakkan terlalu banyak jualan! ',
		a451: 'Pusat log masuk',
		a452: 'Sila masukkan nombor telefon mudah alih anda untuk mendapatkan kod pengesahan! ',
		a453: 'Log masuk kod pengesahan telefon bimbit',
		a454: 'Nombor telefon bimbit tidak boleh kosong! ',
		a455: 'Kod pengesahan dihantar secara tidak normal, sila cuba sebentar lagi! ',
		a456: 'Sila masukkan nombor akaun atau kata laluan! ',
		a457: 'Berjaya mendaftar, melompat ke halaman utama! ',
		a458: 'Nombor telefon bimbit diperlukan! ',
		a459: 'Jenis Pendaftaran',
		a460: 'Daftar telefon anda',
		a461: 'Pendaftaran e-mel',
		a462: 'Luas nombor',
		a463: 'Nombor peti mel',
		a464: 'Kata laluan',
		a465: 'Nama Panggilan Penjual',
		a466: 'Sila masukkan alamat e-mel anda',
		a467: 'Sila masukkan kata laluan (lebih daripada 6 digit, gabungan huruf)',
		a468: 'Sila masukkan kod pengesahan telefon bimbit anda',
		a469: 'Sila masukkan kod pengesahan e-mel',
		a470: 'Sila masukkan nama panggilan penjual',
		a471: 'Kod jemputan (pilihan)',
		a472: 'Kedua-dua kata laluan yang dimasukkan tidak konsisten, sila sahkan semula kata laluan',
		a473: 'Sila masukkan nama panggilan penjual',
		a474: 'Pendaftaran berjaya, dan maklumat pengguna sedang dianalisis dalam persatuan',
		a475: 'Persatuan berjaya! ',
		a476: 'Persatuan gagal, sila hubungi perkhidmatan pelanggan Xiaosheng! ',
		a477: 'Pakar penyetempatan di Asia Tenggara',
		a478: 'E-mel / nombor telefon',
		a479: 'Sila isikan nombor telefon bimbit yang betul! ',
		a480: 'Log masuk berjaya, pergi ke halaman utama! ',
		a481: 'Bangsa',
		a482: 'Kategori peringkat pertama',
		a483: 'Kategori menengah',
		a484: 'Kategori peringkat ketiga',
		a485: 'Jumlah muka surat',
		a486: 'Tidak dapat mencetak selepas dimuatkan? ',
		a487: 'Halaman cetakan semasa',
		a488: 'Halaman',
		a489: 'Halaman setiap cetakan',
		a490: 'Matikan pencetakan kelompok',
		a491: 'Dayakan fungsi pencetakan kelompok',
		a492: 'Kemajuan pemuatan helaian muka',
		a493: 'Kertas A4',
		a494: 'Kertas A5',
		a495: 'Kertas haba (tersuai)',
		a496: 'Pengecualian pemuatan borang',
		a497: 'Memberi',
		a498: 'Mesej pembeli',
		a499: 'Mesej penjual',
		a500: 'Sila tunggu sebentar sementara data borang sedang diambil. . . ',
		a501: `<div class="Section0" style="layout-grid:15.6000pt;"><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:center;line-height:12.0000pt;background:rgb(255,255,255);"><b><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:21.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="黑体">ShopsBu Privacy Policy</font></span></b><b><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:11.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><o:p></o:p></span></b></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Release date: October 15, 2025 &nbsp;&nbsp;；Effective Date: October 15, 2025</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Thank you for visiting the e-commerce business management platform of Guangzhou Xiangrong Information Technology Co., Ltd. (hereinafter referred to as "us" or "ShopsBU"). This policy applies to Guangzhou Xiangrong Information Technology Co., Ltd., which provides products and services for ShopsBU. We attach great importance to the privacy and personal information security protection of our users (hereinafter referred to as "you"). We will strictly comply with legal and regulatory requirements, take corresponding security measures, and do our best to protect your personal information and privacy security. In view of this, we have formulated this "ShopsBU Privacy Policy" (hereinafter referred to as "this policy") and draw your attention to:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">This policy applies to all functions and services provided by our store's e-commerce business management platform. Please carefully read and thoroughly understand this policy before using the various functions or services we provide. Only after confirming full understanding and agreement can you start using them.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">To protect your relevant rights, this policy will explain to you how Dianxiaosheng's products and services will collect, use, and store your personal information, and what rights you have. Please read, understand, and agree to this policy before using Dianxiaosheng's products and services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Before using our products and services, please carefully read and thoroughly understand this privacy policy. Only after confirming that you fully understand and agree can you start using it. We will check and update our policies from time to time. Please visit this page regularly to ensure that you are aware of the latest version of our privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">By using or continuing to use products and services related to Dianxiaosheng, you agree to our collection, use, storage, and sharing of your information in accordance with this privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">This privacy policy will help you understand the following:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1、 How do we collect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2、 How we use your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3、 How do we share and disclose your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4、 How do we store your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5、 How do we protect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6、 Your rights</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7、 How do we handle the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">8、 How can your personal information be transferred globally</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">9、 How do we use cookies and similar technologies</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">10、 Changes to this policy</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">11、 Contact Us</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1、 How do we collect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">In order to provide services to you and enterprise users, optimize our services, and ensure account security, Dianxiaosheng will collect information that you voluntarily provide, authorize, or generate due to the use of the service when registering or using it in the following ways:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you register an account on the platform or log in to an existing account: We will collect your email address, phone number, login password, name, and country;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you use the waybill query function on the platform, we will collect your waybill number and logistics tracking information;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you use this platform for product order distribution and shipping, we will collect your store name, product information, and shipping address. After obtaining your permission, we will collect the names, phone numbers, addresses, and order information of buyers on your platform from third-party e-commerce platforms such as TEMU and Tiktok Shop (including package information, order items, prices, ordering time, shipping time, etc.);</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Please understand that the functions and services we provide to you are constantly updated and developed. If a certain function or service is not mentioned in the above description and has collected your information, we will separately explain the content, scope, and purpose of the information collection to you through page prompts, interaction processes, website announcements, etc., in order to obtain your consent.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2、 How we use your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">The data we collect during the provision of services to you may be used in the following ways:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Provide services to you. We will collect and store certain types of information about your use of this website. Our purpose of collecting this information is to improve the operation of the website, enable us to provide services, and accurately evaluate the website's performance;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Use your personal information to communicate with you. You may receive notifications from us via email or mobile push notifications you submit, such as when the status of your package changes or when we launch new services, promotions, etc. You can unsubscribe at any time;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Assist us in designing new services and improving our existing services;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Allow you to participate in surveys related to our products and services, conduct market activities related to our services, and push you the latest market activity information and discount plans;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Assist national judicial, administrative, security and other authorities in conducting investigations, and comply with applicable laws, regulations and other obligations promised to the authorities.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3、 How do we share and disclose your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will not sell, rent, trade or otherwise disclose your personal information to anyone under any circumstances, except in the following special circumstances:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Service providers and suppliers: In order to manage, supply, and improve the services of our store staff, as well as for marketing purposes, we may disclose personal information, including transaction information, to service providers and suppliers. Such as logistics companies, suppliers, and payment service providers, data storage and management suppliers, marketing and promotion suppliers, and suppliers that send email and SMS notifications. Used to help us improve our services and products.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Protecting legitimate rights and other legal purposes: We may be required to disclose information, such as being summoned, appearing in court, or being asked by law enforcement officers to conduct investigations, or any other legal requirement for us to disclose such information. We will also disclose personal information when necessary to protect our legal rights or to enforce our terms of use and other agreements. ShopsBUs may provide your personal information based on search warrants, subpoenas, or other lawful and effective inquiries or orders, or other requirements of applicable laws.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Merger and/or sale of assets: We usually do not sell, trade, or rent your personal information to any third-party company in the normal course of business. However, we may acquire, merge, or be acquired by another company, or we may dispose of some or all of our assets, in which case your personal information may be disclosed to another company, subject to compliance with privacy policies.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4、 How do we store your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Your personal information will be transferred and stored in Amazon Cloud, while other personal information will be transferred and stored on Tencent Cloud servers in the United States. Unless required or permitted by law for a longer retention period, we will retain the information collected from or about you for the shortest period of time necessary to achieve the purposes described in this privacy policy. When the information is no longer needed for these purposes, we will delete it or save it in a form that does not identify you. When determining this retention period, we will consider various criteria, including the type of service you request or provide, the nature of our relationship with you, the impact on the services we provide to you if we delete certain information about you, and the retention period required by law. Please note that once you successfully apply to cancel your ShopsBU account, we will complete the review of your account cancellation as soon as possible. After the application is approved, we will completely delete your personal data. If we cease to operate our products or services, we will notify you in the form of individual deliveries or announcements, and delete your personal data after ceasing to operate our products and services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5、 How do we protect your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We have implemented industry standard security measures to protect the personal data you provide from unauthorized access, public disclosure, use, modification, damage, or data loss. We will take the following reasonable and feasible measures to protect your personal data:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use encryption technology to ensure the confidentiality of data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use trusted protection mechanisms to prevent malicious attacks on data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We have deployed access control mechanisms to ensure that only authorized personnel can access personal data, and we have organized security and privacy training courses to raise employees' awareness of the importance of protecting personal data;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will use secure encryption technology to protect your personal data during transmission. Take all appropriate organizational, managerial, and technical measures to protect the security of the personal data you provide within our internal organization.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our physical, technical, or management safeguards are violated, resulting in unauthorized access, public disclosure, alteration, or destruction of data that damages your legal rights, we will be held responsible. After the unfortunate occurrence of a personal data security incident, we will promptly inform you of the requirements of laws and regulations: the basic situation and possible impact of the security incident, the disposal measures we have taken or will take, as well as suggestions for you to independently prevent and reduce risks, remedial measures taken for you, etc. We will promptly notify you of the situation related to the event through email, letter, phone, push notifications, and other means.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Although our business aims to protect your personal information, please understand that there is currently no 100% security anywhere, whether online or offline. The ShopsBU account requires a username and password to log in. Please protect your username and password and never disclose them to third parties.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6、 Your rights</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">According to the relevant laws, regulations, and standards in your local area, as well as the prevailing practices in other countries and regions, we guarantee that you exercise the following rights over your personal data. You have the right to demand that we:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">1. Accessing your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You have the right to access your personal information, except for exceptions provided by laws and regulations. If you want to exercise your data access rights, you can access them yourself through the following methods:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Account information: If you wish to access or edit personal profile information in your account.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can log in to your store's Xiaosheng platform account through: personal homepage → click on the avatar in the upper right corner → click on "personal information" → browse your nickname, phone number, country, and email;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2. Correct your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">When you discover errors in the personal information we process about you, you have the right to request us to make corrections. You can submit a correction request through the methods listed in "1. Accessing Your Personal Information".</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are unable to correct these personal information through the above link, you can contact us using the contact information listed in Chapter 11 of this Privacy Policy. We will reply to your correction request within 5-7 working days.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3. Delete your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">In the following situations, you can request the deletion of personal information by sending us an email:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our handling of personal information violates laws and regulations;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we collect and use your personal information without your consent;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If our handling of personal information violates our agreement with you;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you no longer use our products or services, or if you cancel your account;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we no longer provide you with products or services.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we decide to respond to your deletion request, we will also notify the entities that have obtained your personal information from us to delete it in a timely manner, unless otherwise provided by laws and regulations, or if these entities have obtained your independent authorization.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">4. Cancel your account</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can cancel the previously registered account at any time. You can send us an account cancellation application email using the contact information listed in Chapter 11 of this privacy policy. We will reply and take relevant actions within 5-7 working days after verifying your identity. After canceling your account, we will cease providing you with products or services and immediately delete your personal information.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">5. Obtain a copy of your personal information</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You have the right to obtain a copy of your personal information. If you need to obtain a copy of the personal information we have collected from you, you can contact us using the contact information listed in Chapter 11 of this privacy policy. We will reply and take relevant actions within 5-7 working days after verifying your identity. We will submit a copy of your personal information to you via email. Subject to compliance with relevant legal regulations and technical feasibility, we will provide you with a copy of your personal information upon your request.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">6. Consumer Rights of California Residents</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">According to the California Consumer Privacy Act, California residents have the right to know, access, and delete their personal data. California residents also have the right to choose not to allow businesses to sell their personal data, as well as the right not to be discriminated against for exercising California's privacy rights. We will not sell your personal data to anyone for any purpose, nor will we discriminate in responding to privacy requests.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are a resident of California, please be sure to review this privacy policy for important information regarding your rights under California privacy laws and how to submit requests to us based on these rights.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7. Responding to your above request</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will respond to the above request within 5-7 working days. Please refer to Chapter 11 of this Privacy Policy for contact information.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will not be able to respond to your request in the following situations:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests related to the fulfillment of legal and regulatory obligations by personal information controllers;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to national security and defense security;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to public safety, public health, and major public interests;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests directly related to criminal investigation, prosecution, trial, and execution of judgments;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">The personal information controller has sufficient evidence to indicate that the personal information subject has subjective malice or requests for abuse of rights;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests made to safeguard the significant legitimate rights and interests of personal information subjects or other individuals, such as life and property, but with difficulty in obtaining their consent;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Responding to a request from a personal information subject would result in serious harm to the legitimate rights and interests of the personal information subject or other individuals or organizations;</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Requests involving trade secrets.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">7、 How do we handle the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We expect parents or guardians to guide minors in using our services</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you are a minor under the age of 14, you should read and agree to this policy under the supervision and guidance of your parents or other guardians before using our products.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">2. We attach great importance to protecting the personal information of minors</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We protect the personal information of minors in accordance with relevant laws and regulations. In the case of collecting personal information of minors with the consent of parents, we will only use, share or publicly disclose this information when permitted by law, with the explicit consent of parents or guardians, or when necessary to protect minors.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">3. Self inspection and receiving feedback</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If we find that we have collected personal information of minors without obtaining verifiable parental consent in advance, we will try to delete the relevant data as soon as possible. At the same time, we have established strict rules for the collection and use of underage information to protect the personal information security of children and adolescents. If you are the guardian of a minor and have any questions about the personal information of the minor under your guardianship, please contact us through the contact information disclosed in this policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">8、 How can your personal information be transferred globally</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We are committed to adhering to the highest privacy protection standards in the processing and transfer of personal information worldwide. When you use our services, your personal information may be transferred to servers located on Tencent Cloud. This type of international transfer will follow strict data protection and privacy security measures to ensure the same level of privacy protection as we provide locally to you.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">For personal information transferred to Tencent Cloud servers located in Guangzhou, China, we comply with relevant privacy and data protection laws in China and the United States, including but not limited to ensuring that there are corresponding security measures in place, such as encryption and access control, to safeguard data security and privacy. In addition, we will monitor relevant legal changes to ensure that our practices can adapt to these changes in a timely manner and safeguard users' privacy rights.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We will transfer personal information of EU users in accordance with the requirements of the EU General Data Protection Regulation (GDPR). This means that when personal information leaves the European Union and economic regions, we will transfer it by adopting standard contractual terms recognized by the European Commission or when there is sufficient data protection in the receiving country. We promise to regularly evaluate the data protection level of the receiving country and ensure the effective implementation of protection measures.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you have any questions or need assistance regarding the cross-border transfer of your personal information, please contact us.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">9、 How do we use cookies and similar technologies</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">We use cookies and other similar technologies to enhance your experience using this service. When you use this service, we may use relevant technologies to send one or more cookies or anonymous identifiers to your device to collect and store information about your access and use of this service. We promise not to use cookies for any purposes other than those described in this privacy policy. We use cookies and similar technologies mainly to achieve the following functions or services:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Accelerate navigation</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Track website usage</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Identify user identity, access permissions, and preferences</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Conduct research and diagnosis to improve our content, products, and services</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">You can refuse or manage cookies or data analytics tools through your browser settings. However, please note that if cookies or data analytics tools are disabled, you may not be able to enjoy the best service experience, and some services may not function properly.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">10、 Changes to this policy</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">To ensure that you are always aware of how we collect, use, and disclose your information, we will post any changes or updates to this privacy policy on this website and encourage you to review this privacy policy from time to time. If we change this privacy policy, we will notify you by modifying the date at the top of this privacy policy.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">11、 Contact Us</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Please protect your personal information properly and only provide it to others when necessary. If you discover that your personal information has been leaked, especially the username and password of this application, please contact the customer service of this application immediately so that this application can take corresponding measures.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">If you have any questions about this policy or other related matters, please contact us through https://erp.shopsbu.com// Contact us. You can also send your questions to https://erp.shopsbu.com/ Or send it to the following address:</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Address: 1st Floor, Federal Building, No. 30 Caotang Road, Panyu District, Guangzhou City (Address)</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;text-autospace:ideograph-numeric;mso-pagination:widow-orphan;
		text-align:left;line-height:12.0000pt;background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="黑体">Postal code: 510520.</font></span><span style="mso-spacerun:'yes';font-family:黑体;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p></o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" align="center" style="margin-top:37.5000pt;margin-bottom:18.7500pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:center;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">隐私政策</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:21.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">发布日期：</font>202</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">5</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">年</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">10</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">月</font>15日</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">生效日期：</font>202</span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">5</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">年</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">10</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">月</font>15日</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">感谢您访问</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">广州向榕信息科技有限公司</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">电商业务管理平台（以下称</font><font face="system">“我们”或“</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">”）。本政策适用于提供</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">产品和服务的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">广州向榕信息科技有限公司</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">。</font> <font face="system">我们非常重视用户（下称</font><font face="system">“您”）的隐私和个人信息安全保护，我们将严格按照法律法规要求，采取相应安全保护措施，尽力保护您的个人信息及隐私安全。鉴于此，我们制定本《</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">隐私政策》（下称</font><font face="system">“本政策”）并提请您注意：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">本政策适用于我们提供的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">电商业务管理平台所提供的所有的功能和服务。请您在使用我们提供的各项功能或服务前，务必仔细阅读并透彻理解本政策，在确认充分理解并同意后再开始使用。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为保障您的相关权利，本政策将向您说明</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务会如何收集、使用和存储您的个人信息及您享有何种权利，请您在使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务之前，阅读、了解并同意本政策。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">产品服务前，请您务必仔细阅读并透彻理解本隐私政策，在确认充分理解并同意后再开始使用。我们会不时地检查并更新我们的政策，请您定期光顾本页面，以确保对最新版本隐私政策的了解。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您使用或继续使用</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">相关产品与服务，都表示您同意我们按照本隐私政策收集、使用、储存和分享您的信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">本隐私政策将帮助您了解以下内容：</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">一、</font> <font face="system">我们如何收集您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">二、</font> <font face="system">我们如何使用您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">三、</font> <font face="system">我们如何共享、披露您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">四、</font> <font face="system">我们如何存储您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">五、</font> <font face="system">我们如何保护您的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">六、</font> <font face="system">您的权利</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">七、</font> <font face="system">我们如何处理未成年人的个人信息</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">八、</font> <font face="system">您的个人信息如何在全球范围转移</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">九、我们如何使用</font>Cookie和同类技术</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">十、</font> <font face="system">本政策的变更</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:15.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">十一、联系我们</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">一、我们如何收集您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为了向您和企业用户提供服务、优化我们的服务以及保障帐号安全，</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">会按照如下方式收集您在注册、使用服务时主动提供、授权或因为使用服务而产生的信息：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您在平台注册账号或登录现有帐户：我们将收集您的电子邮箱地址、手机号码、登陆密码、姓名、国家；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您在平台使用运单查询功能时，我们将收集您的运单号与物流跟踪信息；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l1 level1 lfo1;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您使用本平台进行产品订单配货发货时我们将收集您的店铺名称、商品信息、发货地址。我们通过您的准许后会从</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">TEMU</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">，</font>Tiktok Shop等第三方电商凭他平台收集您所在平台买家的姓名、电话、地址与订单信息（包括：包裹信息、订单商品、价格、商品下单时间、发货时间等）；</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:18.0000pt;
		mso-para-margin-left:0.0000gd;mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
		mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p>&nbsp;</o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们通过页面提示，交互流程，网站公告等方式另行向你说明信息收集的内容、范围和目的，以征得您的同意。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">二、我们如何使用您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们在向您提供服务过程中收集的数据可能会以以下方式使用：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">向您提供服务。我们会收取并存储有关您使用本网站的某些类型的信息。我们收集这些信息的目的是为了让网站更好的运作、使我们能够提供服务、正确的评估网站的运行情况；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">使用您的个人信息与您沟通。您可能会收到我们通过您提交的电子邮件或者手机推送的通知，例如：当您的包裹状态发生改变或者我们有新服务上线、促销等。您可以随时取消订阅；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">帮助我们设计新服务，改善我们现有服务；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">让您参与有关我们产品和服务的调查，开展与服务相关的市场活动，向您推送最新的市场活动信息及优惠方案；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l2 level1 lfo2;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">协助国家司法、行政、安全机关等权利机构开展调查，并遵守适用法律法规及其他向有权机构承诺之义务。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">三、我们如何共享、披露您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们不会以任何情形出售、出租、交易或以其他方式向任何人披露您的个人信息，以下特殊情况下除外：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">服务提供商和供应商：为了管理、供应和改进</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">的服务以及出于市场营销目的，我们可能会向服务提供商和供应商披露包括交易信息在内的个人信息。如物流公司、供应商和支付服务提供商，数据存储和管理供应商、营销和促销供应商、发送电子邮件和</font>SMS通知的供应商。用于帮助我们改进服务、产品。</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">保护合法权利和其他法定目的：我们可能被要求披露信息，如被传唤、法院出庭或被执法机关人员要求进行调查，或者其它任何一切由法律要求我们披露这些信息。</font> <font face="system">我们还会在必要时披露个人信息，以保护我们的合法权利或执行我们的使用条款和其他协议。</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">可能会根据搜查令，传票或其他合法有效的查询或命令或适用法律的其他要求提供您的个人信息。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l5 level1 lfo3;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">合并和</font>/或出售资产：我们通常不会在正常经营过程中向任何第三方公司出售、交易、出租您的个人信息。但是，我们可能会收购、合并或被另一家公司收购，或者我们可能会处置部分或全部资产，在这种情况下，您的个人信息可能会被披露给另一家公司，但须遵守隐私政策 有效。</span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">四、我们如何存储您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您的个人信息将被传输并存储</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">亚马逊云</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">中，其他个人信息将被传输并存储美国腾讯云服务器中。除非法律要求或允许更长的保留期，否则我们将在实现本隐私政策所述目的所需的最短时间内保留从您处收集的或关于您的信息。当信息不再需要用于这些目的时，我们会将其删除或以不识别您身份的形式保存。在确定此保留期时，我们会考虑各种标准，包括您请求或提供的服务类型、我们与您关系的性质、如果我们删除您的某些信息，对我们向您提供的服务的影响，以及法律要求的保留期。请注意，当您申请注销您的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">账户成功后，我们将尽快完成对您账户注销的审查。申请获得批准后，我们将完全删除的您的个人数据。如果我们停止经营产品或服务，我们将以逐一交付或公告的形式通知您，并在停止经营产品和服务后删除您的个人数据。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">五、我们如何保护您的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们采取的安全措施我们使用了行业标准的安全措施来保护您提供的个人数据免受未经授权的访问、公开披露、使用、修改、损坏或数据丢失。我们将采取以下合理可行的措施来保护您的个人数据：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用加密技术来确保数据的机密性；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用可信的保护机制来防止对数据的恶意攻击；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们部署了访问控制机制，以确保只有授权人员才能访问个人数据，我们举办了安全和隐私培训课程，以提高员工对保护个人数据重要性的认识；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l6 level1 lfo4;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们将使用安全加密技术在传输过程中保护您的个人数据。采取一切适当的组织、管理和技术措施，保护您在我们内部组织中提供的个人数据的安全。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们的物理、技术或管理保障措施被违反，导致未经授权访问、公开披露、更改或破坏数据，从而损害您的合法权利，我们将承担责任。在个人数据安全事件不幸发生后，我们将及时告知您法律法规的要求：安全事件的基本情况和可能产生的影响，我们已经或将要采取的处置措施，以及您可以独立预防和降低风险的建议，为您采取的补救措施等。我们将通过电子邮件、信函、电话、推送通知等方式及时通知您与事件相关的情况。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">虽然我们的业务旨在保护您的个人信息，但请理解，目前在任何地方都不存在</font>100％的安全性，无论线上或线下。 </span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">帐户需要用户名和密码才能登录。请保护好您的用户名和密码，绝不向第三方透露。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">六、您的权利</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">根据您当地的相关法律、法规和标准以及其他国家和地区的通行做法，我们保证您对您的个人数据行使以下权利。您有权要求我们</font>:</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">1.访问您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">账户信息</font>:如果您希望访问或编辑您的账户中的个人资料信息。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您可以登陆您的</font></span><span style="mso-spacerun:'yes';font-family:宋体;mso-ascii-font-family:system;
		mso-hansi-font-family:system;mso-bidi-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="宋体">店小生</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">平台账号通过：个人主页</font><font face="system">→点击右上角头像→点击「个人资料」→浏览您的昵称、手机号码、国家、邮箱；</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">2.更正您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过</font><font face="system">“1.访问您的个人信息”中罗列的方式提出更正申请。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您无法通过上述链接更正这些个人信息，您可按照本《隐私政策》第十一章中列明的联系方式与我们联系。我们将在</font>5-7个工作日内回复您的更正请求。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">3.删除您的个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在以下情形中，您可以通过发送邮件向我们提出删除个人信息的请求：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们处理个人信息的行为违反法律法规；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们收集、使用您的个人信息，却未征得您的同意；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们处理个人信息的行为违反了与您的约定；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您不再使用我们的产品或服务，或您注销了账号；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l0 level1 lfo5;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们不再为您提供产品或服务。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">4.注销您的账户</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您随时可注销此前注册的账户。您可按照本隐私政策第十一章中列明的联系方式向我们发送账号注销申请邮件，我们将在验证您身份后的</font>5-7个工作日内回复并进行相关操作。在注销账户之后，我们将停止为您提供产品或服务，并立即删除您的个人信息。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">5. 获取您的个人信息副本</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您有权利获得您的个人信息副本。如您需要获取我们收集的您的个人信息副本您可按照本隐私政策第十一章中列明的联系方式与我们联系，我们将在验证您身份后的</font>5-7个工作日内回复并进行相关操作。我们会将个人信息副本通过邮件的形式提交给您。在符合相关法律规定且技术可行的前提下，我们将会根据您的要求向您提供您的个人信息副本。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">6. 加州居民消费者权益</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">根据《加州消费者隐私法》，加州居民有权了解、访问和删除他们的个人数据。加州居民也有权选择不让企业出售他们的个人数据，也有权不因行使加州隐私权而受到歧视。我们不会出于任何目的将您的个人数据出售给任何人，也不会在回应隐私权请求时进行歧视。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您是加州居民，请务必查看本隐私政策，了解有关您在加州隐私法下的权利以及如何根据这些权利向我们提交请求的重要信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">7. 响应您的上述请求</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">对于以上请求，我们将在</font>5-7个工作日内做出答复，联系方式请见本隐私政策第十一章节。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">在以下情形中，我们将无法响应您的请求：</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与个人信息控制者履行法律法规规定的义务相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与国家安全、国防安全直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与公共安全、公共卫生、重大公共利益直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">与犯罪侦查、起诉、审判和执行判决等直接相关的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的请求；</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l4 level1 lfo6;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">涉及商业秘密的请求。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">七、我们如何处理未成年人的个人信息</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">1. 我们期望父母或监护人指导未成年人使用我们的服务</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">若您是未满</font>14周岁的未成年人，在使用我们的产品前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">2.我们重视保护未成年人个人信息</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们根据相关法律法规的规定保护未成年人的个人信息，对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享或公开披露此信息。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);">3. 自查与接收反馈</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。同时我们建立了严格的未成年人信息收集使用规则，以保护儿童和青少年个人信息安全。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策公示的联系方式与我们联系。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">八、您的个人信息如何在全球范围转移</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们在全球范围内对个人信息的处理与转移承诺遵守最高的隐私保护标准。当您使用我们的服务时，您的个人信息可能会被转移到位于腾讯云服务器上。此类国际转移将遵循严格的数据保护和隐私安全措施，确保与我们在您本地提供的隐私保护同等水平。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">对于转移到位于中国广州的腾讯云服务器上的个人信息，我们遵循中国与美国的相关隐私和数据保护法律，包括但不限于，确保有相应的安全措施存在，如加密和访问控制，以保障数据的安全与隐私。此外，我们还将监控相关的法律变动，确保我们的做法能够及时适应这些变化，维护用户的隐私权益。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">针对欧盟用户的个人信息，我们将依照欧盟通用数据保护条例（</font>GDPR）的要求进行数据转移。这意味着当个人信息离开欧盟及经济区域时，我们将通过采用欧盟委员会认可的标准合同条款或在接收国有足够的数据保护水平时进行转移。我们承诺会定期评估接收国的数据保护水平，并确保保护措施的有效执行。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">如果您对于您的个人信息跨境转移有疑问或需要帮助，请与我们联系。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">九、我们如何使用</font>Cookie和同类技术</span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">我们使用</font>Cookie和其他类似技术，以提升您使用本服务的体验。当您使用本服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本服务时的信息。我们承诺，不会将Cookie用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie和同类技术主要为了实现以下功能或服务：</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">加速导航</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">追踪网站使用情况</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">辨别用户身份、访问权限及偏好</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:5.0000pt;margin-bottom:5.0000pt;margin-left:36.0000pt;
		mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;text-indent:-18.0000pt;
		tab-stops:left blank 36.0000pt ;mso-pagination:widow-orphan;mso-list:l3 level1 lfo7;"><!--[if !supportLists]--><span style="font-family:Symbol;mso-fareast-font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><span style="mso-list:Ignore;">·<span>&nbsp;</span></span></span><!--[endif]--><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:1.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">进行研究和诊断以改善我们的内容、产品和服务</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">您可以通过的浏览器设置拒绝或管理</font>cookies或数据统计工具。但请注意，如果停用cookies或数据统计工具，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">十、本政策的变更</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="p" style="margin-top:0.0000pt;margin-right:0.0000pt;margin-bottom:3.7500pt;
		margin-left:0.0000pt;text-indent:0.0000pt;mso-pagination:widow-orphan;
		background:rgb(255,255,255);"><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;background:rgb(255,255,255);
		mso-shading:rgb(255,255,255);"><font face="system">为了确保您随时了解我们如何收集、使用和披露您的哪些信息，我们将在本网站上发布本隐私政策的任何更改或更新，并鼓励您不时查看本隐私政策。</font> <font face="system">如果我们更改本隐私政策，我们会通过修改本隐私政策顶部的日期来通知您。</font></span><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:12.0000pt;mso-font-kerning:0.0000pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-top:22.5000pt;margin-bottom:7.5000pt;margin-left:0.0000pt;
		text-indent:0.0000pt;mso-pagination:widow-orphan;text-align:left;
		background:rgb(255,255,255);"><b><span class="16" style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:0.0000pt;
		background:rgb(255,255,255);mso-shading:rgb(255,255,255);"><font face="system">十一、联系我们</font></span></b><b><span style="mso-spacerun:'yes';font-family:system;color:rgb(51,51,51);
		letter-spacing:0.0000pt;font-weight:bold;text-transform:none;
		font-style:normal;font-size:12.0000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></b></p><p class="MsoNormal"><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">如您对本政策或其他相关事宜有疑问，请通过</font><font face="微软雅黑">&nbsp;</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">https://erp.shopsbu.com//</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">&nbsp;与我们联系。您也可将您的问题发送至</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">https://erp.shopsbu.com/</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">或寄到如下地址：</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">地址：</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">广州市</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">番禺区草堂路</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">30号</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;"><font face="宋体">联邦大厦一楼</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">&nbsp;（收）</font></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><br></span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">邮编：</font></span><span class="15" style="mso-spacerun:'yes';font-family:宋体;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;">510520</span><span style="mso-spacerun:'yes';font-family:微软雅黑;color:rgb(0,0,0);
		letter-spacing:0.0000pt;text-transform:none;font-style:normal;
		font-size:10.5000pt;mso-font-kerning:1.0000pt;"><font face="微软雅黑">。</font></span><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
		mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;"><o:p></o:p></span></p></div>`,
		a502: 'Kenal pasti pembayaran kod pembayaran',
		a503: 'Jumlah cas semula',
		a504: 'Jumlah yang sebenarnya dibayar',
		a505: 'Pulangan tunai',
		a506: 'Masa penggunaan',
		a507: 'Terus log in',
		a508: 'Pembayaran kod imbasan WeChat',
		a509: 'Selepas pengguna berjaya mengecas semula, sila hubungi perkhidmatan pelanggan platform untuk memberikan maklumat mengenai pembukaan kedai tempatan dan perkara berkaitan!',
		a510: 'Perkhidmatan Pelanggan WeChat',
		a511: 'Pesanan resit',
		a512: 'Cetak sekarang',
		a513: 'Muat naik borang logistik head-to-head',
		a514: 'Hanya fail jpg/png boleh dimuat naik, dan tidak melebihi 8M',
		a515: 'Nombor pesanan storan',
		a516: 'Nombor kes',
		a517: 'Alamat',
		a518: 'Penerima',
		a519: 'Telefon',
		a520: 'Log Masuk E-mel',
		a521: 'Nombor telefon',
		a522: 'Kata laluan mesti terdiri daripada lebih daripada 6 aksara',
		a523: 'Sila masukkan e-mel anda! ',
		a524: 'Sila masukkan alamat e-mel yang betul! ',
		a525: 'Sila isi maklumat akaun! ',
		a526: 'Kata laluan yang dimasukkan dua kali tidak konsisten! ',
		a527: 'Sila masukkan nombor telefon! ',
		a528: 'Sila masukkan kod pengesahan e-mel! ',
		a529: 'Sila masukkan alamat e-mel atau nama penjual! ',
		a530: 'Pilih wilayah',
		a531: '(diperlukan)',
		a532: 'Akaun gudang',
		a533: 'Nama gudang',
		a534: 'Kata laluan gudang',
		a535: 'Kod pengesahan e-mel',
		a536: 'Isikan akaun gudang',
		a537: 'Isikan nama gudang',
		a538: 'Kata laluan gudang mestilah sekurang-kurangnya 6 aksara, gabungan huruf, nombor dan aksara',
		a539: 'Salin dan kongsi pautan pendaftaran eksklusif anda. Sebaik sahaja penjual yang dijemput mengecas semula, 1% daripada jumlah akan dikembalikan ke akaun anda serta-merta. Penjual yang dijemput juga boleh menerima mata bonus 10 yuan serta-merta. Semua mata boleh digunakan untuk pengedaran, perolehan, logistik Penggunaan dan gudang luar negara, dsb. Kongsikan dengan rakan-rakan penjual anda untuk mencipta pasaran merentasi sempadan',
		a540: 'Jemput pengguna untuk mendaftar pautan',
		a541: 'Salin pautan',
		a542: 'Jemput pautan pengguna',
		a543: 'Akaun tidak normal, sila hubungi khidmat pelanggan! ',
		a544: 'Berjaya disalin',
		a545: 'Sistem pengurusan rentas sempadan',
		a546: 'Mengikat persatuan',
		a547: 'Fokus untuk melayani penjual tempatan di Asia Tenggara',
		a548: 'Akaun niche kedai gabungan',
		a549: 'Sila masukkan akaun Xiaosheng anda',
		a550: 'Sambung sekarang',
		a551: 'Pengurusan Kebenaran',
		a552: 'Rakan Kongsi Rasmi',
		a553: 'Tahniah, kebenaran kedai berjaya, sila pilih operasi yang akan anda lakukan!',
		a554: 'Pergi ke laman utama',
		a555: 'Semak pesanan',
		a556: 'Import Produk',
		a557: 'Produk Stok',
		a558: 'Berjaya mendaftar, pergi ke halaman log masuk! ',
		a559: 'Pengurusan tera air',
		a560: 'Memulihkan imej asal',
		a561: 'Gunakan semua imej',
		a562: 'Hanya gunakan imej semasa',
		a563: 'Sahkan pulangan',
		a564: 'Adakah anda pasti mahu terus memadamkan tera air? ',
		a565: 'Berjaya dipadamkan! ',
		a566: 'kepunyaan gudang',
		a567: 'Kuantiti Hadiah',
		a568: 'Produk tidak terikat',
		a569: 'Titik',
		a570: 'Pesanan telah memulakan aduan dan tuntutan kepada gudang, menunggu gudang memproses! ',
		a571: 'Sila sahkan maklumat berikut',
		a572: 'Masukkan kata-kata kepada penjual (pilihan)',
		a573: 'Sila isikan mesej gudang (diperlukan)',
		a574: 'Masukkan nombor pesanan untuk mencari',
		a575: 'Pesanan aduan akan diproses oleh gudang',
		a576: 'Setuju dengan aduan penjual ini bahawa bilangan mata akan ditolak',
		a577: 'Sila isi mata yang gudang sanggup bayar',
		a578: 'Butiran Rayuan',
		a579: 'Mesej gudang',
		a580: 'Mesej platform',
		a581: 'Pusat Aduan Gudang Luar Negara',
		a582: 'Carian pesanan',
		a583: 'Status pesanan',
		a584: 'Pesanan dibayar',
		a585: 'Anggaran mata pembayaran',
		a586: 'Nama spesifikasi',
		a587: 'Kuantiti',
		a588: 'Masa pesanan',
		a589: 'Masa pembayaran',
		a590: 'Masa Cetak',
		a591: 'Masa berlepas',
		a592: 'Nama kedai',
		a593: 'Kaedah Penghantaran',
		a594: 'Nombor bil laluan',
		a595: 'Jenis platform',
		a596: 'Dibayar',
		a597: 'Setuju',
		a598: 'Berunding',
		a599: 'Menunggu platform untuk memproses',
		a600: 'Semak butiran',
		a601: 'Sila isikan sebab penolakan!',
		a602: 'Berjaya diserahkan!',
		a603: 'Tambah produk baharu',
		a604: 'Tetapkan semula pesanan',
		a605: 'Kembali',
		a606: 'Stok di gudang',
		a607: 'Ubah',
		a608: 'Adakah anda pasti ingin memadam? ',
		a609: 'Item pesanan berjaya diubah suai! ',
		a610: 'Tetapkan semula kepada pesanan asal! ',
		a611: 'Pesanan ciptaan pengguna',
		a612: 'Buat Pesanan',
		a613: 'Isikan maklumat penerima',
		a614: 'Tambah produk gudang',
		a615: 'Anggaran jumlah volum',
		a616: 'Anggaran Berat Kasar',
		a617: 'Apabila jenis gudang',
		a618: 'Anggaran bayaran kurier',
		a619: 'Pilih logistik:',
		a620: 'Berat pertama',
		a621: 'Kos berat pertama',
		a622: 'Yuran pembaharuan',
		a623: 'Kaedah pengebilan',
		a624: 'Nota pesanan',
		a625: 'Tinggalkan mesej kepada gudang:',
		a626: 'Poskod',
		a627: 'Sila pilih negara',
		a628: 'Wilayah',
		a629: 'Bandar',
		a630: 'Alamat',
		a631: 'Isipadu (L*W*H/cm)',
		a632: 'Berat/KG',
		a633: 'Kuantiti beli',
		a634: 'Sila pilih logistik',
		a635: 'Mengikut berat',
		a636: 'Mengikut kelantangan',
		a637: 'Ambil berat/berat isipadu yang lebih besar',
		a638: 'Sila masukkan penerima',
		a639: 'Sila masuk wilayah',
		a640: 'Sila masukkan nombor telefon',
		a641: 'Sila isi bandar',
		a642: 'Sila masukkan wilayah',
		a643: 'Sila masukkan alamat terperinci penerima',
		a644: 'Sila pilih negara',
		a645: 'Produk untuk membuat pesanan binaan sendiri mesti lalai kepada produk di gudang yang sama! ',
		a646: 'Produk gudang pendua sudah wujud! ',
		a647: 'Sila tambah produk pada pesanan anda! ',
		a648: 'Pesanan yang dibina sendiri telah berjaya dibuat! Mengembalikan pesanan untuk disemak! ',
		a649: 'Kandungan dengan langit berbintang merah diperlukan! ',
		a650: 'Sila pilih jenis produk',
		a651: 'Sila pilih gudang penghantaran',
		a652: 'Menambah barang',
		a653: 'Pilih gudang',
		a654: 'Anda boleh memasukkan nama produk dan sku untuk mencari',
		a655: 'Gudang yang sedang diaudit',
		a656: 'Hanya inventori tempat akan diluluskan secara automatik, dan ia tidak akan diluluskan secara automatik jika tiada produk import di gudang atau stok adalah 0 di gudang',
		a657: 'Imej utama',
		a658: 'Pada masa ini tiada pilihan sku',
		a659: 'Gudang ibu sku',
		a660: 'Bilangan anak sku',
		a661: 'Pilih SKU',
		a662: 'Sila ambil perhatian: Jika produk terikat sebagai gudang SKU maya, produk ini tidak akan diisih lagi. Fungsi ini sesuai untuk tetapan seperti hadiah maya. ',
		a663: 'Ikat sku maya',
		a664: 'Ikat produk inventori',
		a665: 'Berjaya diubah suai! ',
		a666: 'Sila tandakan produk',
		a667: 'Sila pilih SKU produk',
		a668: 'Pesanan mesti mengandungi sekurang-kurangnya satu item! ! !',
		a669: 'Sahkan pemadaman?',
		a670: 'Jenis gudang ialah gudang produk, sila pilih jenis produk! ! ! ! ',
		a671: 'Gudang ujian pada masa ini tidak menyokong fungsi semakan automatik, sila pilih semula jenis gudang! ',
		a672: 'Sila pilih gudang untuk semakan',
		a673: 'Nota maklumat pesanan:',
		a674: 'Maklumat pesanan ulasan kelompok',
		a675: 'Nota pesanan ditambahkan oleh penjual, dan hanya gudang dan penjual pada platform boleh melihatnya. Jika ia tidak diisi, ia lalai kepada tiada mesej penjual! ',
		a676: 'Mengikat kegagalan segera',
		a677: 'Sebab',
		a678: 'Buat pesanan bina sendiri dalam kelompok',
		a679: 'Muat turun templat import',
		a680: 'Seret fail excel ke sini, atau klik muat naik',
		a681: 'Sila tunggu sementara data sedang dimuatkan. . . ',
		a682: 'Pemuatan data selesai, sila muat semula halaman! ',
		a683: 'Antara pesanan yang anda pilih, selepas ditapis mengikut kuantiti inventori sebenar di gudang dan kesegeraan sehingga tarikh penghantaran',
		a684: 'Audit berjaya',
		a685: 'Semak butiran',
		a686: 'Menahan mata',
		a687: 'Kegagalan audit',
		a688: 'Sebab kegagalan',
		a689: 'Bayaran mata',
		a690: 'Masa penghantaran tarikh akhir',
		a691: 'Petunjuk sistem',
		a692: 'Resit sebenar(￥)-jumlah penghantaran anggaran harga',
		a693: 'Harga bekalan * kuantiti pembelian',
		a694: 'Pesanan segera yang boleh diluluskan',
		a695: 'Cadangan untuk pesanan kehabisan stok tidak diluluskan',
		a696: 'Pesanan semakan kelompok',
		a697: 'Hidupkan semakan automatik',
		a698: 'Segerakkan status pesanan',
		a699: 'Eksport kelompok',
		a700: 'Pesanan ucapan kelompok',
		a701: 'Pesanan manual yang dibina sendiri',
		a702: 'Buat pesanan manual tunggal',
		a703: 'Buat pesanan manual dalam kelompok',
		a704: 'APP Penjual',
		a705: 'Apl mudah alih di pihak penjual boleh merealisasikan pengurusan pesanan/pemulangan semakan dan sembang berbilang kedai Shopee, termasuk terjemahan automatik, balasan automatik, penukaran berbilang kedai, dsb.',
		a706: 'Pemilihan songsang',
		a707: 'Rekod',
		a708: 'Anggaran Keuntungan Kasar',
		a709: 'Jumlah harga bekalan',
		a710: 'Perintah pengedaran',
		a711: 'pembekal',
		a712: 'Sebab penarikan diri',
		a713: 'Tukar Pesanan',
		a714: 'Nota pesanan',
		a715: 'Padam senarai binaan sendiri',
		a716: 'Sila pilih pesanan! ',
		a717: 'Berjaya menyerahkan maklumat nota! ',
		a718: 'Serahkan pengecualian, dan cuba lagi selepas beberapa ketika! ',
		a719: 'Dihantar dengan jayanya! ',
		a720: 'Pada masa ini tiada pesanan mengejut yang boleh diluluskan! ',
		a721: 'Semakan automatik berjaya dimatikan! ',
		a722: 'Berjaya menghidupkan semakan automatik! ',
		a723: 'Selepas menyemak pesanan, semak semula! ',
		a724: 'Ulasan ini',
		a725: 'Dalam kuantiti pesanan, terdapat ',
		a726: 'Pesanan tidak boleh diaudit kerana pesanan tidak terikat atau gudang audit tidak konsisten. Adakah anda ingin terus mengaudit yang lain',
		a727: 'Pesanan? ',
		a728: 'Teruskan menyemak baki pesanan',
		a729: 'OKEY',
		a730: 'Semakan belum selesai',
		a731: 'COD (wang tunai semasa penghantaran)',
		a732: 'Berjaya diikat sebagai sku maya',
		a733: 'Pengikatan berjaya! ',
		a734: 'Produk inventori terikat pada masa ini:',
		a735: 'SKU ibu bapa',
		a736: 'Sub sku',
		a737: 'Buat masa ini tiada berita tentang produk stok terikat! ',
		a738: 'Sila ikat produk gudang sebelum melakukan operasi ini! ',
		a739: 'Adakah anda pasti mahu memulihkan pesanan? ',
		a740: 'Adakah anda pasti untuk menetapkan pakej kosong? ',
		a741: 'Persediaan berjaya! ',
		a742: 'Memaparkan pesanan akan menyambung semula pendudukan inventori dalam talian produk gudang. Adakah anda pasti akan menyahsembunyikan? ',
		a743: 'Menyembunyikan pesanan akan membatalkan pendudukan inventori dalam talian produk gudang. Adakah anda pasti untuk menyembunyikan pesanan ini? (paparan boleh dipulihkan)',
		a744: 'Pesanan telah dipaparkan',
		a745: 'Perintah itu tersembunyi',
		a746: 'Sila pilih pesanan untuk dieksport! ',
		a747: 'Kali ini akan mengeksport',
		a748: 'Butiran pesanan, adakah anda mahu terus mengeksport? ',
		a749: 'Eksport segera excel',
		a750: 'Semua kedai',
		a751: 'Kali ini akan disegerakkan:"',
		a752: '"Baru-baru ini',
		a753: 'Dianggarkan bahawa ia akan mengambil masa 30-59 saat untuk menyegerakkan data pesanan. Selepas data disegerakkan, sila muat semula halaman semasa. Adakah anda mahu meneruskan penyegerakan? ',
		a754: 'Penyegerakan Pesanan',
		a755: 'Segerakkan Sekarang',
		a756: 'Menyegerakkan data pesanan, sila tunggu! ',
		a757: 'Data pesanan telah disegerakkan, sila muat semula! ',
		a758: 'Hanya fail jenis excel boleh dimuat naik!',
		a759: 'Had semasa adalah untuk memilih 1 fail, sila padam dan teruskan memuat naik',
		a760: 'Kedai telah dibuka',
		a761: 'Pesanan belum selesai',
		a762: 'Pesanan gagal lulus semakan dalam masa 2 jam selepas pembayaran',
		a763: 'Buka',
		a764: 'Pertanyaan nombor pesanan',
		a765: 'Susunan urutan',
		a766: 'Masa pesanan adalah dari lewat hingga awal',
		a767: 'Waktu pesanan adalah dari pagi hingga malam',
		a768: 'Baki masa penghantaran daripada lebih kepada kurang',
		a769: 'Baki masa penghantaran daripada kurang kepada lebih',
		a770: 'Adakah anda pasti mahu tutup? ',
		a771: 'Adakah anda pasti mahu membukanya? ',
		a772: 'Pesanan belum diluluskan dalam masa 2 jam! ',
		a773: 'Pesanan belum diluluskan dalam masa 2 jam! ',
		a774: 'Pilihan Kedai',
		a775: 'Jenis kargo',
		a776: 'Negara / wilayah',
		a777: 'Jenis Pesanan',
		a778: 'Semakan pemulangan gudang',
		a779: 'Keadaan mengikat',
		a780: 'Tunjukkan persembunyian',
		a781: 'Perintah biasa',
		a782: 'Mengandungi produk pengedaran',
		a783: 'Senarai binaan sendiri',
		a784: 'Barangan am',
		a785: 'Barang sensitif',
		a786: 'Senarai binaan sendiri platform',
		a787: 'Pesanan tidak terikat',
		a788: 'Pesanan gudang yang berbeza',
		a789: 'Bersembunyi',
		a790: 'Tunjukkan',
		a791: 'Buat senarai manual',
		a792: 'Sila pilih kedai! ',
		a793: 'Maklumat pesanan telah ditetapkan semula! sila muat semula! ',
		a794: 'Sila pilih pesanan yang perlu disemak! ',
		a795: 'Sila pilih gudang audit',
		a796: 'Jenis gudang audit ialah gudang produk, sila pilih jenis kargo! ',
		a797: 'Pada masa ini tiada pesanan segera yang boleh disemak',
		a798: 'Menyegerakkan data pesanan, sila tunggu! ',
		a799: 'Kepunyaan penjual',
		a800: 'Pesanan berjaya dipadamkan! ',
		a801: 'Maklumat penerimaan bungkusan telah diserahkan kepada penjual, sila tunggu dengan sabar untuk penjual mengesahkan! ',
		a802: 'Harap bersabar dan tunggu penjual mengesahkan! ! ',
		a803: 'Pilih penjual:',
		a804: 'Pesanan sudah ada! ',
		a805: 'Buang bungkusan',
		a806: 'Lancar semula',
		a807: 'Lain',
		a808: 'Isikan maklumat pemulangan yang diterima',
		a809: 'Pilih gudang penerima',
		a810: 'Mesej kepada penjual',
		a811: 'Pakej pulangkan',
		a812: 'Jenis operasi',
		a813: 'Bilangan rak',
		a814: 'Kembalikan Butiran',
		a815: 'Sila pilih gudang penghantaran',
		a816: 'Penjual mengesahkan jenis operasi pemulangan:',
		a817: 'Nama Produk',
		a818: 'Sila masukkan kuantiti di rak',
		a819: 'Tinggalkan mesej kepada gudang (pilihan)',
		a820: 'Tinggalkan mesej kepada penjual (pilihan)',
		a821: 'Gudang yang menerima pulangan',
		a822: 'Seret imej ke sini, atau',
		a823: 'Tiada gambar lagi',
		a824: 'Nyatakan pada masa itu',
		a825: 'Jumlah pulangan',
		a826: 'Pulangkan barang',
		a827: 'Nama Panggilan Pembeli',
		a828: 'Pembeli eamil',
		a829: 'Tarikh Akhir Penghantaran Pembeli',
		a830: 'Penjual adalah kerana proses pemulangan',
		a831: 'Harga',
		a832: 'Kembalikan borang',
		a833: 'Batalkan pesanan',
		a834: 'Sekali gus',
		a835: 'Alasan pembatalan',
		a836: 'Jenis Penghantaran',
		a837: 'Gudang Penghantaran',
		a838: 'Kedai',
		a839: 'Semua pesanan',
		a840: 'Dibatalkan',
		a841: 'Kembalikan pesanan',
		a842: 'Mohon pembatalan',
		a843: 'Semua kedai',
		a844: 'Sila pilih gudang penerima',
		a845: 'Sila masukkan kuantiti rak',
		a846: 'Penjual sedang mengesahkan, harap bersabar! ',
		a847: 'Gudang sedang disahkan, harap bersabar! ',
		a848: 'Tidak disemak',
		a849: 'Pembeli',
		a850: 'Sistem',
		a851: 'Penjual gagal menjawab soalan saya tepat pada masanya',
		a852: 'Jika pembeli gagal membayar, sistem akan membatalkan secara automatik',
		a853: 'Pembeli tidak mahu lagi',
		a854: 'Bungkusan telah hilang',
		a855: 'Penjual tidak menghantar',
		a856: 'Logistik tidak boleh dihantar ke kawasan pembeli',
		a857: 'Bungkusan rosak',
		a858: 'Fungsi produk rosak',
		a859: 'Penjual tersalah hantar barang! ',
		a860: 'Pembeli tidak menerima barang',
		a861: 'Tempoh',
		a862: 'Jumlah kuantiti pesanan pengedaran',
		a863: 'Pendapatan mata',
		a864: 'Eksport jadual excel',
		a865: 'Imbas keluar gudang (hanya untuk gudang di luar negara)',
		a866: 'Pilih tarikh',
		a867: 'Nombor pesanan',
		a868: 'Cari nombor pesanan',
		a869: 'Tarikh pembungkusan',
		a870: 'Kuantiti pesanan keluar',
		a871: 'Bilangan pembatalan selepas penghantaran',
		a872: 'Nombor koleksi kurier',
		a873: 'Tolak mata',
		a874: 'Mata Perolehan',
		a875: 'Semak pesanan',
		a876: 'Pesanan eksport',
		a877: 'Cetak tanda kurier',
		a878: 'Jenis logistik:',
		a879: 'Jenis Penjual',
		a880: 'Mod barangan sensitif',
		a881: 'Mod kargo am',
		a882: 'Mod penghantaran barangan sensitif telah dihidupkan',
		a883: 'Mod penghantaran barangan am telah dihidupkan',
		a884: 'Saya faham',
		a885: 'Imbas keluar perpustakaan',
		a886: 'Tiada mesej penjual',
		a887: 'Tiada kod bar lagi',
		a888: 'Tiada maklumat',
		a889: 'Kuantiti memetik yang tidak normal! ',
		a890: 'Sila scan nombor pesanan dahulu! ',
		a891: 'Sayang, awak belum mengikat shopee lagi! ',
		a892: 'Pergi ke kedai shopee terikat! ',
		a893: 'Menerima',
		a894: 'Tidak dikumpulkan',
		a895: 'Nombor pesanan',
		a896: 'Kaedah Penghantaran',
		a897: 'Ucapan Penjual',
		a898: 'Tolak masa',
		a899: 'Maklumat perhubungan',
		a900: 'Titik keluar',
		a901: 'Hasilkan nombor bil laluan',
		a902: 'Mulakan PDF',
		a903: 'Cetak semula helaian muka',
		a904: 'Bil laluan telah dijana, sila muat semula halaman secara manual!',
		a905: 'Sila jana nombor bil laluan dan cetak semula!',
		a906: 'Kuantiti penghantaran sebenar penjual',
		a907: 'Tiada nama logistik',
		a908: 'Pesanan diproses',
		a909: 'Masukkan pertanyaan nombor pesanan',
		a910: 'Yuran keluar',
		a911: 'Keuntungan pesanan pengedaran',
		a912: 'Senarai pengedaran',
		a913: 'Penapis kedai:',
		a914: 'Jenis gudang',
		a915: 'Kembalikan pesanan',
		a916: 'Bertanya',
		a917: 'Ikat semula',
		a918: 'Produk gudang tidak terikat',
		a919: 'Untuk mengikat',
		a920: 'Gudang penghantaran tidak dikesan',
		a921: 'Penjual memerlukan kaedah pemprosesan',
		a922: 'Kaedah pemprosesan sebenar gudang',
		a923: 'Status pengembalian: ',
		a924: 'Penjual Mengesahkan Pemulangan',
		a925: 'Penjual telah mengesahkan',
		a926: 'Telah di proses',
		a927: 'Sila pilih kaedah pemprosesan',
		a928: 'Pengesahan penjual berjaya, menunggu pemprosesan oleh gudang',
		a929: 'Pesanan sedang menunggu semakan, sila beroperasi selepas semakan pesanan! ',
		a930: 'Ujian',
		a931: 'Kaedah percetakan',
		a932: 'Senarai muka & senarai pilihan',
		a933: 'Hanya perintah muka',
		a934: 'Pilih senarai sahaja',
		a935: 'Penskalaan helaian muka',
		a936: 'Teks penerangan',
		a937: 'Sila isi maklumat penghantaran dahulu',
		a938: 'Eksport fail xlsx',
		a939: 'Senarai saham',
		a940: 'Rekod cetakan sejarah',
		a941: 'Tempoh masa cetak',
		a942: 'Jenis cetakan',
		a943: 'Cetak kuantiti pesanan',
		a944: 'Cetak semula',
		a945: 'Ujian',
		a946: 'Cetakan helaian muka',
		a947: 'Cetak nama',
		a948: 'Masa cetak (kali pertama)',
		a949: 'Tidak dicetak',
		a950: 'Dicetak',
		a951: 'Pesanan cetakan',
		a952: 'Cetak senarai pilihan lalai',
		a953: 'Dicetak, muat semula halaman semasa',
		a954: 'Semakan kembali gagal',
		a955: 'Okay, saya tahu',
		a956: 'Kemajuan pemprosesan pesanan',
		a957: 'Kurier telah dikumpul! ',
		a958: 'Gudang telah selesai mengimbas dan meninggalkan gudang, menunggu kurier mengambilnya dalam talian! ',
		a959: 'Gudang telah selesai membuat pemeriksaan barang, menunggu gudang untuk mengimbas dan meninggalkan gudang! ',
		a960: 'Gudang telah mencetak helaian muka untuk menyusun, menunggu pemeriksaan gudang! ',
		a961: 'Gudang telah menyelesaikan pengedaran, dan gudang akan mencetak helaian muka dan menyusunnya! ',
		a962: 'Diluluskan, menunggu pengisihan dan pengedaran gudang! ',
		a963: 'Nombor bil laluan sedang dijana, sila jangan tinggalkan halaman semasa! ',
		a964: 'Biasa',
		a965: 'Pesanan/selesai',
		a966: 'Penjejakan Pesanan',
		a967: 'Mengandungi pertanyaan',
		a968: 'Cari nama produk, sku produk',
		a969: 'Tekan pengisihan masa (awal hingga lewat)',
		a970: 'Push time sorting (dari lewat hingga awal)',
		a971: 'Isikan maklumat asas penghantar kurier',
		a972: 'Nama penghantar',
		a973: 'Nombor telefon pengirim',
		a974: 'Alamat terperinci pengirim',
		a975: 'Tanda kelompok/remark',
		a976: 'Segerakkan nombor pesanan tunggal',
		a977: 'Maklumat pesanan eksport kelompok',
		a978: 'Pesanan diubah suai oleh pengguna',
		a979: 'Tambah tanda',
		a980: 'Tunai semasa penghantaran',
		a981: 'Semak masa',
		a982: 'Tidak ditanda',
		a983: 'Tidak dilepaskan',
		a984: 'Logistik',
		a985: 'Tidak dijana',
		a986: 'Kemajuan Pesanan',
		a987: 'Peringatan penting',
		a988: 'Pemprosesan dipercepatkan',
		a989: 'Memuatkan pesanan yang belum selesai, sila tunggu!!!',
		a990: 'Berjaya menyerahkan maklumat nota! ',
		a991: 'Serahkan pengecualian, dan cuba lagi selepas beberapa ketika! ',
		a992: 'Sistem telah mengesan bahawa anda belum mengisi maklumat penghantaran asas, sila isi dahulu, supaya anda boleh mencetak dalam kelompok dengan cepat! ',
		a993: 'Berjaya disimpan! ',
		a994: 'Anda telah mempercepatkan pesanan ini dan setiap pesanan hanya boleh dipercepatkan sekali sehari! ',
		a995: 'Masa semakan pesanan semasa tidak melebihi 24 jam, dan pesanan tidak boleh didesak dengan segera. Jika pesanan tidak dicetak selepas 24 jam semakan, anda boleh mengingatkan pesanan, terima kasih. ',
		a996: 'Tahu',
		a997: 'Pesanan yang sama hanya boleh diingatkan sekali sehari. Adakah anda pasti mahu mengingatkan nombor pesanan ini dengan segera? ',
		a998: 'Peringatan Pesanan',
		a999: 'Kakitangan gudang telah dimaklumkan untuk memberi keutamaan untuk mempercepatkan pesanan! ',
		a1000: 'Sahkan untuk menarik diri',
		a1001: 'Pesanan? ',
		a1002: 'Berjaya dikembalikan untuk semakan! ',
		a1003: 'Menyegerak, proses mengambil masa kira-kira 50-60 saat! ! !',
		a1004: 'Manual yang dibina sendiri',
		a1005: 'Penjual telah mencatat',
		a1006: 'Tidak bertanda',
		a1007: 'Bil laluan telah dijana dan halaman semasa sedang dimuat semula! ',
		a1008: 'Sila pilih pesanan yang perlu dicetak! ',
		a1009: 'Pengguna yang dihormati, jika anda telah selesai mencetak pesanan, sila muat semula halaman semasa untuk mendapatkan status pesanan terkini',
		a1010: 'Segar semula',
		a1011: 'Muat semula halaman',
		a1012: 'Teruskan mencetak semua',
		a1013: 'Hapuskan pendua dan teruskan mencetak',
		a1014: 'Pengurusan Alamat',
		a1015: 'Penerima',
		a1016: 'Butiran kegagalan penjanaan waybill',
		a1017: 'Sebab kegagalan generasi',
		a1018: 'Pilih logistik penghantaran',
		a1019: 'Pilih Logistik',
		a1020: 'Isipadu/cm',
		a1021: 'Penghantaran Sebenar',
		a1022: 'Nombor bil laluan',
		a1023: 'Panjang/cm',
		a1024: 'Lebar/cm',
		a1025: 'Tinggi/cm',
		a1026: 'Nombor tulen',
		a1027: 'Mata wang',
		a1028: 'Nombor bil laluan',
		a1029: 'Tetapkan alamat penghantaran lalai',
		a1030: 'Tetapkan alamat penghantaran lalai',
		a1031: 'Borang logistik bina sendiri',
		a1032: 'Kumpulan menjana senarai muka & senarai pilihan',
		a1033: 'Senarai muka pencetakan kelompok & senarai pemilihan',
		a1034: 'Isikan dan ubah suai butiran konsainor',
		a1035: 'Lihat rekod cetakan sejarah',
		a1036: 'Cetakan satu klik helaian muka lalai',
		a1037: 'Inventori dalam talian',
		a1038: 'Kuantiti untuk dihantar',
		a1039: 'Isikan logistik penghantaran borang yang dibina sendiri',
		a1040: 'Isikan caj untuk gudang sampel',
		a1041: 'Sila masukkan ketinggian',
		a1042: 'Sila masukkan panjang, lebar dan tinggi item',
		a1043: 'Sila masukkan lebar',
		a1044: 'Sila pilih logistik',
		a1045: 'Sila masukkan berat',
		a1046: 'Maklumat penghantaran logistik telah berjaya diserahkan! ',
		a1047: 'Asterisk merah diperlukan, sila isi! ',
		a1048: 'Tiada teguran penjual',
		a1049: 'Sila isikan sebab untuk kembali menyemak semula',
		a1050: 'Pesanan biasa',
		a1051: 'Pada masa ini terdapat pesanan yang belum menjana nombor bil laluan atau sedang dijana, sahkan bahawa semua nombor bil laluan telah dijana sebelum dicetak!',
		a1052: 'Menggunakan mod ini untuk mencetak borang akan menyebabkan penyemak imbas muncul berbilang tetingkap borang, sila cuba pilih pesanan daripada penjual yang sama dan logistik yang sama untuk mencetak',
		a1053: 'Saya tahu, teruskan mencetak',
		a1054: 'Terdapat ralat dalam data bil latar belakang, sila jana semula nombor bil laluan, dan kemudian sahkan untuk mencetak bil! ',
		a1055: 'Untuk pesanan yang belum menghasilkan nombor bil laluan, sila sahkan bahawa nombor bil laluan dijana sebelum dicetak! ',
		a1056: 'Sila sahkan bahawa nombor bil laluan telah dijana untuk semua pesanan sebelum dicetak! ',
		a1057: 'Sila tetapkan alamat penghantaran lalai dan cetak semula',
		a1058: 'Sila tetapkan alamat penghantaran lalai dan cetak semula',
		a1059: 'Sedang dipilih',
		a1060: 'Dalam perintah itu, terdapat',
		a1061: 'Nombor pesanan belum dijana atau sedang dijana, sila sahkan bahawa semua pesanan yang dipilih telah menghasilkan nombor bil laluan sebelum dicetak',
		a1062: 'Dalam perintah itu, akan ada ',
		a1063: 'Tempahan akan dicetak berulang kali, sahkan sama ada untuk terus mencetak? ',
		a1064: 'Untuk disahkan oleh penjual',
		a1065: 'Pengurusan gudang',
		a1066: 'Barang gudang',
		a1067: 'Pakej gudang',
		a1068: 'Hadiah gudang',
		a1069: 'Masuk ke gudang dalam transit',
		a1070: 'Pengurusan Pembelian',
		a1071: 'Isi semula sekarang',
		a1072: 'Menetap di kedai tempatan',
		a1073: 'Sebutharga Gudang Luar Negara',
		a1074: 'Sebut harga ERP tulen',
		a1075: 'Penukaran kod QR',
		a1076: 'Borang pertanyaan',
		a1077: 'Jimat mengikat',
		a1078: 'Tambahkan item di sebelah kiri ke pengikatan kanan',
		a1079: 'Pilih produk',
		a1080: 'Akan mengikat produk',
		a1081: 'Tambahkan ke',
		a1082: 'Biasa',
		a1083: 'Telah dikeluarkan',
		a1084: 'Tetapan bahasa soalan pertama',
		a1085: 'Tetapan asas pengetahuan',
		a1086: 'Tetapan kata kunci',
		a1087: 'Semasa dengan',
		a1088: 'Pelancong',
		a1089: 'Penghantaran lebih masa baki masa',
		a1090: 'Peringatan Pesanan',
		a1091: 'Thailand',
		a1092: 'Melayu',
		a1093: 'Peringatan pembayaran',
		a1094: 'Isikan maklumat',
		a1095: 'Ubah suai ucapan',
		a1096: 'Ubah suai nombor pesanan pembelian rangkaian',
		a1097: 'Asingkan berbilang pesanan pembelian dengan koma (,)',
		a1098: 'Atribut tersuai',
		a1099: 'Ubah suai gudang transit',
		a1100: 'Ubah suai pembekal',
		a1101: 'Ubah suai nota pembelian',
		a1102: 'Ubah suai nombor bil laluan',
		a1103: 'Sejarah Perubahan Status',
		a1104: 'Tambah komen',
		a1105: 'Butiran',
		a1106: 'Kemas kini status pesanan pembelian',
		a1107: 'Tukar kuantiti',
		a1108: 'Nisbah bayaran pendahuluan/%',
		a1109: 'Kitaran penyelesaian gudang/hari',
		a1110: 'Nama atribut',
		a1111: 'Nilai atribut',
		a1112: 'Gudang transit',
		a1113: 'Pembekal',
		a1114: 'Masa semakan',
		a1115: 'ID Pengulas',
		a1116: 'Status Kelulusan',
		a1117: 'Teguran Audit',
		a1118: 'Pratonton Gambar',
		a1119: 'Imej Produk',
		a1120: 'Informasi produk',
		a1121: 'Membeli storan gudang',
		a1122: 'Selepas kemas kini automatik didayakan untuk semua pautan dalam talian terikat, kuantiti ini akan disegerakkan, inventori dalam talian=dalam stok terkunci stok yang belum selesai',
		a1123: 'Inventori item di dalam gudang ialah baki kuantiti sebenar yang kini berada di dalam gudang dan belum dihantar keluar',
		a1124: 'ID kategori produk beli',
		a1125: 'Kuantiti beli',
		a1126: 'Harga belian',
		a1127: 'Ucapan pembelian',
		a1128: 'Sila masukkan catatan (pilihan)',
		a1129: 'Tambah gudang transit baharu',
		a1130: 'Sila masukkan nama gudang',
		a1131: 'Gudang transit',
		a1132: 'ID Gudang',
		a1133: 'Alamat pembekal',
		a1134: 'Kaedah penyelesaian',
		a1135: 'Kitaran pembayaran/hari',
		a1136: 'Tambah Pembekal',
		a1137: 'Kaedah pembayaran:',
		a1138: 'Cara penghantaran',
		a1139: 'Kemas kini maklumat pembekal',
		a1140: 'Kitaran pembayaran',
		a1141: 'Nama Pembekal',
		a1142: 'Sila masukkan kata kunci nama produk, nombor pesanan pembelian atau nombor bil laluan domestik',
		a1143: 'Membeli Gudang',
		a1144: 'Pembeli Awam',
		a1145: 'No Pesanan Belian',
		a1146: 'Bayaran pertama telah dibayar',
		a1147: 'Baki bayaran telah dibayar',
		a1148: 'Produk platform pengedaran',
		a1149: 'Beli produk',
		a1150: 'Pemula Keperluan Perolehan',
		a1151: 'Pembeli',
		a1152: 'Ketua Pasukan Pembelian',
		a1153: 'Sama ada hendak dipindahkan',
		a1154: 'Status masa kemas kini terkini',
		a1155: 'Status Pembelian',
		a1156: 'Catatan',
		a1157: 'Rambut lurus',
		a1158: 'Transit diperlukan',
		a1159: 'Tunggu',
		a1160: 'Audit Tahap 1',
		a1161: 'Kajian tahap kedua',
		a1162: 'Perlu membayar baki',
		a1163: 'Jumlah kredit perlu dibayar untuk pesanan pembelian ini',
		a1164: 'Nisbah prabayar',
		a1165: 'Ansuran pertama kena bayar',
		a1166: 'Di mana gudang itu terletak',
		a1167: 'Saiz Produk',
		a1168: 'Berat produk',
		a1169: 'Kedudukan',
		a1170: 'Harga belian komoditi',
		a1171: 'Simpan di gudang',
		a1172: 'Ubah suai kuantiti pembelian',
		a1173: 'Maklumat asas pembekal',
		a1174: 'Maklumat asas pesanan pembelian',
		a1175: 'Pesanan Belian Bersih',
		a1176: 'Nombor bil laluan domestik',
		a1177: 'Catatan pesanan pembelian',
		a1178: 'Anggaran masa ketibaan',
		a1179: 'Nilai atribut tersuai',
		a1180: 'Tiada nilai atribut tersuai',
		a1181: 'Komen PO',
		a1182: 'Tiada ulasan pesanan pembelian',
		a1183: 'Tambah ulasan baharu',
		a1184: 'Komen oleh',
		a1185: 'Komen',
		a1186: 'Gagal',
		a1187: 'Lulus',
		a1188: 'Memperbaharui',
		a1189: 'Buat gudang',
		a1190: 'Pesanan Belian',
		a1191: 'Carian pesanan beli',
		a1192: 'Buat pesanan pembelian secara manual',
		a1193: 'Cipta penyedia',
		a1194: 'Senarai pembekal',
		a1195: 'Gudang transit saya',
		a1196: 'Tiada maklumat produk',
		a1197: 'Lihat lagi',
		a1198: 'Sembunyikan produk',
		a1199: 'Baki',
		a1200: 'Jumlah',
		a1201: 'Produk',
		a1202: 'Lihat sejarah perubahan status',
		a1203: 'Audit',
		a1204: 'Baki penyelesaian',
		a1205: 'Dengan nombor pesanan pembelian',
		a1206: 'Produk sku',
		a1207: 'Semua Status',
		a1208: 'Audit ditolak',
		a1209: 'Menunggu semakan tahap satu',
		a1210: 'Menunggu semakan tahap kedua',
		a1211: 'Membeli',
		a1212: 'Dalam perjalanan ke gudang transit',
		a1213: 'Tiba di gudang transit',
		a1214: 'Dalam perjalanan ke gudang terminal',
		a1215: 'Telah sampai ke gudang terminal',
		a1216: 'Telah disimpan',
		a1217: 'Pengangkutan darat',
		a1218: 'Penghantaran',
		a1219: 'Pengangkutan udara',
		a1220: 'Tunai',
		a1221: 'Dalam talian',
		a1222: 'Kad bank',
		a1223: 'Bayaran baki berjaya diselesaikan',
		a1224: 'Permulaan permintaan:',
		a1225: 'Kakitangan perolehan:',
		a1226: 'Status pembelian:',
		a1227: 'Berjaya ditambahkan',
		a1228: 'Segar semula berjaya',
		a1229: 'Sila isikan harga seunit pembelian komoditi',
		a1230: 'Ditolak',
		a1231: 'Kemas kini selesai',
		a1232: 'Berjaya dipadamkan',
		a1233: 'Sila pilih status untuk dikemas kini',
		a1234: 'Status berjaya dikemas kini',
		a1235: 'Pesanan belum diluluskan dan status tidak boleh diubah suai',
		a1236: 'Item pesanan pembelian telah dimasukkan ke dalam storan, dan status tidak boleh diubah suai',
		a1237: 'Pembekal berjaya dibuat! ',
		a1238: 'Pengguna yang dihormati, jika anda telah menyerahkan pesanan pembelian, sila muat semula halaman semasa untuk mendapatkan semua pesanan pembelian terkini',
		a1239: 'Maklumat asas',
		a1240: 'Pautan produk:',
		a1241: 'Huraikan',
		a1242: 'Gambar produk',
		a1243: 'Nama atribut',
		a1244: 'Jenis atribut',
		a1245: 'Spesifikasi produk',
		a1246: 'Sila masukkan SKU ibu bapa',
		a1247: 'Isi atribut',
		a1248: 'Tetapan bersatu',
		a1249: 'Isi inventori',
		a1250: 'Isi sku',
		a1251: 'Spesifikasi sku',
		a1252: 'Harga runcit',
		a1253: 'Berat komoditi',
		a1254: 'Saiz Produk',
		a1255: 'Panjang',
		a1256: 'Lebar',
		a1257: 'Tinggi',
		a1258: 'Keuntungan dijangka',
		a1259: 'Adakah pemeriksaan kualiti',
		a1260: 'Kata Kunci Produk',
		a1261: 'Status Jualan',
		a1262: 'Kos pembelian',
		a1263: 'Pembekal Produk',
		a1264: 'Gudang Produk',
		a1265: 'Maklumat imej',
		a1266: 'Gambar muka depan',
		a1267: 'Sifat produk',
		a1268: 'Tambah atribut baharu',
		a1269: 'Atribut biasa',
		a1270: 'Atribut spesifikasi',
		a1271: 'Stok spesifikasi',
		a1272: 'Pelbagai spesifikasi',
		a1273: 'Taip',
		a1274: 'Jenis spesifikasi',
		a1275: 'Harga asal runcit',
		a1276: 'Maklumat logistik',
		a1277: 'Maklumat lain',
		a1278: 'Kemas kini maklumat produk',
		a1279: 'Kembali',
		a1280: 'Pemeriksaan kualiti diperlukan',
		a1281: 'Pengecualian',
		a1282: 'Sila masukkan nama produk',
		a1283: 'Tidak lebih daripada 255 aksara',
		a1284: 'Sila isi keterangan produk',
		a1285: 'Sila pilih kategori',
		a1286: 'Sila pilih spesifikasi',
		a1287: 'Sila isikan berat',
		a1288: 'Sila isikan spesifikasi produk',
		a1289: 'Sila isikan atribut produk',
		a1290: 'Sila masukkan sku induk produk',
		a1291: 'Letak atas rak',
		a1292: 'Di luar rak',
		a1293: 'Biru',
		a1294: 'Data sumber',
		a1295: 'Beli Xiaosheng Runcit Mall',
		a1296: 'Tambahkan ke perpustakaan produk',
		a1297: 'Sila pilih kedai yang perlu diterbitkan mengikut tapak! ',
		a1298: 'Sila pilih kedai! ',
		a1299: 'Atribut diperlukan, sila isikan atribut! ',
		a1300: 'Sila isikan harga dan stok, dan kedua-duanya tidak boleh 0',
		a1301: 'Berat komoditi diperlukan, dan tidak boleh 0, sila isi! ',
		a1302: 'Logistik diperlukan, sila pilih logistik',
		a1303: 'Produk itu telah diletakkan di rak ke pusat membeli-belah Xiaosheng! ',
		a1304: 'Maklumat logistik telah disegerakkan kepada yang terkini! ',
		a1305: 'Stesen Thailand',
		a1306: 'Stesen Filipina',
		a1307: 'Stesen Indonesia',
		a1308: 'Stesen Melayu',
		a1309: 'Stesen Taiwan',
		a1310: 'Stesen Vietnam',
		a1311: 'Sahkan padam',
		a1312: 'Pada masa ini, spesifikasi produk boleh ditetapkan sehingga dua peringkat! ',
		a1313: 'Sahkan produk di rak? ',
		a1314: 'Produk ada di rak! ',
		a1315: 'Templat berjaya dibuat! ',
		a1316: 'Sila pilih kedai untuk mengeluarkan produk mengikut tapak! ',
		a1317: 'Sila isikan harga, inventori',
		a1318: 'Nilai tukar tidak boleh kosong',
		a1319: 'Tidak dapat menandingi',
		a1320: 'Pada masa ini dikongsi',
		a1321: 'Sesuatu produk tidak boleh dipadankan dan diikat secara automatik kepada produk gudang, anda boleh mengubah suai sku produk supaya selaras dengan sku gudang dan kemudian mengikat semula atau mengikat secara manual',
		a1322: 'Tiada sku gudang',
		a1323: 'Harga bekalan:',
		a1324: ',Sila isikan harga runcit asal',
		a1325: 'Sila pilih produk yang perlu dibeli dan dimasukkan ke dalam simpanan',
		a1326: 'Rekod',
		a1327: 'Cari kod gudang, sku, nama produk',
		a1328: 'Jana pesanan storan',
		a1329: 'Penyimpanan produk',
		a1330: 'Simpanan produk pesanan beli',
		a1331: 'Batalkan semua produk semasa ke dalam gudang',
		a1332: 'Pilih semua produk semasa semuanya disimpan di gudang',
		a1333: 'Nyahtanda',
		a1334: 'Pilih storan',
		a1335: 'Kembangkan untuk melihat lebih banyak lagi',
		a1336: 'Bersembunyi',
		a1337: 'Individu',
		a1338: 'Penapis status pesanan beli',
		a1339: 'Pakej bebas',
		a1340: 'Semua item dan pakej',
		a1341: 'Pustaka produk tunggal',
		a1342: 'Perpustakaan pakej',
		a1343: 'Isi harga',
		a1344: 'Sila pilih produk gudang terikat',
		a1345: 'Koleksi berjaya',
		a1346: 'Status produk',
		a1347: 'Tiada maklumat templat',
		a1348: 'Sama ada untuk pra-menjual',
		a1349: 'Jumlah Inventori',
		a1350: 'Jumlah jualan',
		a1351: 'Status komoditi',
		a1352: 'Pusat membeli-belah runcit',
		a1353: 'Diterbitkan',
		a1354: 'Tidak diterbitkan',
		a1355: 'Lepaskan',
		a1356: 'Salinan',
		a1357: 'Atribut',
		a1358: 'Bersembunyi',
		a1359: 'Sila pilih kedai',
		a1360: 'Status di rak',
		a1361: 'Pemilihan atribut',
		a1362: 'Sila pilih unit',
		a1363: 'Sama ada terpakai:',
		a1364: 'Negara / wilayah:',
		a1365: 'Pautan Produk:',
		a1366: 'Spesifikasi lain',
		a1367: 'Tambah spesifikasi baharu',
		a1368: 'Maklumat produk',
		a1369: 'ID Atribut',
		a1370: 'ID Produk',
		a1371: 'Jenis masa',
		a1372: 'Harga jualan dijangka',
		a1373: 'Keadaan carian',
		a1374: 'Produk',
		a1375: 'Klik untuk mengubah suai maklumat untuk diisi',
		a1376: 'Adakah ia satu produk',
		a1377: 'Kategori kedai',
		a1378: 'Kategori tahap 4',
		a1379: 'Kategori lima peringkat',
		a1380: 'Baru',
		a1381: 'Terpakai',
		a1382: 'Tambah atribut',
		a1383: 'Pilih semua',
		a1384: 'Kaedah logistik segerak',
		a1385: 'Simpan dan terbitkan',
		a1386: 'Simpan templat',
		a1387: 'Simpan templat sahaja',
		a1388: 'Terbitkan sekarang',
		a1389: 'Maklumat produk asas',
		a1390: 'Penerangan Produk',
		a1391: 'Nama sku produk',
		a1392: 'Kos pembelian produk',
		a1393: 'Status Jualan Produk',
		a1394: 'Alamat produk',
		a1395: 'Pemilik Produk',
		a1396: 'Maklumat atribut produk',
		a1397: 'Tukar masa',
		a1398: 'Maklumat logistik produk',
		a1399: 'Panjang produk',
		a1400: 'Lebar Produk',
		a1401: 'Ketinggian produk',
		a1402: 'Maklumat atribut sku kanak-kanak',
		a1403: 'Kembangkan Semua',
		a1404: 'Penapis Produk',
		a1405: 'Ubah suai maklumat',
		a1406: 'Peperiksaan lulus',
		a1407: 'Diluluskan',
		a1408: 'Semua tapak',
		a1409: 'Pilih gudang:',
		a1410: 'Pembekal:',
		a1411: 'Templat berjaya disimpan! ',
		a1412: 'Audit berjaya, sila pergi ke pengurusan produk untuk mengeluarkan produk di rak',
		a1413: 'Audit berjaya, masukkan pengurusan produk untuk dikeluarkan',
		a1414: 'Perubahan disimpan',
		a1415: 'Adakah anda pasti mahu menerbitkan kepada Dianxiaosheng Retail Mall? ',
		a1416: 'Sila pilih item! ',
		a1417: 'Produk telah dihentikan! ',
		a1418: 'Berjaya menyalin! ',
		a1419: 'Adakah anda pasti mahu memadamkan templat induk ini? ',
		a1420: 'Kotak draf',
		a1421: 'Tapak',
		a1422: 'Edit semula',
		a1423: 'Kemas kini imej',
		a1424: 'Pilih sku induk untuk diikat',
		a1425: 'Cari cusCode / sku ibu bapa / sku anak',
		a1426: 'Maklumat sku kanak-kanak',
		a1427: 'Tera air templat (muat naik imej tera air PNG dengan saiz 800*800px/500*500px)',
		a1428: 'Pilih tapak',
		a1429: 'SKU induk komoditi',
		a1430: 'Memuatkan tera air imej, sila tunggu! ',
		a1431: 'Gunakan semua gambar',
		a1432: 'Hanya gunakan imej pertama',
		a1433: 'Tambah imej produk',
		a1434: 'Pengikatan automatik',
		a1435: 'Pengikatan manual',
		a1436: 'Terikat',
		a1437: 'Tetapkan formula pengiraan harga runcit',
		a1438: 'Harga asal runcit tempatan',
		a1439: 'Dipadamkan! ',
		a1440: 'Rekod semasa telah disimpan dalam kotak draf',
		a1441: 'Bilangan perkataan maklumat perihalan produk hanya boleh 2-3000 aksara',
		a1442: 'Sku produk tidak boleh mengandungi aksara haram, seperti: aksara Cina/khas',
		a1443: 'Sku produk, tajuk dan perihalan tidak boleh mengandungi aksara haram, seperti: aksara Cina/khas',
		a1444: 'Atribut spesifikasi peringkat pertama tidak boleh dipadamkan',
		a1445: ',Sila isi',
		a1446: 'Harga asal runcit tempatan',
		a1447: 'Tidak boleh kosong',
		a1448: 'Tambah',
		a1449: 'Set semula',
		a1450: 'Butiran akaun pembeli (sehingga 5 akaun pembeli boleh dibuat)',
		a1451: 'Akaun pembeli',
		a1452: 'Nama panggilan pembeli',
		a1453: 'Buat akaun pembeli baharu',
		a1454: 'Ketua kumpulan',
		a1455: 'Ditetapkan sebagai ketua kumpulan',
		a1456: 'Tambah akaun pembeli baharu (daftar sehingga 5 akaun pembelian)',
		a1457: 'Masukkan nama panggilan pembeli',
		a1458: 'Masukkan Kata laluan',
		a1459: 'Sahkan Kata laluan',
		a1460: 'Nama panggilan pembeli diperlukan',
		a1461: 'Kata laluan diperlukan',
		a1462: 'Pilih Beli Produk',
		a1463: 'Tambah produk terpilih',
		a1464: 'Harga borong China',
		a1465: 'Butiran Pembelian',
		a1466: 'Menyerahkan',
		a1467: 'Beli gudang:',
		a1468: 'Cara:',
		a1469: 'Gudang transit:',
		a1470: 'Kaedah pembelian:',
		a1471: 'Pembeli Biasa',
		a1472: 'Pembeli:',
		a1473: 'Pembeli Awam:',
		a1474: 'Jangan memilih untuk lalai kepada diri sendiri',
		a1475: 'Sila pilih perolehan awam',
		a1476: 'Ketua Pasukan Pembelian:',
		a1477: 'Tetapkan ketua kumpulan',
		a1478: 'Isi secara automatik selepas memilih pembekal',
		a1479: 'Tambah berbilang pesanan belian bersih',
		a1480: 'Tambahkan atribut tersuai yang anda perlukan untuk pesanan pembelian',
		a1481: 'Kosongkan produk terpilih',
		a1482: 'Tambah produk',
		a1483: 'Nombor pesanan pembelian dalam talian:',
		a1484: 'Catatan pesanan pembelian:',
		a1485: 'Nombor bil laluan China:',
		a1486: 'Pemula permintaan',
		a1487: 'Tetapkan dengan jayanya',
		a1488: 'Ketua pasukan pembelian tidak dipilih',
		a1489: 'Kata laluan yang dimasukkan dua kali tidak konsisten',
		a1490: 'Akaun pembeli anda:',
		a1491: ',kata laluan:',
		a1492: 'Sila tambah produk sebelum menyerahkan',
		a1493: 'Pesanan pembelian berjaya dibuat, pergi ke halaman pesanan pembelian untuk melihat',
		a1494: 'Sila pilih gudang pembelian dahulu',
		a1495: 'Harga kos pembelian',
		a1496: 'Hantar pesanan pembelian',
		a1497: 'Mata perlu dimakan',
		a1498: 'Kembali ke platform pengedaran',
		a1499: 'Pergi ke halaman pengurusan pesanan pembelian',
		a1500: 'Jumlah pembelian',
		a1501: 'Jana Produk Gudang',
		a1502: 'Komoditi berjaya dicipta!',
		a1503: 'Jumlah kuantiti yang dibeli oleh penjual kali ini',
		a1504: 'Dan jumlah kuantiti sebenar barang yang tiba di gudang',
		a1505: 'konsisten',
		a1506: 'Beza',
		a1507: 'Amaran',
		a1508: 'Butiran pesanan storan yang disahkan',
		a1509: 'Kuantiti Belian Penjual',
		a1510: 'Kuantiti ketibaan sebenar',
		a1511: 'Perlu dibayar oleh penjual',
		a1512: 'Dibayar',
		a1513: 'Meter padu',
		a1514: 'Standard penilaian',
		a1515: 'Jumlah isipadu kargo',
		a1516: 'Berat',
		a1517: 'Mata Bayar',
		a1518: 'Mengesahkan pembayaran',
		a1519: 'Cetak kod bar SKU produk',
		a1520: 'Cetak kod bar pesanan storan',
		a1521: 'Percetakan kod bar',
		a1522: 'Kuantiti Cetak',
		a1523: 'Penjual mengesahkan maklumat storan',
		a1524: 'Jika percanggahan berlaku, sila hubungi gudang untuk mengesahkan butiran! ',
		a1525: 'Harga pembelian',
		a1526: 'Kuantiti ketibaan sebenar gudang',
		a1527: 'Tiada mesej lagi',
		a1528: 'Kembalikan inti berat',
		a1529: 'Sahkan penyimpanan',
		a1530: 'Pengurusan storan',
		a1531: 'Mendapatkan data pesanan storan, sila tunggu! ',
		a1532: 'Jangkaan ketibaan',
		a1533: 'Ketibaan sebenar',
		a1534: 'Yuran perjalanan kepala',
		a1535: 'Lihat & Ubah Suai',
		a1536: 'Cetak kod bar',
		a1537: 'Pembayaran berjaya! ',
		a1538: 'Menunggu pengesahan dari pekedai',
		a1539: 'Perjalanan pertama telah dibayar',
		a1540: 'Pembantu kedai sedang menyemak maklumat invois, sila tunggu dengan sabar! ',
		a1541: 'Sila tandakan produk! ',
		a1542: 'Status pesanan semasa tidak membenarkan pemadaman! ',
		a1543: 'Operasi ini akan memadamkan pesanan storan semasa secara kekal, teruskan?',
		a1544: 'Ia telah dikembalikan ke gudang untuk disemak semula! ',
		a1545: 'Terdapat percanggahan antara kuantiti pembelian penjual dan kuantiti sebenar yang diterima oleh gudang. Adakah anda ingin terus mengesahkan operasi pergudangan? ',
		a1546: 'Ya',
		a1547: 'Pembayaran diperlukan untuk pengesahan pergudangan ini',
		a1548: 'Mata, dan potongan tambahan diperlukan',
		a1549: 'Yuran mata pelbagai gudang',
		a1550: 'Potongan tambahan diperlukan untuk pergudangan ini',
		a1551: 'Mata',
		a1552: 'OKEY',
		a1553: 'Terdapat perbezaan antara kuantiti simpanan penjual dan kuantiti pengesahan sebenar gudang! ',
		a1554: 'Status storan',
		a1555: 'Masa penciptaan pesanan penyimpanan',
		a1556: 'Imbas ke dalam storan',
		a1557: 'Gudang Masuk',
		a1558: 'Penjual',
		a1559: 'Caj Tambahan Gudang',
		a1560: 'Isikan nombor tulen',
		a1561: 'Mengesahkan penerimaan barang',
		a1562: 'Panjang/cm (diperlukan)',
		a1563: 'Lebar/cm(diperlukan)',
		a1564: 'Tinggi/cm(diperlukan)',
		a1565: 'Berat/kg(diperlukan)',
		a1566: 'Masukkan mesej kepada penjual',
		a1567: 'Sila isikan panjang, lebar, tinggi dan berat produk! ',
		a1568: 'Kuantiti yang dibeli oleh penjual adalah konsisten dengan kuantiti sebenar yang tiba di gudang. Adakah anda mengesahkan resit? ',
		a1569: 'Kuantiti yang dibeli oleh penjual tidak konsisten dengan kuantiti sebenar yang tiba di gudang. Adakah anda ingin terus mengesahkan penerimaan? ',
		a1570: 'Ia telah berjaya diserahkan kepada penjual untuk pengesahan! ',
		a1571: 'Semua penjual',
		a1572: 'Pesanan pembelian yang disahkan',
		a1573: 'Jenis pertanyaan',
		a1574: 'Nilai pertanyaan',
		a1575: 'Lihat peraturan harga pemantauan',
		a1576: 'Produk Dalam Talian',
		a1577: 'Mata wang negara',
		a1578: 'Harga jualan',
		a1579: 'Ikat produk lawan',
		a1580: 'Produk yang dipantau',
		a1581: 'ID Aktiviti',
		a1582: 'Harga aktiviti',
		a1583: 'Tarikh luput',
		a1584: 'Buka ikatan',
		a1585: 'Pantau arah aliran harga',
		a1586: 'Ubah suai peraturan pemantauan',
		a1587: 'Ubah suai maklumat produk diskaun',
		a1588: 'Lalai',
		a1589: 'Nama acara',
		a1590: 'Kawasan aktiviti',
		a1591: 'Sila pilih kawasan aktiviti',
		a1592: 'Kawasan satu',
		a1593: 'Kawasan dua',
		a1594: 'Masa aktiviti',
		a1595: 'Penghantaran segera',
		a1596: 'Aktiviti Alam Semula Jadi',
		a1597: 'Acara Dalam Talian Makanan/Restoran',
		a1598: 'Aktiviti tolak tanah',
		a1599: 'Aktiviti bertema luar talian',
		a1600: 'Pendedahan jenama tulen',
		a1601: 'Sumber khas',
		a1602: 'Ditaja oleh Jenama Dalam Talian',
		a1603: 'Tempat luar talian adalah percuma',
		a1604: 'Borang aktiviti',
		a1605: 'Tambah maklumat produk diskaun',
		a1606: 'Masa tamat acara',
		a1607: 'Item acara',
		a1608: 'Harga sebelum acara',
		a1609: 'Harga Aktiviti',
		a1610: 'Had pembelian',
		a1611: 'Ikat produk pengguna dengan produk lawan',
		a1612: 'Dapatkan item halaman',
		a1613: 'Pantau harga rizab:',
		a1614: 'Strategi pengurangan harga:',
		a1615: 'Nilai turun: ',
		a1616: 'Ikat produk yang dipilih',
		a1617: 'Peraturan satu',
		a1618: 'Peraturan dua',
		a1619: 'Semua harga adalah berdasarkan harga terendah yang dipantau',
		a1620: 'Adakah anda pasti mahu melepaskan ikatan produk ini? ',
		a1621: 'Ciri ini belum disiarkan lagi. ',
		a1622: 'Turun 0.01%',
		a1623: 'Lalai turun 0.01%',
		a1624: 'Jangan laraskan',
		a1625: 'Turun nilai tetap',
		a1626: 'Peratusan bawah peraturan tersuai',
		a1627: 'Sila masukkan nota',
		a1628: 'Gambar produk',
		a1629: 'Sub-SKU produk',
		a1630: 'Peraturan Harga',
		a1631: 'Carta pemantauan harga',
		a1632: 'Harga monitor terakhir',
		a1633: 'Pertanyaan mengikut nama produk',
		a1634: 'Menurut pertanyaan sku induk',
		a1635: 'Semua barang',
		a1636: 'Ia telah ditambah kepada',
		a1637: 'Item dilarang',
		a1638: 'Item dipadamkan',
		a1639: 'Sila tetapkan selang permulaan menjadi lebih kecil daripada selang akhir. ',
		a1640: 'Sila masukkan selang masa kurang daripada 15 hari. ',
		a1641: 'Sahkan tutup? ',
		a1642: 'Tamat tempoh',
		a1643: 'Sedang berjalan',
		a1644: 'Berjaya melepaskan ikatan produk! ',
		a1645: 'Ubah suai peraturan berjaya! ',
		a1646: 'Bertanggungjawab ke atas kedai',
		a1647: 'Pilih kedai terikat, anda boleh memilih lebih daripada satu! ',
		a1648: 'Pilih kedai terikat (berbilang pilihan)',
		a1649: 'Buat kumpulan',
		a1650: 'Nama kumpulan',
		a1651: 'Kitaran Yuran',
		a1652: 'Suku',
		a1653: 'Bulan',
		a1654: 'Jumlah kos item tersuai',
		a1655: 'Tambah item perbelanjaan baharu',
		a1656: 'Dapatkan yuran sejarah',
		a1657: 'Nama yuran',
		a1658: 'Nama perbelanjaan, seperti: kos buruh',
		a1659: 'Perbelanjaan',
		a1660: 'Tahun',
		a1661: 'Tahun',
		a1662: 'Bulan',
		a1663: 'Simpan butiran bayaran tersuai',
		a1664: 'Butiran yuran tersuai kumpulan',
		a1665: 'Berjaya menambah item perbelanjaan! ',
		a1666: 'Yuran telah berjaya diubah suai! ',
		a1667: 'Sila sahkan sama ada anda mahu memadamkan item perbelanjaan ini?',
		a1668: 'Sila isi kandungan seperti yang diperlukan! ',
		a1669: 'Kitaran',
		a1670: 'Pilih bulan',
		a1671: 'Pilih tahun',
		a1672: 'Pilih suku',
		a1673: 'Muat semula halaman semasa',
		a1674: 'Kedai',
		a1675: 'Amaun pesanan berbayar (jualan)',
		a1676: 'Kadar pertumbuhan rantaian jualan',
		a1677: 'Bayaran pengiklanan',
		a1678: 'Kos pembelian barang',
		a1679: 'Jumlah tuntutan yang berjaya',
		a1680: 'Pulangan Amaun Bayaran Balik',
		a1681: 'Kos pengangkutan awal',
		a1682: 'Tiada kedai yang terikat lagi',
		a1683: 'Kos pengiklanan',
		a1684: 'Keuntungan',
		a1685: 'Margin keuntungan',
		a1686: 'Penilaian keseluruhan',
		a1687: 'Item perbelanjaan tersuai lain',
		a1688: 'Lihat bayaran tersuai',
		a1689: 'Padam kumpulan',
		a1690: 'Suku pertama',
		a1691: 'S2',
		a1692: 'S3',
		a1693: 'S4',
		a1694: 'Kos pengangkutan kaki pertama: hanya perlu mengisi setiap kelompok borang pergudangan kaki pertama dengan tepat, dan kos pengangkutan yang dikaitkan dengan setiap kelompok boleh dikira secara automatik. Contohnya, kumpulan pengangkutan udara dan laut yang berbeza mempunyai kos yang berbeza.',
		a1695: 'Pada masa ini hanya menyokong pemerolehan automatik yuran pengiklanan Shopee, yuran pengiklanan platform lain perlu menambah item yuran tersuai',
		a1696: 'Untung = Jualan - Kos Belian Barang - Kos Pengangkutan Terdahulu - Perbelanjaan Pengiklanan - Item Perbelanjaan Tersuai Lain + Amaun Tuntutan Berjaya',
		a1697: 'Kos pembelian barangan: iaitu, kos pembelian sebenar barangan, yang dikira secara automatik daripada kos pembelian produk inventori',
		a1698: 'Adakah anda pasti mahu membuka ikatan kedai?',
		a1699: 'Berjaya melepaskan',
		a1700: 'Berjaya diikat! ',
		a1701: 'Kumpulan berjaya dipadamkan! ',
		a1702: 'Kumpulan berjaya dibuat! ',
		a1703: 'Pengedar tidak membenarkan ejen mengedar produk mereka sendiri! ',
		a1704: 'Saya mahu sampel',
		a1705: 'Imbas untuk menghubungi perkhidmatan pelanggan pengedaran untuk mendapatkan sampel',
		a1706: 'Kita sembang nombor',
		a1707: 'Memuatkan...',
		a1708: 'Kejayaan pengedaran! ',
		a1709: 'Pengedaran gagal',
		a1710: 'Akaun atau kata laluan tidak boleh kosong! ',
		a1711: 'Log masuk berjaya! ',
		a1712: 'Produk pengedaran spot',
		a1713: '1 keping bagi pihak harga',
		a1714: 'Kuantiti Spot',
		a1715: 'Edarkan segera',
		a1716: 'Stok',
		a1717: 'Maklumat produk',
		a1718: 'Sila log masuk ke akaun Xiaosheng kedai untuk mengedarkan produk! ',
		a1719: 'Adakah anda ingin meneruskan pengedaran produk ini? ',
		a1720: 'Kejayaan pengedaran! Produk seterusnya untuk diletakkan di platform shopee, sila pergi ke platform pengedaran shopee "Saya seorang ejen" untuk diletakkan di rak! ',
		a1721: 'Pergi ke kedai untuk meletakkan produk di rak',
		a1722: 'Teruskan mengedarkan produk',
		a1723: 'Hubungi Khidmat Pelanggan',
		a1724: 'Jika anda perlu mendapatkan sampel pengedaran, sila imbas kod QR untuk menghubungi perkhidmatan pelanggan platform pengedaran! ',
		a1725: 'Gunakan alat analisis data Shopee secara percuma',
		a1726: 'Pemalam analisis kulit udang',
		a1727: 'Klik untuk memuat turun',
		a1728: 'Imej utama shopee',
		a1729: 'Indeks shopee melonjak',
		a1730: 'Jualan bulanan shopee',
		a1731: 'Jualan bulanan shopee',
		a1732: 'Hari simpanan shopee',
		a1733: 'Harga terendah shopee',
		a1734: 'Indeks penukaran shopee',
		a1735: 'Lihat pautan sumber',
		a1736: 'Muat turun APP Dianxiaosheng sekarang',
		a1737: 'Senarai pengedaran barangan spot Asia Tenggara',
		a1738: 'Senarai cadangan hangat',
		a1739: 'Cari nama produk',
		a1740: 'Spot inventori',
		a1741: 'Analisis pasaran',
		a1742: 'Saya ingin mengedarkan',
		a1743: 'Tiada data berkaitan lagi',
		a1744: 'Platform pengedaran spot di Asia Tenggara',
		a1745: 'Butiran produk pengedaran',
		a1746: 'Sila masukkan mesej',
		a1747: 'Spesifikasi sku',
		a1748: 'Stok:',
		a1749: 'Produk telah berjaya diedarkan ke akaun shopee anda. Untuk mengeluarkan produk ke platform shopee, sila ke platform pengedaran di PC: Saya ejen, teruskan beroperasi! ',
		a1750: 'Hantar kod pengesahan',
		a1751: 'Mendaftar',
		a1752: 'Sudah mendaftar, klik untuk log masuk',
		a1753: 'Sila masukkan nombor telefon',
		a1754: 'Sila masukkan kata laluan pengguna',
		a1755: 'Sila masukkan nama panggilan pengguna',
		a1756: 'Pilihan',
		a1757: 'Akaun emel',
		a1758: 'Sila isi maklumat pendaftaran, ia tidak boleh kosong! ',
		a1759: 'Pendaftaran berjaya, sila log masuk! ',
		a1760: 'Kod pengesahan telah dihantar, beri perhatian untuk menyemak! ',
		a1761: 'Sila isi nombor telefon bimbit! ',
		a1762: 'Rumah Pengedaran',
		a1763: 'Saya boleh bekalkan',
		a1764: 'Hubungan perkhidmatan pelanggan',
		a1765: 'Log masuk segera',
		a1766: 'Log keluar daripada log masuk semasa',
		a1767: 'Platform pengedaran spot Asia Tenggara/Taiwan',
		a1768: 'Tempat tempatan di Asia Tenggara, satu dropshipping',
		a1769: 'Inventori yang tepat, pengikatan yang berkaitan, mengelakkan terlebih jual',
		a1770: 'Sokong penjual tempatan Shopee/Lazade/Shopify',
		a1771: 'Ikhlas menjemput pengedaran',
		a1772: 'Mengesyorkan produk pengedaran',
		a1773: 'Lihat situasi berkaitan shopee',
		a1774: 'Lokasi',
		a1775: 'Pada masa ini tidak log masuk, sila log masuk ke akaun Dian Xiaosheng, dan kemudian teruskan ke operasi pengedaran! ',
		a1776: 'Log keluar daripada log masuk semasa! ',
		a1777: 'Sila log masuk ke akaun Xiaosheng kedai dahulu, dan kemudian edarkan! ',
		a1778: 'Pengedaran berjaya, sila klik Saya telah bertindak sebagai ejen untuk mengeluarkan produk pada masa hadapan! ',
		a1779: 'Pengguna niche kedai:',
		a1780: 'Kami dengan tulus menjemput anda untuk mengedarkan produk spot beliau, penghantaran setitik, dan meningkatkan keuntungan bersih penjual! ',
		a1781: 'Saya telah diwakili',
		a1782: 'Status semasa tidak log masuk, sila pergi untuk log masuk! ',
		a1783: 'Tiada produk ejen! ',
		a1784: 'Log keluar daripada akaun log masuk semasa! ',
		a1785: 'Nombor akaun',
		a1786: 'Bilangan kedai terikat',
		a1787: 'Kuantiti gudang yang berkaitan',
		a1788: 'Bilangan Baki Mata',
		a1789: 'Sistem erp yang memfokuskan kepada penjual rentas sempadan di Asia Tenggara',
		a1790: 'Pemalam pemilihan produk percuma Bayanalysis',
		a1791: 'Terminal mudah alih',
		a1792: 'Dokumen Panduan Sistem',
		a1793: 'Sokongan teknikal',
		a1794: 'Mesej baru',
		a1795: 'Log keluar',
		a1796: 'Belum ada berita!',
		a1797: 'Berita terkini',
		a1798: 'Mesej yang belum dibaca',
		a1799: 'Balas',
		a1800: 'Dari',
		a1801: 'Peringatan penting daripada sistem',
		a1802: 'Lihat semua mesej',
		a1803: 'Tiada mesej sesi lagi',
		a1804: 'Buka kata laluan kedua',
		a1805: 'Selepas menetapkan, data kewangan sensitif seperti untung kasar dan harga belian perlu dipaparkan selepas memasukkan kata laluan kedua',
		a1806: 'Bilangan pesanan berbayar',
		a1807: 'Nota: Selepas kata laluan kedua didayakan, ia tidak akan dapat ditutup. Data kewangan sensitif seperti untung kasar dan harga belian terlibat. Anda perlu memasukkan kata laluan kedua untuk memaparkannya! ',
		a1808: 'Sila masukkan kata laluan kedua',
		a1809: 'Ubah suai kata laluan kedua',
		a1810: 'Gambaran keseluruhan',
		a1811: 'Perbelanjaan bayaran pendahuluan pembelian komoditi',
		a1812: 'Pendapatan bayaran pendahuluan pembelian komoditi',
		a1813: 'Bayaran baki pembelian komoditi',
		a1814: 'Bayaran pendahuluan pembelian komoditi Yuran yang dibayar oleh pembeli kepada platform',
		a1815: 'Komisen yang diperoleh daripada sistem prabayar pembelian komoditi',
		a1816: 'Kadar pertukaran berjaya diubah suai',
		a1817: 'Kata laluan kedua telah berjaya ditetapkan! ',
		a1818: 'Gambaran keseluruhan jualan sku',
		a1819: 'Nilai',
		a1820: 'Kuantiti dalam stok',
		a1821: 'Purata jualan/hari (hampir 7 hari)',
		a1822: 'Masa penyimpanan terkini',
		a1823: '30 hari lepas',
		a1824: '7 hari lepas',
		a1825: '3 hari lepas',
		a1826: 'Jumlah jualan dalam tempoh masa semasa',
		a1827: 'Pemilihan gudang',
		a1828: 'Eksport fail excel',
		a1829: 'Kitaran pengisian semula (hari)',
		a1830: 'Pertanyaan produk gudang',
		a1831: 'Cari kod gudang/nama sku',
		a1832: 'Cipta storan',
		a1833: 'Semak status jualan sku',
		a1834: 'Peringatan kehabisan stok',
		a1835: 'Butiran Potongan',
		a1836: 'Butiran',
		a1837: 'Potongan mata',
		a1838: 'Perihalan potongan',
		a1839: 'Butiran perbelanjaan',
		a1840: 'Rekod mata',
		a1841: 'Pertanyaan nombor pesanan',
		a1842: 'Jenis bayaran',
		a1843: 'Perubahan bersepadu',
		a1844: 'Sumber pembayaran',
		a1845: 'Lihat butiran potongan',
		a1846: 'Semua gudang',
		a1847: ' Kemas kini mata',
		a1848: 'Sahkan untuk meneruskan, yuran mata semasa akan ditukar kepada:',
		a1849: ' Integral, sama ada untuk meneruskan operasi kemas kini!',
		a1850: 'Ya kemas kini sekarang',
		a1851: 'Mata berjaya dikemas kini! ',
		a1852: 'Kemas kini mata gagal, peraturan pengecasan baharu adalah konsisten dengan peraturan semasa! ',
		a1853: 'Caj penjual "',
		a1854: '"Kejadian Gudang',
		a1855: 'Gudang untuk caj pelbagai',
		a1856: 'Potong mata penjual',
		a1857: 'Kandungan catatan untuk potongan perbelanjaan pelbagai',
		a1858: 'Tawaran Penjual',
		a1859: 'Tambah tawaran baharu',
		a1860: 'Diskaun (nilai antara 0 dan 1): 0: percuma, 1: tiada diskaun, 0.95: potongan 95%',
		a1861: 'Gudang',
		a1862: 'Diskaun',
		a1863: 'Bilangan pengguna penjual yang berkaitan',
		a1864: 'Mata yang mencukupi',
		a1865: 'Mata tertunggak',
		a1866: 'Akaun Penjual',
		a1867: 'Status baki mata',
		a1868: 'Pada masa ini kurang daripada 30 mata, sila ingatkan pengguna untuk membenarkan nilai dalam masa! ',
		a1869: 'Tetapkan diskaun',
		a1870: 'Pelbagai caj',
		a1871: 'Sembunyikan penjual',
		a1872: 'Tunjukkan penjual',
		a1873: 'Julat nilai adalah antara 0 dan 1',
		a1874: 'Bayaran bahan',
		a1875: 'Yuran penyenaraian',
		a1876: 'Bayaran simpanan',
		a1877: 'Caj berlebihan SKU lalai',
		a1878: 'Caj berlebihan sku yang sama',
		a1879: 'Tetapan berjaya!',
		a1880: 'Mata yang ditolak tidak boleh 0! ',
		a1881: 'Catatan tidak boleh kosong! ',
		a1882: 'Berjaya mengutip yuran sampingan! ',
		a1883: 'Julat nilai adalah antara 0.6 dan 1',
		a1884: 'Nilai keutamaan yuran perkhidmatan mestilah antara 0.6 dan 1, dan tidak boleh kurang daripada 0.6',
		a1885: 'Gambaran Keseluruhan Umum Gudang',
		a1886: 'Pesanan belum selesai',
		a1887: 'Memproses pesanan hari ini',
		a1888: 'Pendapatan mata hari ini',
		a1889: 'Sub-gudang akaun gudang semasa',
		a1890: 'Nama panggilan Zicang',
		a1891: 'Id sub-gudang',
		a1892: 'Jenis sub-bin',
		a1893: 'Gudang sampel',
		a1894: 'Gudang awan di luar negara',
		a1895: 'Gudang persendirian',
		a1896: 'Gudang Perikatan',
		a1897: 'Gudang Pengedaran',
		a1898: 'Nombor telefon pembeli',
		a1899: 'Masa siasatan',
		a1900: 'Senarai produk',
		a1901: 'Nama Produk',
		a1902: 'Harga kos (hanya integer atau perpuluhan yang sah boleh dimasukkan)',
		a1903: 'Pilih gudang...',
		a1904: 'Keadaan mengikat komoditi',
		a1905: 'Menerima Gudang',
		a1906: 'Kosong',
		a1907: 'Menyerahkan',
		a1908: 'Berjaya mengikat produk',
		a1909: 'Telah terikat',
		a1910: 'Ikatan gagal',
		a1911: 'Diharamkan',
		a1912: 'Dipadamkan',
		a1913: 'Hasilkan produk gudang',
		a1914: 'Rekod berjaya ditambah',
		a1915: 'Semua Kedai',
		a1916: 'Sila masukkan kod gudang produk di gudang, atau tambahkannya dalam produk gudang! ',
		a1917: 'Sila pilih kedai untuk menyegerakkan semula produk',
		a1918: 'Produk telah disegerakkan',
		a1919: 'Pada masa ini tiada maklumat produk, sila pilih produk yang anda perlu tambah ke gudang',
		a1920: 'Sila pilih gudang penerima',
		a1921: 'berjaya menyertai',
		a1922: 'Tahniah, ini adalah mesej kejayaan',
		a1923: 'Barang terikat',
		a1924: 'Produk gudang perlu terikat dengan sekurang-kurangnya satu produk dalam talian, jika anda tidak memerlukan produk ini, anda boleh memadam terus produk di gudang!',
		a1925: 'Jenis import',
		a1926: 'Jenis storan',
		a1927: 'Nama produk yang boleh dicari, sku',
		a1928: 'Import semua dengan satu klik',
		a1929: 'Segerakkan produk lazada',
		a1930: 'Import produk gudang',
		a1931: 'Import perpustakaan item dalam gudang',
		a1932: 'Import perpustakaan pakej gabungan',
		a1933: 'Di perpustakaan item gudang',
		a1934: 'Perpustakaan pakej gabungan',
		a1935: 'Data shopee sedang dikemas kini secara serentak, sila muat semula selepas beberapa ketika! ',
		a1936: 'Hasilkan oleh kedai pilihan semasa',
		a1937: 'Hasilkan mengikut kategori yang dipilih sekarang',
		a1938: 'Hasilkan mengikut item yang dipilih sekarang',
		a1939: 'Pada masa ini tiada produk terpilih! ',
		a1940: 'Adakah anda pasti akan memadamkan item semasa?',
		a1941: 'Data Lazada sedang dikemas kini secara serentak, sila muat semula selepas beberapa ketika! ',
		a1942: 'Segerakkan produk SHOPEE',
		a1943: 'Kategori',
		a1944: 'Kuantiti semasa',
		a1945: 'Pada masa ini tiada kategori terpilih',
		a1946: 'Import kumpulan produk dalam gudang',
		a1947: 'Menurut kedai yang dipilih pada masa ini, import perpustakaan item dalam gudang',
		a1948: 'Mengikut perpustakaan pakej gabungan import kedai yang dipilih pada masa ini',
		a1949: 'Menurut produk yang dipilih pada masa ini, importnya ke dalam inventori barang gudang',
		a1950: 'Import perpustakaan pakej gabungan mengikut produk yang sedang dipilih',
		a1951: 'Di atas rak',
		a1952: 'Menurut kedai yang dipilih pada masa ini, jana perpustakaan item gudang',
		a1953: 'Buat perpustakaan pakej gabungan mengikut kedai yang dipilih sekarang',
		a1954: 'Jana dalam perpustakaan item gudang mengikut kategori yang dipilih sekarang',
		a1955: 'Jana perpustakaan pakej gabungan mengikut kategori yang dipilih sekarang',
		a1956: 'Jana dalam pesanan gudang mengikut produk yang sedang dipilih',
		a1957: 'Jana pustaka pakej gabungan mengikut produk yang sedang dipilih',
		a1958: 'Pengurusan Akaun',
		a1959: 'Telefon bimbit',
		a1960: 'Sila masukkan kod pengesahan telefon mudah alih',
		a1961: 'Kata laluan baharu',
		a1962: 'Peti Surat',
		a1963: 'Sila masukkan kod pengesahan e-mel',
		a1964: 'Kata laluan baharu',
		a1965: 'Telefon semasa',
		a1966: 'Tukar Kata laluan',
		a1967: 'Masukkan kata laluan baharu',
		a1968: 'Kod pengesahan telefon mudah alih',
		a1969: 'Peti mel semasa',
		a1970: 'Kata laluan kedua',
		a1971: 'Sila masukkan nombor telefon anda! ',
		a1972: 'Kata laluan berjaya ditukar, log keluar, sila log masuk semula! ',
		a1973: 'Tambah alamat',
		a1974: 'Isi penerima',
		a1975: 'Isikan nombor telefon penerima',
		a1976: 'Isikan alamat terperinci',
		a1977: 'Isikan poskod',
		a1978: 'Telefon bimbit/telefon',
		a1979: 'Penerima tidak boleh kosong! ',
		a1980: 'Kaedah penerima tidak boleh kosong! ',
		a1981: 'Alamat tidak boleh kosong! ',
		a1982: 'Tingkatkan kejayaan! ',
		a1983: 'Halaman maklumat peribadi',
		a1984: 'Pusat Pengurusan Maklumat',
		a1985: 'Pengurusan Akaun',
		a1986: 'Pengurusan alamat',
		a1987: 'Analisis pintar CRM potret pembeli',
		a1988: 'Dalam teori pengurusan pelanggan: kos membangunkan pelanggan baharu ialah kos mengekalkan pelanggan lama',
		a1989: 'Masa! ! Penyelenggaraan dan perkhidmatan pelanggan lama amat penting! ! ! ',
		a1990: 'Atas sebab ini, pasukan data besar Dianxiaosheng telah melaraskan model latihan dan algoritma selama satu tahun, dan secara rasmi melancarkan fungsi analisis pelanggan untuk penjual. Kami menggabungkan ciri-ciri transaksi e-dagang merentas sempadan di Asia Tenggara dan mesin pakai model algoritma pembelajaran. Menurut anda',
		a1991: 'Kekerapan pembelian/jumlah pembelian/kebarangkalian bayaran balik pertikaian/masa pembelian terkini bagi transaksi sejarah pembeli',
		a1992: 'Dll. untuk analisis. ',
		a1993: 'Klasifikasi pintar ialah:',
		a1994: 'Nilai tinggi/kesetiaan tinggi nilai rendah/kesetiaan rendah dan nilai tinggi yang akan berlaku',
		a1995: 'Pelanggan, dsb., algoritma klasifikasi ini akan membantu perkhidmatan pelanggan anda untuk meningkatkan lagi perkhidmatan pelanggan dan mengekalkan pelanggan yang mungkin hilang semasa membuat susulan pelanggan. ',
		a1996: 'Cubalah sekarang',
		a1997: 'Selang penggunaan purata',
		a1998: 'Bilangan pesanan (masa penggunaan)',
		a1999: 'Selang antara penggunaan terkini dan masa kini',
		a2000: 'Nisbah premium penggunaan purata berbanding harga purata kategori',
		a2001: 'Jumlah jumlah penggunaan',
		a2002: 'Bilangan pesanan yang ditolak',
		a2003: 'Analisis Kuantitatif Pembeli',
		a2004: 'Keadaan penapis data',
		a2005: 'Nama pembeli',
		a2006: 'Kesetiaan',
		a2007: 'Kapasiti penggunaan',
		a2008: 'Kepekaan harga',
		a2009: 'Pembelian',
		a2010: 'Jumlah jumlah pembelian',
		a2011: 'Tarikh pembelian terkini',
		a2012: 'Nama pembeli:',
		a2013: 'Selang antara penggunaan terkini dan masa kini',
		a2014: 'Jumlah harga',
		a2015: 'Mata wang',
		a2016: 'Kumpulan pembeli tersuai',
		a2017: 'Nama kumpulan',
		a2018: 'Huraian kumpulan',
		a2019: 'Perihalan dikongsi',
		a2020: 'Alih keluar dari keterangan',
		a2021: 'Dapatkan data transaksi sejarah',
		a2022: 'Latihan indeks model terkuantisasi',
		a2023: 'Klasifikasi akhir potret pembeli',
		a2024: 'Pengiraan data...',
		a2025: 'Senarai Hitam',
		a2026: 'Senarai hitam awan',
		a2027: 'Alih ke senarai hitam awan',
		a2028: 'Alih keluar daripada senarai hitam awan',
		a2029: 'Ubah suai nama',
		a2030: 'OK untuk mengubah suai',
		a2031: 'Tambah kumpulan tersuai',
		a2032: 'Tambah sekarang',
		a2033: 'Peringkat semasa',
		a2034: 'Kemajuan semasa',
		a2035: 'Jumlah data terlatih',
		a2036: 'Jumlah jumlah data sebenar',
		a2037: 'Anda tidak membenarkan kedai itu, sila beri kebenaran terlebih dahulu',
		a2038: 'Pergi ke kebenaran',
		a2039: 'Anggaran volum latihan pembeli',
		a2040: 'Kedai sah',
		a2041: 'Tambah kebenaran',
		a2042: 'Mulakan latihan',
		a2043: 'Pada masa ini mata tersedia anda',
		a2044: 'Melatih mata anggaran penggunaan',
		a2045: '*Anggaran amaun pengiraan mungkin berbeza sedikit daripada amaun pengiraan sebenar (dalam 1% ralat)',
		a2046: 'Kuantiti penolakan pesanan',
		a2047: 'Selang masa pembelian',
		a2048: 'Purata peratusan premium',
		a2049: 'Latihan telah selesai',
		a2050: 'Sedia untuk dihantar',
		a2051: 'Reship',
		a2052: 'Dihantar',
		a2053: 'Menunggu pengesahan penerimaan',
		a2054: 'Membatalkan',
		a2055: 'Memulangkan barang',
		a2056: 'Nilai tinggi',
		a2057: 'Nilai sederhana',
		a2058: 'Nilai rendah',
		a2059: 'Telah hilang',
		a2060: 'Pengairan',
		a2061: 'Biasa',
		a2062: 'Kesetiaan',
		a2063: 'Penggunaan rendah',
		a2064: 'Penggunaan tinggi',
		a2065: 'Tidak sensitif harga',
		a2066: 'Sensitif harga',
		a2067: 'Kuasa penggunaan tinggi',
		a2068: 'Mata semasa tidak mencukupi, sila cas semula dahulu',
		a2069: 'Jumlah latihan pembeli semasa ialah 0, dan latihan tidak boleh dilakukan',
		a2070: 'Kedai yang tidak dibenarkan pada masa ini, tidak dapat melatih',
		a2071: 'Berjaya dikongsi',
		a2072: 'Tambah peraturan pengecasan terjemahan perkhidmatan pelanggan pintar',
		a2073: 'Ubah suai peraturan pengecasan terjemahan perkhidmatan pelanggan pintar',
		a2074: 'Kawasan pengecasan',
		a2075: 'Sila pilih kawasan pengecasan',
		a2076: 'Sila pilih jenis pengecasan',
		a2077: 'Jenis caj',
		a2078: 'Tetapan selang caj:',
		a2079: 'Julat pengecasan',
		a2080: 'Caj yuran',
		a2081: 'Kali',
		a2082: 'Perkhidmatan pelanggan pintar dan standard pengecasan SMS',
		a2083: 'Standard pengecasan terjemahan perkhidmatan pelanggan pintar',
		a2084: 'Sila pilih rantau',
		a2085: 'Penapis',
		a2086: 'Dalam 10 bilion',
		a2087: 'Percuma selamanya',
		a2088: 'Bilangan sepuluh ribu aksara',
		a2089: 'Bilangan aksara',
		a2090: 'Standard petikan fungsi peringatan SMS',
		a2091: '* Menghidupkan fungsi peringatan pintar akan menolak yuran mengikut jumlah SMS yang dihantar secara automatik, dan harga SMS dicaj mengikut negara yang berbeza. Berikut ialah petikan SMS antarabangsa:',
		a2092: 'Caj',
		a2093: 'Kepingan',
		a2094: 'Lalu 1518, Jalan Jinshajiang, Daerah Putuo, Shanghai',
		a2095: 'Lane 1517, Jinshajiang Road, Putuo District, Shanghai',
		a2096: 'Bilangan balasan kepada pembeli',
		a2097: 'Bilangan aksara yang diterjemahkan',
		a2098: 'Adakah anda pasti untuk memadamkan?',
		a2099: 'Peraturan telah berjaya ditambahkan',
		a2100: 'Klasifikasi',
		a2101: 'Lihat semua pesanan pembeli',
		a2102: 'Ubah suai kos pembelian',
		a2103: 'Kos pengangkutan',
		a2104: 'Mata wang tempatan',
		a2105: 'Serahkan pengubahsuaian',
		a2106: 'Kargo akan secara langsung menjejaskan pengiraan nilai barang, adalah disyorkan untuk masuk',
		a2107: 'Isipadu/meter padu',
		a2108: 'Kuantiti pembelian (integer)',
		a2109: 'Sudah wujud! ',
		a2110: 'Ia bukan produk di bawah gudang yang sama, sila pilih produk dari gudang yang sama! ',
		a2111: 'Jangkaan masa ketibaan mestilah lebih daripada 3 hari dari tarikh semasa, dan hari semasa tidak akan dikira!',
		a2112: 'Tiada maklumat produk, tidak boleh membuat pesanan pembelian',
		a2113: 'Sila isikan tarikh ketibaan yang dijangka',
		a2114: 'Kuantiti barang tidak boleh 0',
		a2115: 'Sila pilih produk di bawah gudang yang sama untuk pembelian',
		a2116: 'Berjaya membuat pesanan storan:',
		a2117: 'Tidak dapat membuat pesanan storan, mata semasa yang tersedia tidak mencukupi, sila cas semula! ',
		a2118: 'Pengubahsuaian berjaya, dan halaman pesanan storan sedang dikembalikan! ',
		a2119: 'Saya tahu',
		a2120: 'Masa ketibaan',
		a2121: 'Sila masukkan mata wang tempatan',
		a2122: 'Jumlah pembelian semasa',
		a2123: 'Anggaran tarikh ketibaan',
		a2124: 'Buat storan',
		a2125: 'Tambah produk baharu',
		a2126: 'Sahkan pengubahsuaian',
		a2127: 'Kargo pertama',
		a2128: 'Saluran sendiri',
		a2129: 'Perjalanan kepala platform',
		a2130: 'Standard Pengecasan',
		a2131: 'Anggaran jumlah volum',
		a2132: 'Mata Tempahan',
		a2133: 'Setiap meter padu',
		a2134: 'Sekilogram',
		a2135: 'Berat sebenar atau berat isipadu mengambil nilai yang lebih besar',
		a2136: 'Butiran produk masuk',
		a2137: 'Harga kos',
		a2138: 'Hadiah',
		a2139: 'Warehouse sku',
		a2140: 'Tambah satu produk atau pakej',
		a2141: 'Jenis Produk',
		a2142: 'Beli 1 atau kurang produk atau pakej tunggal, akan menambah nombor yang ditetapkan oleh pusat pengedaran',
		a2143: 'Bilangan aksesori percuma',
		a2144: 'Dipilih',
		a2145: 'Ibu gudang Sku',
		a2146: 'Kembangkan',
		a2147: 'Tutup',
		a2148: 'Semua sub-SKU dalam gudang',
		a2149: 'Bilangan sub-sku gudang',
		a2150: 'Baki jumlah inventori dalam gudang',
		a2151: 'Sila masukkan sub-SKU gudang baharu',
		a2152: 'Masukkan skuName baharu',
		a2153: 'Volume',
		a2154: 'Sila sahkan untuk memadam yang dipilih',
		a2155: ' Produk? ',
		a2156: 'Gagal memadamkan pesanan! ',
		a2157: 'Adakah anda pasti akan memadamkan item ini?',
		a2158: 'Gagal memadamkan pesanan',
		a2159: 'Berjaya disimpan',
		a2160: 'Berjaya mencipta satu produk dalam gudang! ',
		a2161: 'Buat bahan boleh guna hadiah secara manual',
		a2162: 'Imbas bar produk',
		a2163: 'Jana kod QR',
		a2164: 'Pergi untuk mencetak',
		a2165: 'Kod QR',
		a2166: 'Jenis kedai',
		a2167: 'Shopee\Lazade\TikTok store\Tiki local store kini disokong, sila sahkan dengan perkhidmatan pelanggan dan klik untuk membayar kandungan pakej berikut',
		a2168: 'Kedai Eksklusif Peribadi',
		a2169: '5 orang berkongsi kedai perusahaan',
		a2170: 'Kedai Perusahaan Eksklusif Peribadi',
		a2171: 'Dilampirkan',
		a2172: 'Termasuk 1 kedai tempatan, 1000 mata pulangan tunai pada platform pengedaran. ',
		a2173: 'Sebut harga dan perkhidmatan berkaitan adalah seperti berikut',
		a2174: '1. Apakah ERP tulen?',
		a2175: 'Penjual tempatan yang membina gudang mereka sendiri di negara Asia Tenggara tidak perlu menggunakan gudang awan luar negara kami. Mereka juga boleh menggunakan hanya sistem ERP dan WMS. Buat akaun gudang persendirian (iaitu, akaun gudang) di kedai halaman kebenaran, dan segera gunakan seluruh gudang kami. ERP dan aliran pemprosesan WMS gudang yang cekap, hanya perlu membayar yuran perkhidmatan sistem serendah 0.05 yuan/pesanan. ',
		a2176: '2. Mengapa menggunakan sistem ERP/WMS Dianxiaosheng? ',
		a2177: ' Direka khas untuk penjual tempatan, pembantu tuntutan percuma tetap boleh menjejaki pesanan hilang logistik dengan satu klik, mengelakkan kedai terlebih jual dan memotong mata, kadar ketepatan inventori 99.99%, mengikat inventori dalam talian pada berbilang platform dan kedai, dan mengemas kini secara automatik dalam talian dalam Inventori 1 minit, untuk mengelakkan terlebih jual di kedai & tamat masa penghantaran! ',
		a2178: '3. Platform pengedaran spot ERP? ',
		a2179: 'Platform pengedaran spot Asia Tenggara yang eksklusif, penjual boleh menggunakan platform pengedaran Dinxiaosheng untuk mewujudkan sistem pengedaran luar negara pada bila-bila masa, lebih banyak ejen dalam talian, sokongan untuk menetapkan harga runcit minimum dalam talian, pemantauan masa nyata harga jualan ejen dan kawalan harga . ',
		a2180: '4. Pasukan perkhidmatan profesional',
		a2181: 'Sistem ERP Dianxiaosheng disesuaikan khas untuk penjual tempatan di Asia Tenggara. Pada masa ini, pasukan perkhidmatan tempatan telah ditubuhkan di banyak negara Asia Tenggara seperti Malaysia, Thailand, Indonesia dan Filipina! ',
		a2182: '1. Mengapa anda mahu menetap di kedai tempatan? ',
		a2183: 'Penjual yang memasuki Asia Tenggara harus tahu bahawa negara-negara Asia Tenggara memerlukan semua platform e-dagang untuk melindungi akaun tempatan mereka. Pada masa yang sama, di bawah wabak ini, hanya penghantaran gudang awan tempatan boleh menjadikan pembeli mengalami pengalaman yang lebih baik, menghasilkan kadar penukaran yang lebih tinggi dan keuntungan. Kadarnya juga lebih tinggi, dan kedai TIKTOK Thailand, Malaysia dan Vietnam baru dibuka pada Mac tahun ini, pulangan dan pertukaran penggunaan impulsif siaran langsung hanya boleh direalisasikan di gudang tempatan, jadi kedai tempatan telah menjadi satu kemestian bagi Tenggara. Penjual Asia. ',
		a2184: '2. Objek perkhidmatan',
		a2185: 'Oleh kerana tidak terdapat banyak akaun berkualiti tinggi yang selamat dan patuh, dan bilangannya terhad, pada masa ini kami hanya menyediakannya kepada pelanggan di gudang atau menggunakan platform pengedaran Xiaosheng kedai, dan melarang sama sekali produk tiruan dan peniaga lain , hanya untuk penjual yang mempunyai kehadiran jangka panjang di Asia Tenggara Serve. ',
		a2186: '3, maklumat lanjut',
		a2187: 'Negara dan platform yang boleh diselesaikan, kami akan terus mengemas kini maklumat yang berkaitan, sila klik untuk melihat butiran:',
		a2188: 'Dokumen kongsi',
		a2189: 'Senarai Harga Gudang Luar Negara',
		a2190: '1. Apakah gudang awan di luar negara? ',
		a2191: 'Gudang awan, biasanya dikenali sebagai gudang luar negara. Iaitu, mengikut kesan operasi produk kedai, barangan akan disimpan terlebih dahulu ke tanah besar, dan setelah pesanan dikeluarkan, barang akan dihantar dalam masa 24 jam. Anda boleh menggunakan ERP Dianxiaosheng secara percuma dan menyediakan barang ke gudang awan luar negara Dianxiaosheng, yang boleh memudahkan anda mengawal barang dalam masa, memantau secara automatik pesanan pemulangan COD pembeli/pertikaian, dan secara berkesan meningkatkan keuntungan bersih keseluruhan untuk penjual! ',
		a2192: '2 Negara manakah yang menjadi gudang awan utama di luar negara? ',
		a2193: 'Pada masa ini perkhidmatan gudang awan luar negara Dian Xiaosheng telah meliputi: Vietnam/Thailand/Malaysia/Filipina/Indonesia/Taiwan/dan negara Asia Tenggara yang lain',
		a2194: '3. Mengapa menggunakan storan awan di luar negara? ',
		a2195: '① Kurangkan kos pengangkutan laluan pertama dan mampatkan kos logistik; ②. Penghantaran pantas dalam masa 24 jam untuk meningkatkan pengalaman pembeli; ③. Pemprosesan pemulangan dan pertukaran tepat pada masanya untuk meningkatkan keuntungan bersih keseluruhan',
		a2196: 'Butiran perubahan mata',
		a2197: 'Perubahan bersepadu dalam tempoh masa semasa',
		a2198: 'Nombor positif: tambah mata, nombor negatif: tolak mata',
		a2199: 'Jenis potongan mata (lalai semua)',
		a2200: 'Jenis pembayaran',
		a2201: 'Potongan',
		a2202: 'Item perbelanjaan',
		a2203: 'Sebelum mata bertukar',
		a2204: 'Selepas pertukaran mata',
		a2205: 'Cari',
		a2206: 'Butiran mata tersimpan',
		a2207: 'Pesta pembayaran (kedai)',
		a2208: 'Sebelah hasil (gudang)',
		a2209: 'Jumlah mata',
		a2210: 'Mata yang tersedia',
		a2211: 'Lihat butiran titik',
		a2212: 'Semak butiran tempat tempahan',
		a2213: 'Selepas mengecas semula, anda boleh segera menggunakan fungsi seperti storan awan luar negara, gudang ujian produk dan gudang persendirian',
		a2214: 'Arahan caj semula ahli: 1 yuan 1 mata, lebih banyak caj semula, lebih banyak mata akan diberikan',
		a2215: 'Tiada maklumat potongan untuk nombor pesanan ini!',
		a2216: 'Peringatan untuk membayar',
		a2217: 'Peringatan penghantaran',
		a2218: 'Tanda untuk peringatan',
		a2219: 'Tiada had',
		a2220: 'Peringatan Tanda',
		a2221: 'Adakah anda pasti mahu menyerahkan borang? ',
		a2222: 'Mendapatkan rekod storan! ',
		a2223: 'Tiada rekod simpanan! ',
		a2224: 'Kos pengangkutan',
		a2225: 'Akan disahkan oleh platform',
		a2226: 'Akan dibayar oleh penjual...',
		a2227: 'Ubah suai harga kos',
		a2228: 'Buat laluan tajuk baharu',
		a2229: 'Sila pilih jenis kargo',
		a2230: 'Pilih negara',
		a2231: 'Sila pilih kawasan',
		a2232: 'Singapura',
		a2233: 'Kaedah potongan',
		a2234: 'Volume atau berat maksimum',
		a2235: 'Sila pilih kaedah potongan',
		a2236: 'Yuran harga',
		a2237: 'Pindah hubungan gudang',
		a2238: 'Alamat gudang pemindahan',
		a2239: 'Perjalanan kepala saluran milik sendiri',
		a2240: 'Tambah perjalanan kepala',
		a2241: 'Ambil nilai maksimum',
		a2242: 'Nombor telefon penerima',
		a2243: 'Kargo am melalui laut',
		a2244: 'Kargo udara',
		a2245: 'Kargo am pengangkutan darat',
		a2246: 'Barang Sensitif Laut',
		a2247: 'Barang Sensitif Udara',
		a2248: 'Pengangkutan darat sensitif',
		a2249: 'Berjaya mencipta!',
		a2250: 'Berjaya padam! ',
		a2251: 'Pilih platform berikut untuk kebenaran kedai',
		a2252: 'Klik untuk membenarkan',
		a2253: 'Sila panjat dinding',
		a2254: 'Sekali lagi',
		a2255: 'Keizinan akan datang tidak lama lagi! Jika kedai telah diberi kuasa pada akaun lain, ia akan tercabut secara automatik daripada akaun asal dan tidak boleh dipulihkan. Sila beroperasi dengan berhati-hati. Jika anda tidak pasti, sila hubungi perkhidmatan pelanggan platform',
		a2256: 'Beri kebenaran sekarang',
		a2257: 'Pembantu Tuntutan',
		a2258: 'Penghadan tuntutan',
		a2259: 'Pampasan tiba dalam akaun',
		a2260: 'Ia adalah fungsi khas sistem yang direka khas untuk penjual tempatan di Asia Tenggara. Ia boleh membantu penjual mengetahui tepat pada masanya pesanan yang ditolak oleh COD atau hilang dalam penghantaran ekspres, dan memudahkan penjual untuk mengeksport borang, yang boleh digunakan untuk menuntut pampasan daripada platform. ',
		a2261: 'Biasanya dalam tempoh 30 hari, jika anda tidak membuat tuntutan kepada perkhidmatan pelanggan platform selama lebih daripada 30 hari, ia akan dianggap sebagai penepian kelayakan tuntutan dan akhirnya penjual akan kehilangan sejumlah pampasan (contohnya, naik kepada 2,000 baht di Thailand)! Jika anda boleh membuat tuntutan kepada platform tepat pada masanya, ia akan segera membantu anda memulihkan kerugian anda dan meningkatkan keuntungan bersih anda serta-merta!',
		a2262: 'Selepas menyerahkan borang tuntutan perkhidmatan pelanggan platform, sistem akan menilai secara automatik sama ada pesanan yang anda tuntut telah berjaya diberi pampasan, menjimatkan masa anda untuk menyemak, dan ia jelas sekali imbas. ',
		a2263: 'Klik pada bar menu yang sepadan di bawah "Tuntutan untuk disahkan - Pesanan", "Tuntutan - Pesanan", "Tuntutan Berjaya - Pesanan"',
		a2264: 'Tuntutan menunggu pengesahan',
		a2265: 'Apabila pembeli menolak pesanan COD daripada kedai tempatan, kebarangkalian kehilangan pakej akan meningkat, dan sistem akan memantau pakej yang hilang secara automatik dan menghantar pakej yang gagal. ',
		a2266: 'Penjual perlu mengklik butang mula tuntutan secara manual untuk memasuki keadaan ini, untuk mengelakkan kekeliruan dengan pesanan tuntutan yang baru tiba untuk disahkan! ',
		a2267: 'Setelah diserahkan kepada perkhidmatan pelanggan platform, sistem secara automatik akan menyemak sama ada pesanan telah berjaya dituntut dan jumlah sebenar diterima, dan akan memaparkan status ini secara automatik. ',
		a2268: 'Anda perlu mengambil inisiatif untuk menghubungi perkhidmatan pelanggan SHOPEE untuk membuat tuntutan. Umumnya, beritahu mereka untuk menuntut pakej yang hilang dan serahkan senarai Excel. ',
		a2269: 'Menuntut',
		a2270: 'Pakej diterima',
		a2271: 'Untuk mengesahkan perintah tuntutan',
		a2272: 'Untuk dihubungi pesanan perkhidmatan pelanggan platform',
		a2273: 'Perintah telah berjaya dituntut',
		a2274: 'Sahkan untuk menuntut pesanan:',
		a2275: 'Sahkan untuk meninggalkan perintah:',
		a2276: 'Tuntutan?',
		a2277: 'Perintah telah melepaskan tuntutan!',
		a2278: 'Apabila anda mengklik pada semua tuntutan, jumlah semasa ialah',
		a2279: 'Semua pesanan dituntut, sila sahkan jika anda ingin meneruskan operasi ini?',
		a2280: 'Semua tuntutan berjaya!',
		a2281: 'Menunggu penjual menghubungi perkhidmatan pelanggan platform',
		a2282: 'Tuntutan berjaya',
		a2283: 'Masukkan nama nota',
		a2284: 'Sila isikan kenyataan kedai',
		a2285: 'Eksport butiran potongan status semasa',
		a2286: 'Pesta hasil',
		a2287: 'Pembayar',
		a2288: 'Butiran akaun gudang persendirian (hanya boleh membuat sehingga 3 akaun gudang persendirian)',
		a2289: 'Buat akaun gudang persendirian baharu',
		a2290: 'Akaun gudang persendirian',
		a2291: 'Buat sub-gudang gudang pengedaran',
		a2292: 'Buat gudang persendirian',
		a2293: 'Tetapan Keutamaan',
		a2294: 'Penjual semasa',
		a2295: 'Sila pilih gudang',
		a2296: 'Sila pilih jenis diskaun',
		a2297: 'Jenis Promosi',
		a2298: 'Yuran Perkhidmatan',
		a2299: 'Tawaran Penjual',
		a2300: 'Julat nilai ialah 0-1, 0.95=95% diskaun, 1=tiada diskaun, 0=percuma',
		a2301: 'Pada masa ini tiada gudang terikat',
		a2302: 'Pada masa ini tiada akaun terikat kepada penjual',
		a2303: 'Tolak bayaran pelbagai penjual',
		a2304: 'Julat nilai ialah 0.7-1, potongan 0.7=30%, 1=tiada diskaun',
		a2305: 'Sebab untuk memohon membuka gudang pengedaran diperlukan',
		a2306: 'Sila isikan alamat terperinci',
		a2307: 'Sila isikan penerima',
		a2308: 'Sila isikan maklumat hubungan penerima',
		a2309: 'Sila isikan nama gudang pengedaran',
		a2310: 'Berjaya memotong mata penjual! ',
		a2311: 'Pernyataan kedai telah dikemas kini dan halaman semasa sedang dimuat semula',
		a2312: 'Berjaya mengikat',
		a2313: 'Berjaya mencipta gudang persendirian! ',
		a2314: 'Permohonan untuk membuat gudang pengedaran telah diserahkan kepada platform, sila tunggu platform memprosesnya! ',
		a2315: 'Sila isikan kandungan langit berbintang merah! ',
		a2316: 'Sub-gudang baharu',
		a2317: 'Gudang perikatan baharu',
		a2318: 'Sila masukkan perpuluhan antara 0 dan 1! Hanya boleh menyimpan sehingga dua tempat perpuluhan',
		a2319: 'Nilai keutamaan yuran perkhidmatan mestilah antara 0.7 dan 1, dan tidak boleh kurang daripada 0.7',
		a2320: 'Sila pilih jenis gudang! ! ! ',
		a2321: 'Potong penjual',
		a2322: 'Yuran pelbagai gudang',
		a2323: 'Akaun itu sudah wujud! sila masukkan lagi! ',
		a2324: 'Pilih negara',
		a2325: 'Sila isikan nama gudang persendirian! ',
		a2326: 'Sila isikan kata laluan akaun gudang persendirian! ',
		a2327: 'Anda telah berjaya mencipta akaun gudang persendirian:',
		a2328: ', Kata laluan:',
		a2329: 'Berjaya dibuat',
		a2330: 'Berjaya mengikat kedai! ',
		a2331: '! Adakah anda mahu memberi kebenaran semula dan menyahjilid akaun asal? ',
		a2332: 'Nota: Selepas menyahjilid, data pesanan akaun asal di kedai ini akan dikosongkan secara automatik. ',
		a2333: 'Adakah anda mahu meneruskan kebenaran? ',
		a2334: 'Sahkan Kebenaran',
		a2335: 'China',
		a2336: 'Didayakan',
		a2337: 'Dilumpuhkan',
		a2338: 'Sila isi maklumat gudang',
		a2339: 'Berjaya mencipta gudang perikatan! ',
		a2340: 'Cabut segera! Selepas menyahikat, perkaitan dan perhubungan mengikat antara kedai dan produk gudang akan dipadamkan secara automatik, dan pesanan kedai tidak boleh diperoleh dan tidak boleh dipulihkan! Sila beroperasi dengan berhati-hati, jika anda tidak pasti, sila hubungi perkhidmatan pelanggan platform',
		a2341: 'Lepaskan serta-merta',
		a2342: 'Alamat penjual',
		a2343: 'Masukkan nama kenyataan penjual',
		a2344: 'Tambah keizinan Shopify',
		a2345: 'Nama kedai',
		a2346: 'URL Kedai',
		a2347: 'Butiran akaun gudang persendirian (hanya boleh membuat sehingga 5 akaun gudang persendirian)',
		a2348: 'Sub-gudang pengedaran baharu',
		a2349: 'Nama Gudang Pengedaran',
		a2350: 'Nama sub-gudang',
		a2351: 'Sila masukkan alamat terperinci',
		a2352: 'Sila masukkan keterangan untuk memohon gudang pengedaran! ',
		a2353: 'Perihalan aplikasi',
		a2354: 'Untuk membuat akaun gudang persendirian, sila imbas kod QR di WeChat untuk menghubungi kakitangan perkhidmatan pelanggan',
		a2355: 'Isi nama sub-gudang',
		a2356: 'Masukkan kata laluan gudang persendirian',
		a2357: 'Peraturan pengecasan gudang',
		a2358: 'Dayakan',
		a2359: 'Kurang upaya',
		a2360: 'Tiada jenis lagi',
		a2361: 'Nama kedai diperlukan',
		a2362: 'URL kedai diperlukan',
		a2363: 'Mohon untuk membuka akaun gudang persendirian',
		a2364: 'Peringatan: Apabila pengguna mencipta akaun gudang persendirian, sistem akan menjana akaun gudang persendirian secara rawak, dan pada masa yang sama, sistem akan membuat sub-gudang persendirian secara automatik untuk akaun tersebut, sila isikan nama sub-gudang! ',
		a2365: 'Setiap yuran pesanan',
		a2366: 'Bilangan maksimum pesanan setiap bulan',
		a2367: 'Yuran pemprosesan pemulangan',
		a2368: 'Nombor SKU potongan lalai pakej tunggal',
		a2369: 'Bilangan sku melebihi caj lalai',
		a2370: 'Nombor potongan lalai pakej dengan sku yang sama',
		a2371: 'SKU overcharge',
		a2372: 'Yuran pesanan',
		a2373: 'Yuran operasi',
		a2374: 'Hadiah baharu untuk pembeli',
		a2375: 'Buat gudang persendirian dan gudang pengedaran',
		a2376: 'Penjual tempatan yang membina gudang mereka sendiri di negara Asia Tenggara hanya boleh menggunakan sistem ERP, mencipta akaun gudang persendirian baharu pada halaman kebenaran kedai dan serta-merta menggunakan keseluruhan proses ERP kami yang cekap. ',
		a2377: 'Kebenaran laman web rasmi',
		a2378: 'Simpan pengasingan IP tempatan',
		a2379: 'Status kebenaran',
		a2380: 'Pada masa ini tiada kedai yang dibenarkan',
		a2381: 'Butiran alamat',
		a2382: 'Peraturan pengecasan',
		a2383: 'Apabila dilumpuhkan, gudang semasa akan disembunyikan apabila pengguna mencetuskan gelagat pemilihan gudang',
		a2384: 'Lihat peraturan pengecasan',
		a2385: 'Sila isi kandungan yang ditandakan dengan asterisk merah! ',
		a2386: 'Berjaya mencipta sub-kedudukan! ',
		a2387: 'Import borang excel',
		a2388: 'Seret fail ke sini, atau',
		a2389: 'Anda hanya boleh mengimport helaian excel dengan akhiran .xlsx/.xls',
		a2390: 'Fail sedang disahkan, sila tunggu',
		a2391: 'Sahkan Import',
		a2392: 'Produk sudah ada di gudang',
		a2393: 'Mengikat produk dalam talian',
		a2394: 'Produk dalam talian segerak',
		a2395: 'Produk pengikat',
		a2396: 'Anda boleh mencari nama, sku, ID produk',
		a2397: 'Ikat produk',
		a2398: 'Pengesahan data berjaya, jumlah',
		a2399: 'Produk sku, sila teruskan beroperasi! ',
		a2400: 'Mengeluarkan dari rak',
		a2401: 'Sila import borang excel',
		a2402: 'Menyegerakkan kedai:',
		a2403: 'Produk dalam talian',
		a2404: 'Dijangka mengambil masa 15-30 saat untuk menyegerakkan produk dalam talian. Selepas sistem menggesa bahawa penyegerakan berjaya, sila muat semula halaman itu sendiri! ',
		a2405: 'Penyegerakan selesai, sila muat semula halaman! ',
		a2406: 'Ralat mendapatkan data, sila cuba sebentar lagi! ',
		a2407: 'Sila pilih produk! ',
		a2408: 'Hanya boleh dipilih',
		a2409: 'Fail, sedang dipilih',
		a2410: 'Format lampiran adalah salah, sila padamkannya dan muat naik semula! ',
		a2411: 'Sila muat naik lampiran! ',
		a2412: 'Melebihi had bilangan maksimum fail yang dimuat naik! ',
		a2413: 'Rekod pembelian sejarah',
		a2414: 'Yuran tambahan',
		a2415: 'Kos logistik',
		a2416: 'Masa pembelian',
		a2417: 'Butiran Ejen',
		a2418: 'Nama panggilan',
		a2419: 'Kod Kus Ejen',
		a2420: 'Buat SKU secara manual',
		a2421: 'Berat (pilihan)',
		a2422: 'Volume (pilihan)',
		a2423: 'Sila masukkan sub-SKU gudang',
		a2424: 'Sila masukkan nama sub-SKU gudang',
		a2425: 'Sila masukkan berat produk (unit/KG',
		a2426: 'Panjang (cm)',
		a2427: 'Lebar (cm)',
		a2428: 'Tinggi (cm)',
		a2429: 'Mengikat produk dalam talian',
		a2430: 'Tambah produk mengikat baharu',
		a2431: 'Harga diskaun',
		a2432: 'Pilih pada masa ini produk inventori untuk dijilid',
		a2433: 'Berikut ialah produk dalam talian yang akan dikaitkan dan terikat',
		a2434: 'Ikat sekarang',
		a2435: 'Padam gesaan yang gagal',
		a2436: 'Gagal memadamkan produk! ',
		a2437: 'Situasi mengikat',
		a2438: 'Sebuah sku berjaya mengikat produk gudang',
		a2439: 'Ikatan sku gagal',
		a2440: 'Produk sudah terikat',
		a2441: 'Tutup, kembali ke produk gudang',
		a2442: 'Import satu klik produk dalam talian dan surat-menyurat yang mengikat',
		a2443: 'Penting!! Sila beri perhatian khusus!!!!',
		a2444: 'Fungsi ini hanya terpakai untuk kedai dengan SKU yang dirancang. Setiap kali ia digunakan, ia akan dikaitkan secara automatik dengan SKU induk dalam talian yang sama bagi produk gudang yang telah dibuat,',
		a2445: 'Kedua, SKU induk produk yang belum dibuat dalam gudang dibuat secara automatik dan digabungkan serta dikaitkan dengan SKU induk yang sama. Oleh itu, jika SKU induk produk dalam talian tidak diisi, penciptaan akan gagal! ',
		a2446: 'Fungsi ini tidak sesuai untuk kedai yang SKU asal tidak dirancang dalam talian, jika tidak, ia boleh menyebabkan kekeliruan dalam pengikatan SKU gudang yang berjaya dibuat,',
		a2447: 'Jika anda tidak pasti tentang operasi itu, anda boleh berunding dengan kakitangan perkhidmatan pelanggan Xiaosheng, terima kasih! ! (Penting!! Sila beri perhatian khusus!!!!)',
		a2448: 'Sila pilih kedai untuk diimport',
		a2449: 'Memuatkan data, sila tunggu...',
		a2450: 'Konfigurasikan produk tunggal pakej ini',
		a2451: 'Tambah item dalam gudang',
		a2452: 'Bilangan pakej',
		a2453: 'Senarai Aksesori',
		a2454: 'Kod gudang boleh dicari, sub-sku gudang',
		a2455: 'Simpan pilihan konfigurasi semasa',
		a2456: 'Bilangan pakej',
		a2457: 'Gambar itu tidak boleh kosong! ',
		a2458: 'SKU sub-gudang tidak boleh kosong! ',
		a2459: 'SkuName tidak boleh kosong! ',
		a2460: 'Produk gudang',
		a2461: 'Sudah wujud, sila jangan ulang konfigurasi! ',
		a2462: 'Tera air templat',
		a2463: 'Ganti imej harta',
		a2464: 'Letakkan produk gudang pada platform pengedaran',
		a2465: 'Isi maklumat produk pengedaran',
		a2466: 'Pengedaran di rak',
		a2467: 'Kemas kini kepada platform pengedaran',
		a2468: 'Kategori komoditi',
		a2469: 'Imej produk utama',
		a2470: 'Tambah gambar produk',
		a2471: 'Gambar diisih secara rawak',
		a2472: 'Tambah gambar',
		a2473: 'Maklumat spesifikasi',
		a2474: 'Diagihkan pada harga bekalan tetap',
		a2475: 'Diagihkan di rak dengan margin untung kasar tetap',
		a2476: 'Diedarkan pada harga kos produk',
		a2477: 'Tetapkan formula pengiraan lalai',
		a2478: 'Formula lalai',
		a2479: 'Harga spot tempatan',
		a2480: 'Harga satu penghantaran dropshipping dari tempat tempatan (termasuk yuran logistik rentas sempadan)',
		a2481: 'Antara 5-99',
		a2482: 'Diterima (5% komisen daripada platform)',
		a2483: 'Diterima selepas komisen platform',
		a2484: 'Stok di luar negeri',
		a2485: 'Harga borong yang dibeli dari China (tidak termasuk kos penghantaran)',
		a2486: 'Semua sumber barangan dalam tali pinggang industri platform menyokong model tempoh pengebilan Panax notoginseng, iaitu, penjual hanya perlu membayar deposit 30%, dan pembekal akan menghantar barang ke gudang pengumpulan platform mengikut pesanan pembelian, dan hantarkannya ke gudang luar negara platform. Hanya perlu membayar baki 70% sahaja',
		a2487: 'Adakah ia menyokong tempoh akaun 3/7',
		a2488: 'Harga diskaun runcit terendah dalam talian',
		a2489: 'Isipadu berat',
		a2490: 'Selepas harga bekalan tetap didayakan, kos produk pesanan selepas transaksi akan diselesaikan mengikut harga bekalan, dan akan diselesaikan kepada pembekal selepas ditauliahkan oleh platform. Sila isikan harga bekalan produk',
		a2491: 'Selepas kadar untung kasar tetap dihidupkan, sistem akan mengira secara automatik harga bekalan pengagihan setiap sku mengikut harga RMB diskaun terendah produk dalam talian terikat, sila isikan kadar untung kasar tetap (iaitu, ruang margin keuntungan kasar untuk setiap ejen!)! ',
		a2492: 'Dayakan harga kos produk diletakkan di atas rak, pembekal harus mengira sendiri keuntungan kasar, dan kemudian mengisi harga bekalan',
		a2493: 'Selepas menutup margin keuntungan kasar tetap, sistem tidak lagi akan mengira secara automatik harga bekalan pengedaran setiap sku berdasarkan produk dalam talian terikat, sila isikan harga bekalan produk',
		a2494: 'Sehingga 9 gambar utama boleh dimuat naik',
		a2495: 'Harga kos produk:',
		a2496: 'Kadar untung kasar tidak boleh kurang daripada 5%',
		a2497: 'Bilangan aksara dalam tajuk produk mestilah antara 2-120! ',
		a2498: 'Panjang aksara semua sku tidak boleh lebih daripada 20! ',
		a2500: 'Harga bekalan tidak boleh 0',
		a2501: 'Dikemas kini kepada platform pengedaran',
		a2502: 'Pengikatan templat berjaya! ',
		a2503: 'Produk telah dikeluarkan ke platform pengedaran',
		a2504: 'Sku',
		a2505: 'Masuk gagal',
		a2506: 'Ibu sku (diperlukan)',
		a2507: 'Adakah ia barangan sensitif',
		a2508: 'Produk dalam talian',
		a2509: 'Produk gudang import Excel',
		a2510: 'Produk eksport',
		a2511: 'Import produk gudang',
		a2512: 'Gudang telah diimport',
		a2513: 'Batalkan import',
		a2514: 'Gudang import',
		a2515: 'Sku induk adalah item yang diperlukan, masih terdapat produk yang sku induknya belum diisi, sila isi maklumat sku ibu bapa yang sepadan',
		a2516: 'Pilih produk/pakej tunggal yang dikonfigurasikan untuk hadiah',
		a2517: 'Masukkan kod bar produk',
		a2518: 'Sila masukkan maklumat kod bar produk',
		a2519: 'Butiran produk inventori',
		a2520: 'Pilih semua halaman semasa',
		a2521: 'Operasi kelompok',
		a2522: 'Alih ke perpustakaan pakej dalam kelompok',
		a2523: 'Padamkan produk terpilih dalam kelompok',
		a2524: 'Tambah sub-sku',
		a2525: 'Import dalam talian',
		a2526: 'Dicipta secara manual',
		a2527: 'Dimuat naik ke platform pengedaran',
		a2528: 'Kemas kini maklumat produk platform pengedaran',
		a2529: 'Muat naik ke Kedai TikTok',
		a2530: 'Maklumat sku ibu gudang',
		a2531: 'Watak dalam 120',
		a2532: 'Tidak terikat',
		a2533: 'Sumber barang',
		a2534: 'Ubah suai sumber barang',
		a2535: 'Lihat rekod pembelian sejarah',
		a2536: 'Jumlah kuantiti untuk dihantar yang telah diluluskan ke gudang ini',
		a2537: 'Harga kos produk',
		a2538: 'Diluluskan untuk dihantar',
		a2539: 'Semua kuantiti untuk dihantar',
		a2540: 'Inventori kunci',
		a2541: 'Automatik bermaksud untuk mendapatkan secara automatik daripada Shopee inventori yang dikunci dalam aktiviti seperti Flash, dan manual bermakna penjual perlu mengunci inventori mengikut tetapan sebenar. Kunci lalai ialah 0, iaitu, tiada kunci. Dan penjual tidak boleh mengubah suai kuantiti inventori terkunci bagi pakej yang dikonfigurasikan, dan nilai terkunci bagi pakej yang dikonfigurasikan perlu diubah suai dalam perpustakaan pakej gabungan. ',
		a2542: 'Termasuk semua kuantiti yang diluluskan dan tidak diluluskan untuk dihantar',
		a2543: 'Automatik',
		a2544: 'Manual',
		a2545: 'Pengguna Penjual',
		a2546: 'Kemas kini inventori dalam talian secara automatik',
		a2547: 'Apabila kemas kini automatik didayakan dalam gudang, inventori shopee semua produk yang terikat pada produk gudang akan disegerakkan secara automatik kepada baki inventori sebenar produk gudang',
		a2548: 'Sama ada untuk menetapkan pembungkusan bebas',
		a2549: 'Inventori bebas',
		a2550: 'Barcode',
		a2551: 'Masukkan kod bar',
		a2552: 'Harga bekalan pengedaran',
		a2553: 'Diperlukan',
		a2554: 'Pindah ke dalam pakej',
		a2555: 'Padankan ke dalam satu produk/pakej',
		a2556: 'Bergerak ke dalam satu produk',
		a2557: 'Pakej konfigurasi',
		a2558: 'Lihat log inventori',
		a2559: 'Lihat agensi',
		a2560: 'Pakej yang dikonfigurasikan',
		a2561: 'Hadiah yang dikonfigurasikan',
		a2562: 'Sama ada mahu terus menetapkan produk ini sebagai produk sensitif',
		a2563: 'Sama ada mahu terus menetapkan produk ini sebagai barangan am',
		a2564: 'Isi harga bekalan pengedaran secara pukal (￥)',
		a2565: 'Isi kadar untung kasar (perpuluhan antara 0 dan 1):',
		a2566: 'Berjaya menambah sub-SKU! ',
		a2567: 'Anda hanya boleh memasukkan nombor yang lebih besar daripada 0! ',
		a2568: 'Margin keuntungan kasar produk yang diletakkan pada platform pengedaran tidak boleh kurang daripada 5%',
		a2569: 'Harga bekalan produk yang diedarkan diperlukan, sila isi! ',
		a2570: 'Produk ini tidak boleh diedarkan, sila hubungi khidmat pelanggan! ',
		a2571: 'Gambar telah berjaya diganti! ',
		a2572: 'Sku telah dialih keluar daripada platform pengedaran:',
		a2573: ', Telah diletakkan di atas rak ke platform pengedaran',
		a2574: 'Pakej ini telah dibuka sebagai pakej individu',
		a2575: 'Pakej ini telah ditutup sebagai pakej individu',
		a2576: 'Kod gudang bagi pakej yang mana ia berada:',
		a2577: 'Bilangan maksimum aksara tidak boleh melebihi 35',
		a2578: 'Sila masukkan nombor',
		a2579: 'Bilangan maksimum nota tidak boleh melebihi 32',
		a2580: 'Berjaya mengubah suai atribut',
		a2581: 'Adakah anda pasti mahu berpindah ke perpustakaan pakej? ',
		a2582: 'Adakah anda pasti mahu berpindah ke perpustakaan produk tunggal? ',
		a2583: 'Ia telah dipindahkan ke perpustakaan pakej',
		a2584: 'Ia telah dipindahkan ke perpustakaan produk tunggal',
		a2585: 'Sesuatu produk akan ditambahkan ke perpustakaan gabungan, sila sahkan? ',
		a2586: 'Berjaya dialihkan ke perpustakaan pakej! ',
		a2587: 'Padam yang dipilih pada masa ini',
		a2588: ' Produk SKU, sila sahkan sama ada untuk meneruskan operasi ini? ',
		a2589: 'Harga kos berjaya diubah suai',
		a2590: 'Masukkan aksara dalam 120! ',
		a2591: 'Berjaya mengemas kini data! ',
		a2592: 'Gambar avatar yang dimuat naik hanya boleh dalam format JPG!',
		a2593: 'Sila masukkan maklumat kod bar! ',
		a2594: 'Kod bar produk telah berjaya dimasukkan! ',
		a2595: 'Mendayakan automatik akan secara automatik memperoleh daripada Shopee inventori terkunci yang mengambil bahagian dalam aktiviti seperti Flash',
		a2596: 'Kunci inventori secara automatik telah dihidupkan! ',
		a2597: 'Apabila ia ditetapkan kepada manual, bilangan inventori perlu dikunci mengikut tetapan sebenar penjual. Kunci lalai ialah 0, iaitu, tiada kunci. ',
		a2598: 'Penguncian automatik inventori telah dimatikan! ! ',
		a2599: 'Apabila kemas kini automatik didayakan dalam gudang, semua inventori platform produk yang terikat pada produk gudang akan disegerakkan secara automatik dengan baki inventori sebenar produk gudang. Sila sahkan sama ada untuk mendayakannya? ',
		a2600: 'Kemas kini automatik inventori dalam talian didayakan! ',
		a2601: 'Apabila kemas kini automatik inventori dalam gudang ditutup, inventori produk gudang tidak akan menjejaskan inventori platform semua produk terikat. Sila sahkan sama ada mahu terus menutup? ',
		a2602: 'Kemas kini automatik inventori dalam talian telah dimatikan! ',
		a2603: 'Padam gagal! ',
		a2604: 'Pilih sumber data dalam talian',
		a2605: 'Id Komoditi:',
		a2606: 'Butiran pengedaran produk',
		a2607: 'Pilih sumber data daripada pautan dalam talian terikat',
		a2608: 'Isi harga bekalan',
		a2609: 'Anggaran margin keuntungan kasar perlu lebih besar daripada 80%, dan harga bekalan adalah kurang daripada 50% daripada harga semasa, sebelum ia dibenarkan untuk ditetapkan sebagai produk pelepasan',
		a2610: 'Pakej gabungan',
		a2611: 'Batch bergerak ke dalam produk tunggal',
		a2612: 'Buat pakej gudang',
		a2613: 'Eksport produk inventori',
		a2614: 'Jumlah baki inventori',
		a2615: 'Sku',
		a2616: '20 Produk gudang berjaya diimport kali ini, dengan jumlah 521 sub-skus, 58554 sub-skus berjaya diikat, dan 5201 sub-skus gagal diikat',
		a2617: 'Berjaya dialihkan ke perpustakaan produk tunggal! ',
		a2618: 'Sila pilih gudang sasaran tempat produk akan disalin',
		a2619: 'Sila pilih gudang sasaran',
		a2620: 'Habis hadiah',
		a2621: 'Produk salinan gudang penuh',
		a2622: 'Buat hadiah habis pakai',
		a2623: 'Operasi berjaya! ',
		a2624: 'Produk tunggal gudang',
		a2625: 'Buat item gudang',
		a2626: 'Import dan ikat dalam talian dengan satu klik',
		a2627: 'Peringatan kehabisan stok',
		a2628: 'Berjaya diimport kali ini',
		a2629: 'Sku, berjaya diikat',
		a2630: 'Sub-sku, pengikatan gagal',
		a2631: 'Sub SKU, selepas menutup tetingkap timbul, sila muat semula untuk mendapatkan data produk gudang terkini! ',
		a2632: 'Produk akan dialihkan ke pustaka gabungan, sila sahkan? ',
		a2633: 'Mesej tugas',
		a2634: 'Kemajuan tugas',
		a2635: 'Pilih kemajuan tugas:',
		a2636: 'Buat tugas baharu',
		a2637: 'Nama tugas',
		a2638: 'Perihalan tugas',
		a2639: 'Butiran caj',
		a2640: 'Perihalan penjual',
		a2641: 'Gudang belum menerima pesanan',
		a2642: 'Gudang telah menerima pesanan',
		a2643: 'Tugas selesai',
		a2644: 'Nombor tugas',
		a2645: 'Kemajuan tugas semasa',
		a2646: 'Sila masukkan kandungan mesej',
		a2647: 'Tinggalkan mesej',
		a2648: 'Pilih kemajuan tugas',
		a2649: 'Selesaikan semua yuran',
		a2650: 'Yuran penyiapan separa',
		a2651: 'Perkhidmatan nilai tambah ialah perkhidmatan khas gudang tempatan yang dipromosikan oleh platform, seperti mencari sauh tempatan untuk siaran langsung, komunikasi telefon dengan perkhidmatan pelanggan dalam bahasa kecil, dan semakan ulasan negatif, dsb.',
		a2652: 'Tidak semua gudang di luar negara telah membuka semua perkhidmatan nilai tambah. Jika ada keperluan, sila rujuk kakitangan perkhidmatan pelanggan gudang untuk mendapatkan butiran. Perkhidmatan nilai tambah kini dalam tempoh ujian dalaman,',
		a2653: 'Semua penjual dan rakan perlu bekerjasama untuk menambah baik, berharap dapat membantu penjual dan rakan',
		a2654: 'Pemilihan wilayah',
		a2655: 'Butiran Yuran',
		a2656: 'Selesaikan semua kos tugas',
		a2657: 'Sumbangan belum selesai',
		a2658: 'Yuran',
		a2659: 'Semua tugas selesai',
		a2660: 'Pengesahan selesai',
		a2661: 'Kembali',
		a2662: 'Sahkan yuran tambahan',
		a2663: 'Padam tugasan',
		a2664: 'Pesanan gudang',
		a2665: 'Penolakan gudang',
		a2666: 'Sahkan kemajuan',
		a2667: 'Gudang telah disahkan',
		a2668: 'Selesai',
		a2669: 'Separa siap',
		a2670: 'Perihalan tugas penjual',
		a2671: 'Mesej sistem',
		a2672: 'Belum Selesai',
		a2673: 'Tiada jenis tugas',
		a2674: 'Sila masukkan nombor! ',
		a2675: 'Berjaya mencipta! ',
		a2676: 'Status pesanan telah dikembalikan! ',
		a2677: 'Selepas pengesahan ini selesai, ia akan ditolak daripada akaun kredit penjual',
		a2678: 'Mata, dan',
		a2679: 'Mata tambahan, jumlah',
		a2680: 'Mata, adakah anda mahu meneruskan operasi? ',
		a2681: 'Penyelesaian selesai! ',
		a2682: 'Penjual belum mengesahkan caj tambahan, adakah anda mahu meneruskan? ',
		a2683: 'Pengesahan ini, penjual akan bersetuju dengan cadangan gudang',
		a2684: 'Adakah anda mahu terus melaksanakan kos tambahan mata? ',
		a2685: 'Berjaya disahkan! ',
		a2686: 'Teruskan menerima perintah tugas ini? ',
		a2687: 'Berjaya menerima pesanan',
		a2688: 'Caj tambahan telah diserahkan kepada penjual, menunggu pengesahan daripada penjual! ',
		a2689: 'Mesej tidak boleh kosong! ',
		a2690: 'Kembangkan semua',
		a2691: 'Semua dilipat',
		a2692: 'Ubah suai gambar',
		a2693: 'Nama Penjual',
		a2694: 'Kuantiti inventori bebas',
		a2695: 'Pakej terkonfigurasi',
		a2696: 'Simpan',
		a2697: 'Edit',
		a2698: 'Kotak draf',
		a2699: 'Kawasan pengimbasan kod bar produk/kod gudang',
		a2700: 'Jumlah',
		a2701: 'SKU Ibu',
		a2702: 'Jumlah bilangan gudang asal',
		a2703: 'Jumlah kiraan',
		a2704: 'Simpan rekod inventori semasa',
		a2705: 'Inventori selesai',
		a2706: 'CUSCODE (kod bar)',
		a2707: 'Asal disimpan di dalam gudang',
		a2708: 'Inventori inventori sebenar',
		a2709: 'Sebab pemulangan untuk semakan diperlukan! ',
		a2710: 'Tiada data pesanan! ',
		a2711: 'Sambung semula',
		a2712: 'Rekod inventori',
		a2713: 'Inventori gudang',
		a2714: 'Jumlah bilangan inventori ini:',
		a2715: 'Adakah anda mahu meneruskan operasi pengambilan stok? Selepas pengesahan, inventori akan diubah suai dengan sewajarnya, sila semak log inventori untuk butiran! ',
		a2716: 'Ya, masukkan ke dalam storan sekarang',
		a2717: 'Storan yang berjaya! ',
		a2718: 'Gudang semasa tidak mempunyai produk ini! ',
		a2719: 'Cetak kod bar produk',
		a2720: 'Kod bar pencetakan kelompok',
		a2721: 'Berbilang kos bahan',
		a2722: 'Gudang maya',
		a2723: 'Gudang Awan',
		a2724: 'Gudang binaan sendiri',
		a2725: 'Permohonan pemindahan telah dimulakan kepada penjual, menunggu pengesahan penjual! ',
		a2726: 'Sila pilih penjual! ',
		a2727: 'Sila pilih gudang untuk dipindahkan! ',
		a2728: 'Perpindahan berjaya! ',
		a2729: 'Darab tidak boleh kurang daripada 1',
		a2730: 'Berjaya diubah suai! ',
		a2731: 'Sila isikan sebab untuk mengubah suai inventori! ',
		a2732: 'Item ini telah berjaya diikat',
		a2733: 'Pengurusan Inventori',
		a2734: 'Perpustakaan gabungan',
		a2735: 'Perpustakaan bekalan hadiah',
		a2736: 'Penjual penapis',
		a2737: 'Produk dalam gudang dianalisis oleh algoritma pintar berdasarkan data berbilang dimensi seperti kekerapan keluar dan dana yang diduduki: ia dibahagikan kepada penting (kategori A), penting umum (kategori B) dan tidak penting (kategori C)',
		a2738: 'Pengkelasan pintar ABC',
		a2739: 'Saiz',
		a2740: 'Produk terikat mestilah lebih besar daripada 0',
		a2741: 'Pesanan pembelian telah berjaya dibuat, dan nombor pesanan pembelian ialah:',
		a2742: 'Serahkan pengesahan gudang baharu',
		a2743: 'Selepas menyimpan rekod semasa, rekod inventori sebelumnya akan ditimpa, sila sahkan sama ada untuk meneruskan operasi menyimpan inventori semasa',
		a2744: 'Selepas melakukan operasi ini, data pemindahan akan diserahkan kepada gudang baharu untuk pengesahan, dan data pesanan pemindahan ini tidak akan diubah suai lagi pada masa hadapan. Sila sahkan sama ada untuk meneruskan? ',
		a2745: 'Pengesahan berjaya, dan gudang baharu akan diperiksa dan dimasukkan ke dalam storan! ',
		a2746: 'Melaksanakan sistem pengendalian ini sebenarnya akan dimasukkan ke dalam storan mengikut inventori semasa produk, sila sahkan sama ada semua inventori telah disiapkan? ',
		a2747: 'Pengesahan berjaya, dan penyimpanan telah selesai! ',
		a2748: 'Kuantiti inventori gudang lama ini',
		a2749: 'Dan inventori sebenar gudang baharu',
		a2750: 'Inventori gudang lama',
		a2751: 'Inventori gudang baharu',
		a2752: 'Pilih gudang pemindahan',
		a2753: 'Pilih gudang untuk dipindahkan',
		a2754: 'Mesej daripada penjual (pilihan)',
		a2755: 'Pindahkan nombor resit gudang',
		a2756: 'Mulakan gudang',
		a2757: 'Peringatan mesej',
		a2758: 'Gudang Pemindahan',
		a2759: 'Sahkan penyerahan',
		a2760: 'Senarai pemindahan pemindahan',
		a2761: 'Pemindahan telah selesai',
		a2762: 'Sedang memindahkan jawatan',
		a2763: 'Mulakan permohonan',
		a2764: 'Pengesahan penjual',
		a2765: 'Inventori gudang lama',
		a2766: 'Inventori gudang baharu',
		a2767: 'Menerima gudang',
		a2768: 'Gudang pemindahan tidak boleh sama dengan gudang asal! ',
		a2769: 'Gudang, atribut penjual tidak boleh kosong! ',
		a2770: 'Buat pesanan pemindahan',
		a2771: 'Pilih penjual',
		a2772: 'Mesej gudang (pilihan)',
		a2773: 'Buat',
		a2774: 'Inventori inventori lama',
		a2775: 'Gudang semasa tidak mempunyai data pengelasan pintar',
		a2776: 'Gudang semasa tidak mempunyai ABC dan hanya boleh mengklasifikasikan data',
		a2777: 'Kelas A: Kuantiti 5%~10%; Kelas kekerapan masuk dan keluar menyumbang: 60%~70%',
		a2778: 'Kelas B: Kuantiti 10~20%; Kelas kekerapan masuk dan keluar menyumbang: 20%~30%',
		a2779: 'Kelas C: 70%~80% daripada kuantiti; perkadaran kategori frekuensi masuk dan keluar: 5%~10%',
		a2780: 'Adalah disyorkan untuk meletakkan keluar dari gudang:',
		a2781: 'Kelas A: Lokasi pemilihan yang mudah (seperti pintu, barisan pertama rak)',
		a2782: 'Kelas B: kedudukan biasa (seperti kedudukan tengah)',
		a2783: 'Kategori C: kedudukan sudut (jangan bergerak dengan kerap, atau pertimbangkan untuk menggabungkan dan meletakkan)',
		a2784: 'Buat hadiah atau bahan habis pakai',
		a2785: 'SKU gudang baharu',
		a2786: 'Keluaran satu klik',
		a2787: 'Pemilihan pengedaran dikonfigurasikan',
		a2788: 'Produk semasa tidak mempunyai templat yang mengikat, sila ikat templat sebelum meneruskan penerbitan? ',
		a2789: 'OK, versi baharu',
		a2790: 'Templat Mengikat',
		a2791: 'Lihat templat yang sedang terikat',
		a2792: 'Edarkan produk ini',
		a2793: 'Pemula gudang perikatan produk yang diedarkan pada masa ini tidak mengikat templat keluaran produk, anda boleh mengingatkan pemula untuk mengikat templat untuk produk ini, atau anda boleh terus mengedarkan produk, dan kemudian mengikat anda sendiri model baharu, Terbitkan lagi! ',
		a2794: 'Teruskan mengedarkan produk semasa',
		a2795: 'Berjaya mengedarkan produk ini! ',
		a2796: 'Adakah anda pasti mahu mengedarkan produk semasa? ',
		a2797: 'Produk Gudang Perikatan',
		a2798: 'Perpustakaan pemilihan pengedaran',
		a2799: 'Perpustakaan produk siap pengedaran',
		a2800: 'Tinjauan keseluruhan produk pengedaran',
		a2801: 'Jumlah inventori baki',
		a2802: 'Bilangan Ejen',
		a2803: 'Anda pada masa ini tidak mengehadkan bilangan proksi',
		a2804: 'Kuantiti sku',
		a2805: 'Pengurusan Produk',
		a2806: 'Kawalan harga ejen',
		a2807: 'Tambah maklumat belum selesai yang diperlukan',
		a2808: 'Koleksi Komoditi',
		a2809: 'Koleksi satu klik',
		a2810: 'Koleksi pautan',
		a2811: 'Pada masa ini hanya menyokong koleksi produk di platform shopee, sila masukkan pautan halaman butiran produk! ',
		a2812: 'Tambah ke pusat templat produk',
		a2813: 'SKU induk gudang',
		a2814: 'Nama produk induk',
		a2815: 'Nama sub-komoditi gudang (pilihan)',
		a2816: 'Isi sub-sku gudang',
		a2817: 'Nama Subkomoditi Gudang',
		a2818: 'Panjang (pilihan)',
		a2819: 'Lebar (pilihan)',
		a2820: 'Ketinggian (pilihan)',
		a2821: 'Sila masukkan sku induk gudang',
		a2822: 'Tidak lebih daripada 80 aksara',
		a2823: 'Tidak lebih daripada 120 aksara',
		a2824: 'Muat turun imej asal',
		a2825: 'Ganti peta harta',
		a2826: 'Adakah ia menyokong pementasan 3/7',
		a2827: 'Jumlah komoditi',
		a2828: 'Sila muat naik gambar! ',
		a2829: 'Sila muat naik gambar dalam keadaan penyuntingan',
		a2830: 'Kemas kini telah berjaya! ',
		a2831: 'Simpan gambar',
		a2832: 'Sama ada menyokong POD tersuai',
		a2833: 'Penyertaan',
		a2834: 'Jangan ambil bahagian',
		a2835: 'Permohonan sampel percuma',
		a2836: 'Serahkan permohonan',
		a2837: 'Berjaya menghantar sampel permohonan percuma, semak kemajuan permohonan, sila ke hadapan: Saya ejen - contoh modul permohonan',
		a2838: 'Sampel permohonan',
		a2839: 'Julat masa',
		a2840: 'Status Permohonan',
		a2841: 'Untuk dihantar',
		a2842: 'Akan dikembalikan',
		a2843: 'Masa permohonan',
		a2844: 'Pemohon',
		a2845: 'Penerima',
		a2846: 'Kembalikan ulasan',
		a2847: 'Return Note',
		a2848: 'Komen audit',
		a2849: 'Ulasan Semakan',
		a2850: 'Maklumat kurier semasa masih belum dikemas kini, sila tunggu dengan sabar, jika anda mempunyai sebarang pertanyaan, sila hubungi pembekal',
		a2851: 'Maklumat nyatakan',
		a2852: 'Contoh video/foto maklum balas',
		a2853: 'Pembekal sedang memproses dan akan memulangkan mata kemudian',
		a2854: 'APP platform pengedaran: Ia boleh merealisasikan pemilihan dan pengedaran APP, dan menerbitkannya ke Shopee, Lazada, TikTok dan platform lain, termasuk semakan pesanan, pengurusan pemulangan, terjemahan serentak, dsb.',
		a2855: 'Pilih produk yang diimport ke dalam gudang pengedaran',
		a2856: 'Maklumat produk yang sempurna',
		a2857: 'Langkah sebelumnya',
		a2858: 'Seterusnya',
		a2859: 'Kod Kus Produk yang boleh dicari, SKU ibu bapa/anak, nama komoditi',
		a2860: 'Harga bekalan (unit: RMB)',
		a2861: 'Harga bekalan ialah harga penghantaran sekeping yang diberikan kepada penjual, kos pembelian yang perlu dibayar oleh penjual untuk setiap keping keluar dari gudang',
		a2862: 'Pendapatan sebenar pembekal selepas ditolak komisen sistem diterima',
		a2863: 'Dikumpul',
		a2864: 'Inventori tersedia untuk dijual',
		a2865: 'Mewakili inventori maksimum yang tersedia untuk pengedaran di gudang luar negara atau gudang persendirian',
		a2866: 'Inventori yang diperuntukkan hanya boleh diperuntukkan daripada inventori sebenar di gudang, jadi ia tidak melebihi inventori sebenar di gudang',
		a2867: 'Inventori berasingan',
		a2868: 'Sila masukkan nama produk! ',
		a2869: 'Sila masukkan sku induk produk',
		a2870: 'Harga bekalan diperlukan! ',
		a2871: 'Inventori yang dipindahkan tidak boleh lebih besar daripada inventori produk di gudang! ',
		a2872: 'Sahkan penyerahan? ',
		a2873: 'Berjaya mencipta produk pengedaran, sedang melaksanakan pembahagian inventori, operasi templat mengikat, jangan tinggalkan halaman semasa',
		a2874: 'Berjaya membahagikan inventori! ',
		a2875: 'Tambah pada belum selesai',
		a2876: 'Berjaya ditambahkan dan templat asal telah disimpan',
		a2877: 'Formula pengiraan harga runcit lalai',
		a2878: 'Kotak draf sementara',
		a2879: 'Bilangan maksimum aksara dalam nama spesifikasi pada rak tidak boleh melebihi 20! ',
		a2880: 'Bilangan aksara dalam tajuk produk mestilah lebih daripada 20 dan kurang daripada 100',
		a2881: 'Selepas memilih untuk menerbitkan kedai, sistem akan mendapatkan maklumat kategori secara automatik',
		a2882: 'Pilih kategori',
		a2883: 'Kategori terpilih',
		a2884: 'Sahkan kategori dan teruskan menerbitkan produk',
		a2885: 'Sila pilih kategori! ',
		a2886: 'Sahkan kategori dan teruskan menerbitkan produk shopee',
		a2887: 'Terbitkan produk TikTok',
		a2888: 'Sahkan kategori dan teruskan menerbitkan produk TikTok',
		a2889: 'Kuantiti pesanan belum selesai',
		a2890: 'Kuantiti pesanan belum selesai',
		a2891: 'Margin untung kasar tetap',
		a2892: 'Lihat pautan mengikat',
		a2893: 'Selepas menutup margin keuntungan kasar tetap, sistem tidak lagi secara automatik mengira harga bekalan pengedaran setiap sku berdasarkan produk dalam talian terikat, mengesahkan untuk terus ditutup? ',
		a2894: 'Produk gudang belum terikat pada pautan dalam talian lagi! ',
		a2895: 'Produk gudang tidak mempunyai maklumat sub-SKU! ',
		a2896: 'Produk telah dialih keluar daripada platform pengedaran! ',
		a2897: 'Produk dengan kadar untung kasar tetap tidak boleh mengubah harga bekalan pengedaran! ',
		a2898: 'Berjaya mengubah suai harga bekalan',
		a2899: 'Nama produk:',
		a2900: 'Ibu sku:',
		a2901: 'Alih keluar inventori',
		a2902: 'Simpan perubahan',
		a2903: 'Maklumat asas',
		a2904: 'Nama produk:',
		a2905: 'Perihalan komoditi:',
		a2906: 'Harga bagi pihak sekeping (tempatan)',
		a2907: 'Tambahkan pada senarai niat membeli',
		a2908: 'Logistik akhir:',
		a2909: 'Jumlah komoditi:',
		a2910: 'Berat komoditi:',
		a2911: 'Senarai Niat Membeli',
		a2912: 'Tiada gambar untuk spesifikasi ini',
		a2913: 'Kosongkan "Niat Pembelian"',
		a2914: 'Untuk menjana pesanan pembelian',
		a2915: 'Produk ini sudah wujud dalam senarai niat pembelian dan tidak boleh ditambah lagi',
		a2916: 'Templat terikat telah dikemas kini',
		a2917: 'Butiran mengikat komoditi',
		a2918: 'Boleh diikat secara automatik',
		a2919: 'Status pra-jualan',
		a2920: 'Bilangan hari pra-jualan',
		a2921: 'Buka semua habis dijual untuk pra-jualan',
		a2922: 'Tutup semua habis dijual dan pindahkan ke pra-jualan',
		a2923: 'Inventori baki',
		a2924: 'Adakah ia terikat',
		a2925: 'Lepaskan',
		a2926: 'Mengikat',
		a2927: 'Tambah maklumat produk gudang',
		a2928: 'Kuantiti stok',
		a2929: 'Sila pilih SKU induk gudang untuk diganti (hubungan pengikatan dan konfigurasi asal kekal tidak berubah)',
		a2930: 'Sku ibu bapa boleh dicari',
		a2931: 'Apabila produk ditukar kepada pra-jualan, jika produk telah mengambil bahagian dalam Tawaran Bundle shopee, Jualan Kilat Kedai Saya, promosi produk Pilihan Teratas, sila tarik diri daripada aktiviti di atas! ',
		a2932: 'Permohonan',
		a2933: 'Pulihkan',
		a2934: 'Atribut kategori',
		a2935: 'Sifat asas',
		a2936: 'Sahkan Keluaran',
		a2937: 'Harga saham',
		a2938: 'Maklumat versi baharu',
		a2939: 'Pilih negara',
		a2940: 'Isi nama templat',
		a2941: 'Pemilihan tapak',
		a2942: 'Templat pengikat',
		a2943: 'Kembali untuk semakan',
		a2944: 'Masa penciptaan produk',
		a2945: 'Terbitkan kepada',
		a2946: 'Produk tidak normal, sila ejen semula! ',
		a2947: 'Kepulangan yang berjaya! ',
		a2948: 'Sila pilih templat untuk diikat! ',
		a2949: 'Penyelesaian Sistem Gudang Luar Negara Asia Tenggara',
		a2950: 'Sistem gudang luar negara yang dibina sendiri menyokong ERP/WMS pada masa yang sama, menyokong Shopee/Lazade dan platform lain, penyegerakan inventori/pengedaran satu klik/pembantu tuntutan/sembang berbilang kedai, dsb.',
		a2951: 'Sediakan penyelesaian pengurusan kedai sehenti',
		a2952: 'Percuma untuk digunakan',
		a2953: '0 Kemasukan kos',
		a2954: 'Tiada bayaran pemasangan awal/tiada pelayan/penciptaan satu klik',
		a2955: 'Sokongan pasukan profesional',
		a2956: 'Satu set lengkap latihan sistem pengurusan gudang luar negara dan bantuan sokongan teknikal akan membolehkan perniagaan gudang di luar negara anda beroperasi dengan cepat. ',
		a2957: 'Permulaan pantas',
		a2958: 'Versi ringkas operasi seperti bodoh, sistem berbilang bahasa (Bahasa Cina, Inggeris, Thai dan Vietnam) adalah mudah untuk penduduk tempatan di Asia Tenggara untuk belajar dengan cepat dan bermula. ',
		a2959: 'Lebih banyak sumber pendapatan',
		a2960: 'Penghantar barang berkualiti yang lulus audit boleh menikmati harga yang sama, dan menyokong lebih banyak pengedar harga perjalanan pertama/berbilang negara gudang luar negara yang setara. ',
		a2961: 'Penjual segera mendapati pesanan ditolak oleh COD atau hilang melalui penghantaran ekspres, supaya penjual boleh menuntut pampasan daripada platform tepat pada masanya, memulihkan kerugian dan meningkatkan keuntungan bersih anda',
		a2962: 'Kod QR pengecaman WeChat',
		a2963: 'Tambah perkhidmatan pelanggan WeChat',
		a2964: 'Kelebihan kami',
		a2965: 'Menyediakan perkhidmatan pergudangan luar negara berkualiti tinggi',
		a2966: '7*12 jam perkhidmatan pelanggan yang bertimbang rasa',
		a2967: 'Kluster Pelayan Diedarkan',
		a2968: 'Pelayan luar negara',
		a2969: 'Kod imbasan WeChat',
		a2970: 'Imbas kod untuk memuat turun',
		a2971: 'Apl Gudang',
		a2972: 'Sistem gudang luar negara yang menumpukan perkhidmatan kepada penjual tempatan di Asia Tenggara',
		a2973: 'Kemasukan sistem WMS',
		a2974: 'Rakan kongsi sertai',
		a2975: 'Muat turun aplikasi',
		a2976: 'Penjual tempatan',
		a2977: 'Anti-terlebih jual',
		a2978: 'Inventori penyegerakan automatik berbilang platform dan berbilang kedai',
		a2979: 'Pengurusan Gudang Luar Negara',
		a2980: 'Mudah digunakan',
		a2981: 'Tabur WMS',
		a2982: 'Berbilang bahasa',
		a2983: 'Amat dipermudahkan',
		a2984: 'Keselamatan data',
		a2985: 'Sistem stabil',
		a2986: 'Kecekapan Melampau',
		a2987: 'Asia Tenggara',
		a2988: 'Fokus pada perkhidmatan penyetempatan di Asia Tenggara selama bertahun-tahun',
		a2989: 'Pengalaman sekarang',
		a2990: 'Sokongan',
		a2991: 'Sila gunakan IE10 atau lebih tinggi, Chrome, Firefox untuk menyemak imbas dengan resolusi terbaik melebihi 1440×900',
		a2992: 'Penyelesaian sistem gudang luar negara profesional di Asia Tenggara',
		a2993: 'Penghantar Barang Asia Tenggara',
		a2994: '0 kos untuk membuat gudang di luar negara',
		a2995: 'Sokong gudang francais untuk menetap di, mengurus dan mengawal pelanggan gudang luar negara dengan mudah',
		a2996: 'Buat gudang luar negara dalam talian WMS Asia Tenggara secara percuma',
		a2997: 'Versi mudah operasi seperti bodoh, sistem berbilang bahasa (Cina, Inggeris, Thai dan Vietnam)',
		a2998: 'Adalah mudah bagi penduduk tempatan di Asia Tenggara untuk belajar dengan cepat. ',
		a2999: 'Satu set lengkap latihan sistem pengurusan gudang luar negara dan bantuan sokongan teknikal',
		a3000: 'Biarkan perniagaan gudang anda di luar negara berkembang dengan cepat. ',
		a3001: 'Sistem gudang luar negara yang dibina sendiri',
		a3002: 'Sokong ERP/WMS pada masa yang sama, sokong Shopee/Lazade dan platform lain',
		a3003: 'Penyegerakan inventori/pengedaran satu kunci/pembantu tuntutan/sembang berbilang kedai, dsb.',
		a3004: 'Platform pengedaran spot di Asia Tenggara/Taiwan',
		a3005: 'Hubungi kami, dan kami akan segera mewujudkan sistem gudang luar negara di Asia Tenggara pada kos sifar! ',
		a3006: 'Semua habis dijual dan dipindahkan ke pra-jualan',
		a3007: 'Pilihan',
		a3008: 'Ikat inventori aksesori produk',
		a3009: `Hanya apabila produk siap terdiri daripada berbilang aksesori ke dalam satu SKU produk, contohnya: jam penggera terdiri daripada 1 badan jam + 2 bateri AA<br/>
		SKU jam penggera siap dijual kepada dunia luar. Setelah jam penggera siap dijual, 1 inventori aksesori badan jam dan 2 inventori aksesori bateri AA akan ditolak.<br/>
		Dan kuantiti inventori jam penggera siap bergantung pada bilangan kombinasi aksesori. `,
		a3010: 'Meningkatkan',
		a3011: 'Pilih laluan utama kedai Xiaosheng',
		a3012: 'Anggaran berat',
		a3013: 'Anggaran volum',
		a3014: 'Buat dan serahkan pesanan storan',
		a3015: 'Semua sub-SKU telah dipilih',
		a3016: 'Hanya apabila produk siap terdiri daripada berbilang aksesori untuk membentuk SKU produk, contohnya: jam penggera terdiri daripada 1 badan jam + 2 bateri AA dan SKU jam penggera siap dijual secara luaran, sekali 1 jam penggera dijual Untuk produk siap, satu inventori aksesori badan jam dan dua inventori aksesori bateri AA akan ditolak, dan kuantiti inventori jam penggera siap bergantung pada bilangan kombinasi aksesori. ',
		a3017: 'Berjaya padamkan produk ini! ',
		a3018: 'Gagal memadamkan item semasa! ',
		a3019: 'Sila pilih produk gudang untuk dipadamkan! ',
		a3020: 'Bilangan kepingan yang dimasukkan sekurang-kurangnya sama dengan atau lebih daripada 1',
		a3021: 'Muat naik fail dengan Excel sahaja (iaitu, akhiran ialah .xlsx)',
		a3022: 'Saiz fail tidak boleh melebihi 10M',
		a3023: 'Fail berjaya dimuat naik',
		a3024: 'Sila pilih produk yang perlu dibuat dan disimpan',
		a3025: 'Kod gudang ialah',
		a3026: 'Kemas kini gambar dalam gudang',
		a3027: 'Muat naik fail jpg/png sahaja',
		a3028: 'Tambah item dalam gudang',
		a3029: 'Matikan kemas kini automatik dalam gudang',
		a3030: 'Buka kemas kini automatik di gudang',
		a3031: 'Anggaran masa ketibaan',
		a3032: 'Tarikh ketibaan',
		a3033: 'Masukkan pengangkutan (pengangkutan secara langsung akan menjejaskan pengiraan nilai barang, disyorkan untuk masuk)',
		a3034: 'Pengenalan kepada konfigurasi perpustakaan pakej gabungan',
		a3035: `<p style="color:red;font-weight:bold;font-size:16px">Jika kedai dalam talian anda menjual produk pakej gabungan, anda perlu mengkonfigurasi perpustakaan pakej gabungan (jika tiada pakej gabungan, anda boleh mengabaikannya)</p>
		<br />
		<p>Langkah pertama. Buat [Pustaka Pakej Gabungan]: import produk dalam talian melalui [Penciptaan Manual] atau [Import Products];</p>
		<p>Perhatikan bahawa hanya satu pautan perlu diimport, dan pautan produk dalam talian yang lain dari model yang sama perlu diikat pada produk gudang yang baru diimport. </p>
		<router-link :to="{path:'/userStoreItems/products'}">
			<p style="color:#409EFF;padding:10px 0;cursor:pointer">Jika produk yang anda jual dalam talian ialah item dalam gudang, sila lihat pengenalan konfigurasi pustaka item dalam gudang.</p>
		</router-link>
		
		<br />
		<p>Langkah 2. Konfigurasikan [Pakej Gabungan]: Klik [Konfigurasi Pakej] sub-SKU, dan pilih konfigurasi daripada [Dalam Gudang] yang dihasilkan;</p>
		<br />
		<p>① Anda mesti membuat [Dalam Gudang] dahulu sebelum anda boleh mengkonfigurasi pakej gabungan, lihat "Pengenalan kepada Menyediakan dalam Gudang" untuk mendapatkan butiran)</p>
		<p>②Produk dan pakej tunggal mesti berada di gudang yang sama (tidak dibenarkan membuat satu produk di gudang luar negara di Malaysia, tetapi konfigurasikan pakej di gudang luar negara di Thailand)</p>
		<p>③Pakej tidak boleh dipadamkan dalam kes berikut: apabila satu produk telah dikonfigurasikan (ia perlu dinyahkonfigurasikan dahulu), apabila ia telah disimpan dalam transit (ia perlu disiapkan atau dipadamkan dahulu)</p>
		<br />
		<p>Langkah ketiga. Ikat pautan dalam talian: kaitkan dan ikat produk dalam [Pustaka Pakej Gabungan] dengan produk setiap kedai dalam talian;</p>
		<br />
		<p>①Perkaitan dan pengikatan automatik (dengan syarat SKU induk setiap kedai dalam talian perlu konsisten sepenuhnya)</p>
		<p>②Anda boleh mengaitkan dan mengikat secara manual (setiap sub-SKU terikat pada produk dalam talian yang sepadan di kedai)</p>
		<p>③Perkaitan automatik dan status mengikat semua kedai boleh diedit secara intuitif. </p>
		<br />
		<p>Langkah 4. Dayakan penyegerakan inventori dalam talian: operasi kelompok atau klik [Kemas kini inventori dalam talian secara automatik] sub-sku untuk mula menyegerakkan inventori sebenar pakej dalam talian;</p>
		<br />
		<p>1. Baki inventori sebenar pakej bergantung pada nisbah inventori item dalam gudang. Sebagai contoh, jika pakej jualan adalah satu set 2 pen merah, dan terdapat 10 pen merah yang tinggal di perpustakaan produk tunggal, maka mengikut nisbah padanan, hanya 5 keping bungkusan yang tinggal dalam stok. </p>
		<br />
		<p>2. Inventori pakej tidak boleh diubah suai secara langsung, dan gudang hanya perlu mengira kuantiti sebenar [dalam gudang pesanan gudang]. Pustaka pakej dikonfigurasikan secara maya, jadi inventori bergantung pada item sebenar dalam gudang. Masuk dan keluar dari gudang semuanya dijalankan di dalam [dalam gudang pesanan gudang]. </p>`,
		a3036: 'Tiada lagi peringatan pada masa hadapan',
		a3037: 'Tukar kemas kini inventori dalam talian',
		a3038: 'Alih ke perpustakaan produk tunggal dalam kelompok',
		a3039: 'Ganti SKU induk dalam kelompok',
		a3040: 'Buat pakej',
		a3041: 'Dicipta secara manual',
		a3042: 'Import dalam talian',
		a3043: 'Ikat semua SKU kanak-kanak',
		a3044: 'Pengikat persatuan manual',
		a3045: 'Pengikat persatuan automatik',
		a3046: 'Padam sku ibu bapa',
		a3047: 'Tambah sub-SKU gudang secara manual',
		a3048: 'Import sub-SKU gudang dalam talian',
		a3049: 'Edit situasi dalam talian yang mengikat',
		a3050: 'Bergantung pada kuantiti inventori maksimum yang boleh digabungkan daripada item dalam gudang sebenar yang dikonfigurasikan dalam pakej',
		a3051: 'Inventori dalam talian bagi produk terikat akan sentiasa dikemas kini kepada inventori dalam talian sebenar di gudang (kecuali produk pra-jualan)',
		a3052: 'Barangan yang dibungkus secara individu',
		a3053: 'Inventori pembungkusan individu',
		a3054: 'Pindah ke perpustakaan produk tunggal',
		a3055: 'Batalkan pembungkusan bebas',
		a3056: 'Tetapkan pembungkusan bebas',
		a3057: 'Bersama kali ini',
		a3058: 'Produk telah dimatikan kemas kini automatik dan dalam stok! ',
		a3059: 'Kemas kini automatik dimatikan dan disimpan di dalam gudang! ',
		a3060: 'Produk telah menghidupkan autokemas kini dan dalam stok! ',
		a3061: 'Kemas kini automatik dihidupkan dan disimpan di dalam gudang! ',
		a3062: 'Sesuatu produk akan ditambahkan pada perpustakaan produk tunggal, sila sahkan? ',
		a3063: 'Adakah anda pasti mahu berpindah ke perpustakaan produk tunggal?',
		a3064: 'Ia telah dipindahkan ke perpustakaan item! ',
		a3065: 'Apabila ia ditetapkan kepada automatik, bilangan inventori yang perlu dikunci akan ditetapkan mengikut tetapan sebenar penjual. Kunci lalai ialah 0, iaitu, tiada kunci. ',
		a3066: 'Sila sahkan sama ada ia ditetapkan sebagai produk yang dibungkus secara individu?',
		a3067: 'Sila sahkan sama ada untuk membatalkan produk yang dibungkus secara individu?',
		a3068: 'Berjaya membatalkan! ',
		a3069: 'Masukkan bar produk',
		a3070: 'Sila masukkan maklumat kod bar',
		a3071: 'Jumlah inventori item tunggal yang digunakan oleh bungkusan yang akan dihantar',
		a3072: 'Konfigurasikan pakej item ini',
		a3073: 'Kod gudang Suit',
		a3074: 'Bilangan konfigurasi pakej',
		a3075: 'Inventori pesanan',
		a3076: 'Bilangan pakej untuk dihantar',
		a3077: 'Pengenalan untuk menyediakan perpustakaan item gudang',
		a3078: `			<p style="color:red;font-weight:bold;font-size:16px">Notis! Hanya terdapat satu produk dalam gudang dan semua sub-SKU dalam talian bagi item yang sama mesti terikat pada produk dalam gudang yang sama untuk mengemas kini inventori secara serentak dengan berkesan.</p>
		<br />
		<p>Langkah pertama. Wujudkan [In-Warehouse]: Import produk dalam talian melalui [Manual Creation] atau [Import Products];</p>
		<p>Perhatikan bahawa hanya satu pautan perlu diimport, dan pautan produk dalam talian yang lain dari model yang sama perlu diikat pada produk gudang yang baru diimport. </p>
		<router-link :to="{path:'/userStoreItems/accessories'}">
			<p style="color:#409EFF;padding:10px 0;cursor:pointer">Jika produk jualan dalam talian anda mempunyai pakej gabungan, sila lihat pengenalan kepada konfigurasi pakej gabungan. Jika tiada pakej, pergi ke langkah kedua.</p>
		</router-link>
		<br />
		<p>Langkah kedua. Kaitkan dan ikat produk dalam [Perpustakaan Item Gudang] dengan produk setiap kedai dalam talian;</p>
		<br />
		<p>①Perkaitan dan pengikatan automatik (dengan syarat SKU induk setiap kedai dalam talian perlu konsisten sepenuhnya)</p>
		<p>②Ia boleh dikaitkan dan dijilid secara manual (setiap sub-SKU terikat pada produk dalam talian kedai yang sepadan)</p>
		<p>③Perkaitan automatik dan status mengikat semua kedai boleh diedit secara intuitif.</p>
		<br />
		<p>Langkah 3. Hidupkan inventori penyegerakan, operasi kelompok atau klik [Kemas kini inventori dalam talian secara automatik] sub-sku, dan inventori dalam talian akan mula disegerakkan.</p>
		<br />
		<p>1. Kehabisan stok: Jika mana-mana produk di platform menjual 1 keping inventori, semua produk yang berkaitan di kedai juga akan menolak 1 keping inventori pada masa yang sama</p>
		<p>2. Pergudangan: Produk yang baru tiba, selepas pengesahan oleh kedua-dua penjual dan gudang, inventori secara automatik akan meningkatkan kuantiti ketibaan produk yang sepadan.</p>
		<p>3. Pra-pendudukan: Mana-mana produk pada platform yang mengambil bahagian dalam acara jualan Flash secara automatik boleh mendahului inventori dalam gudang dan mengeluarkannya untuk dijual selepas acara bermula</p>
		<br />
		<p>Notis! Pautan produk dalam talian berbilang model yang sama tidak boleh diimport terus untuk menjana berbilang produk gudang, kerana hanya terdapat satu produk fizikal. Untuk menyegerakkan inventori dengan tepat, anda mesti mencipta [Produk Tunggal Dalam Gudang] atau [Pakej Gabungan] dahulu, melalui [ Produk Dalam Gudang] atau [Pakej Gabungan] Untuk mengikat berbilang pautan dalam talian bagi produk yang sama (contohnya, pautan dalam talian model yang sama di kedai berbeza di Shopee atau Lazade), iaitu, berbilang sub-SKU dalam talian bagi model yang sama terikat kepada produk dalam gudang yang sama.</p>`,
		a3079: 'Ramalkan produk kehabisan stok secara automatik berdasarkan kitaran stok, kitaran stok lalai ialah 7 hari (boleh diubah suai)',
		a3080: 'Buat satu produk',
		a3081: 'Salinan produk gudang penuh',
		a3082: 'Eksport keseluruhan gudang',
		a3083: 'Sila semak! ',
		a3084: 'Ucapan yang ditolak:',
		a3085: 'Ditolak',
		a3086: 'Adakah anda ingin memohon pesanan binaan sendiri untuk sampel ini?',
		a3087: 'Status muat naik kelompok',
		a3088: 'Sila tunggu semasa memuat naik produk. . . ',
		a3089: 'Status muat naik',
		a3090: 'Terbitkan produk TikTok Shop dalam kelompok',
		a3091: 'Pilih semula kategori',
		a3092: 'Senarai Produk',
		a3093: 'Kira harga runcit mengikut formula yang ditetapkan',
		a3094: 'Tiada formula lagi',
		a3095: 'Klik untuk menetapkan! ',
		a3096: 'Tetapkan sekarang',
		a3097: `Tetapkan formula harga harga runcit, dari kiri ke kanan: yuran keluar, kadar pertukaran, diskaun, margin keuntungan：
		<p>1. Yuran keluar: Pada masa ini, bayaran keluar untuk gudang Melayu ialah 3 yuan, anda boleh mengisi 3</p>
		<p>2. Kadar pertukaran: kadar pertukaran RMB kepada mata wang tempatan, seperti 1rmb=1.5 MYR, iaitu: 0.667 kadar pertukaran</p>
		<p>3. Kadar keuntungan: kadar keuntungan kasar yang anda ingin perolehi, seperti 30%, tetapkan 30</p>
		<p>4. Diskaun: Jika anda bercadang untuk menetapkan harga jualan sebagai 40% daripada harga asal, iaitu: 40 diskaun</p>`,
		a3098: 'Segera lepaskan',
		a3099: 'Berjaya diterbitkan',
		a3100: 'Semua tali pinggang industri',
		a3101: 'Tiada zon perindustrian',
		a3102: 'Pelepasan',
		a3103: 'Sokongan 3/7 pementasan',
		a3104: 'Bahan video sisi jenama',
		a3105: 'Kategori:',
		a3106: 'Menapis produk POD tersuai',
		a3107: 'Bagaimanakah penjual mengagihkan bekalan? ',
		a3108: 'Cari ibu bapa sku',
		a3109: 'Cari nama produk',
		a3110: 'Cari kod gudang',
		a3111: 'Sesetengah produk adalah percuma kos penghantaran, yang lain dicaj mengikut pakej mengikut piawaian gudang di luar negara, contohnya',
		a3112: 'Anggaran margin keuntungan kasar',
		a3113: 'Harga bagi pihak sekeping',
		a3114: 'Yuran operasi keluar',
		a3115: 'Percuma',
		a3116: 'Stok spot tempatan',
		a3117: 'Hubungi Pengedar',
		a3118: 'Pembelian tempoh akaun',
		a3119: 'Sila sahkan sama ada hendak mengedarkan produk?',
		a3120: 'Produk telah berjaya disebarkan sebagai ejen, dan anda boleh terus menyebarkan barang. Anda boleh melihat semua produk yang telah disebarkan dalam "Saya telah bertindak sebagai ejen".',
		a3121: 'Cari kod gudang',
		a3122: 'Cari sku induk produk',
		a3123: 'Semua tali pinggang industri',
		a3124: 'Ejen',
		a3125: 'Akaun Agensi',
		a3126: 'Nama Ejen',
		a3127: 'Aktiviti pengedaran',
		a3128: 'Peringatan pelepasan',
		a3129: 'Harga bekalan semasa',
		a3130: 'Harga diskaun runcit terendah dalam talian (RMB)',
		a3131: 'Pautan halaman perkongsian h5',
		a3132: 'Seorang penjual telah pun mewakili produk ini',
		a3133: 'Perihalan aktiviti',
		a3134: 'Nisbah rebat Tahap 1',
		a3135: 'Nisbah rebat Tahap 2',
		a3136: 'Inventori komoditi minimum',
		a3137: 'Kategori komoditi aktif',
		a3138: 'Daftar sekarang',
		a3139: 'Nisbah rebat tiga peringkat',
		a3140: 'Barang clearance: kadar keuntungan kasar mestilah lebih besar daripada atau sama dengan 80%, dan harga bekalan kurang daripada 50% daripada harga bekalan semasa',
		a3141: 'Tidak layak',
		a3142: 'Harga bekalan pelepasan',
		a3143: 'Rebat berbilang peringkat, pengedaran dan pengembangan pelanggan, pengambilan aktif',
		a3144: 'Garis Panduan Operasi Pembekal',
		a3145: 'Jana "Halaman Perkongsian Edaran Saya"',
		a3146: 'Tarikh pelancaran',
		a3147: 'Saya mahu mengosongkan gudang',
		a3148: 'Barangan pelepasan',
		a3149: 'Pengedaran luar rak',
		a3150: 'Kemas kini produk pengedaran berjaya! ',
		a3151: 'Margin keuntungan kasar produk pelepasan mestilah lebih besar daripada 80%',
		a3152: 'Harga bekalan pelepasan hendaklah kurang daripada 50% daripada harga bekalan semasa',
		a3153: 'Diserahkan! ',
		a3154: 'Produk ini sedang dikongsi',
		a3155: 'Penjual sedang menjual dalam talian, dan pengguna tidak dibenarkan mengalih keluar produk daripada platform pengedaran. Jika anda perlu memaksa produk untuk dialih keluar, sila hubungi perkhidmatan pelanggan platform? ID WeChat perkhidmatan pelanggan: shopsbu001',
		a3156: 'Adakah anda pasti akan terus membuka rak?',
		a3157: 'Pembekal:',
		a3158: 'Produk telah dialih keluar daripada platform pengedaran:',
		a3159: ', Jika ejen telah berjaya meletakkan produk di rak, sila tukar status produk itu sendiri!',
		a3160: 'Kejayaan',
		a3161: 'Adakah anda pasti untuk mengambil bahagian dalam aktiviti pengedaran dan pengembangan pelanggan? ',
		a3162: 'Pertanyaan kod pesanan/gudang',
		a3163: 'Tiada rekod pesanan',
		a3164: 'Jumlah harga bekalan',
		a3165: 'Pembekal dibayar penuh',
		a3166: 'Harga unit bekalan',
		a3167: 'Status Pesanan:',
		a3168: 'Belum selesai',
		a3169: 'Pesanan rekod, adakah anda mahu meneruskan operasi ini? ',
		a3170: 'Mata pulangan',
		a3171: 'Mata tolak',
		a3172: 'Persetujuan kelompok',
		a3173: 'Penolakan kelompok',
		a3174: 'Pesanan binaan sendiri kelompok',
		a3175: 'Mata telah dikembalikan',
		a3176: 'Foto/Video',
		a3177: 'Berikut ialah bahan video dari sisi jenama, yang boleh digunakan dalam TIKTOK dan video lain, perhatikan penyuntingan sekunder, dan alih keluar pendua!',
		a3178: 'Pautan',
		a3179: 'Kod pengekstrakan',
		a3180: 'Isi, buat pesanan sekarang',
		a3181: 'Pilih kuantiti pembelian',
		a3182: 'Buat pesanan sekarang',
		a3183: 'Beli sekarang',
		a3184: 'Berjaya menghantar pesanan! ',
		a3185: 'Kata Laluan',
		a3186: 'Sila masukkan ID pengguna atau nombor telefon mudah alih',
		a3187: 'Log masuk',
		a3188: 'Tiada akaun? Klik Daftar',
		a3189: 'Pengedaran titik',
		a3190: 'Garis Panduan Operasi Pengedaran',
		a3191: 'Garis panduan untuk operasi pengedaran di rak di gudang ujian China',
		a3192: 'Garis panduan untuk pengendalian pengedaran di rak pembekal',
		a3193: 'Garis Panduan untuk Ejen untuk Menyenaraikan Operasi',
		a3194: 'Kargo udara ekspres dari gudang ujian Shenzhen China ke Asia Tenggara (3 hari), tidak termasuk pengangkutan udara',
		a3195: 'Pergi ke China untuk membeli',
		a3196: 'Bekalan borong China adalah mencukupi, dan sampel percuma disokong. Selepas pesanan kumpulan pertama, yuran sampel boleh dikembalikan. Klik untuk membeli terus, atau hubungi kakitangan perkhidmatan pelanggan Xiaosheng. ',
		a3197: 'Semua wilayah',
		a3198: 'Panduan',
		a3199: 'Semua negara',
		a3200: 'Gagal memuat naik gambar',
		a3201: 'Adakah anda pasti mahu memadamkan sesi ini?',
		a3202: 'Sesi berjaya dipadamkan',
		a3203: 'Sila pilih objek sesi! ',
		a3204: 'Sesi segar semula',
		a3205: 'Pengedar',
		a3206: 'Rekod Keluaran Sejarah',
		a3207: 'Kedai diterbitkan',
		a3208: 'Masa keluaran',
		a3209: 'Status keluaran',
		a3210: 'Penerbitan gagal',
		a3211: 'Sunting semula dan terbitkan',
		a3212: 'Muat naik berkelompok ke TIKTOK',
		a3213: 'Jana halaman pusat membeli-belah runcit',
		a3214: 'Garis Panduan Operasi Ejen',
		a3215: 'Penyingkiran separa',
		a3216: 'Keluaran produk',
		a3217: 'Berjaya memadam rekod! ',
		a3218: 'Beroperasi selepas menyemak produk',
		a3219: 'Operasi ini akan memadam',
		a3220: 'Rekod, sila sahkan sama ada untuk meneruskan? ',
		a3221: 'Tambah ke troli',
		a3222: 'Perundingan Perniagaan',
		a3223: 'Sila masukkan kandungan...',
		a3224: 'Bekalan saya',
		a3225: 'Mengeluarkan perintah bagi pihak perintah',
		a3226: 'Lokasi sumber',
		a3227: 'Enggan membalas kenyataan:',
		a3228: 'Enggan untuk kembali',
		a3229: 'Pindah ke perpustakaan pakej',
		a3230: 'Pakej milik',
		a3231: 'Pelbagai hadiah',
		a3232: 'Buat sku item secara manual dalam pesanan gudang',
		a3233: 'Adakah anda pasti mahu berpindah ke perpustakaan pakej?',
		a3234: 'Ia telah dipindahkan ke perpustakaan pakej! ',
		a3235: 'Harga asal runcit - (mata wang tempatan)',
		a3236: 'Harga bekalan-(unit/¥)',
		a3237: 'Associate cusCode',
		a3238: 'Permohonan yang diluluskan',
		a3239: 'Muat naik foto/video',
		a3240: 'Permohonan ditolak',
		a3241: 'Pesanan bina sendiri yang berjaya, sila pergi ke: Modul pesanan saya untuk melihat',
		a3242: 'Recharge & Sebutharga',
		a3243: 'Sila muat naik gambar/video',
		a3244: 'Permohonan saya',
		a3245: 'Permohonan sampel ejen',
		a3246: 'yuran sewa gudang',
		a3247: 'yuran pakej',
		a3248: 'Atribut jenama produk tidak dipilih',
		a3249: 'Atribut jualan sku pendua',
		a3250: 'Berjaya diterbitkan! ',
		a3251: 'Atribut produk dengan asterisk merah diperlukan',
		a3252: 'Pengecualian sistem',
		a3253: 'Panjang nama sku tidak melebihi 20 aksara',
		a3254: 'Atribut langit berbintang merah diperlukan',
		a3255: 'Panjang aksara bagi tajuk produk hendaklah antara 20 dan 100 aksara',
		a3256: 'Produk dengan tajuk produk yang sama sudah wujud di kedai semasa! ',
		a3257: 'Harga runcit sku, nilai maksimum dibahagikan dengan nilai minimum tidak boleh lebih daripada 7',
		a3258: 'Gudang Luar Negara',
		a3259: 'Senarai muka pencetakan lalai & senarai pemilihan',
		a3260: 'Tiada gudang terikat',
		a3261: 'Tiada stor terikat',
		a3262: 'Perbelanjaan yuran penghantaran pesanan',
		a3263: 'Pendapatan yuran penghantaran pesanan',
		a3264: 'Perbelanjaan yuran rak pesanan storan',
		a3265: 'Hasil yuran rak untuk pesanan penyimpanan',
		a3266: 'Perbelanjaan yuran pemprosesan pemulangan',
		a3267: 'Pendapatan yuran pemprosesan pemulangan',
		a3268: 'Potongan platform',
		a3269: 'Perbelanjaan yuran penghantaran pesanan (P)',
		a3270: 'Pendapatan yuran penghantaran pesanan (P)',
		a3271: 'Perbelanjaan yuran rak pesanan storan (P)',
		a3272: 'Hasil yuran rak untuk pesanan penyimpanan (P)',
		a3273: 'Contoh pembayaran yuran permohonan',
		a3274: 'Sampel pendapatan yuran permohonan',
		a3275: 'Maklumat perihalan produk adalah antara 2-3000 aksara',
		a3276: 'Pendapatan yuran keluar',
		a3277: 'Pendapatan Yuran Penyenaraian',
		a3278: 'hasil pulangan',
		a3279: 'pendapatan yuran pelbagai gudang',
		a3280: 'Pendapatan yuran sewa gudang (P)',
		a3281: 'Pendapatan potongan platform',
		a3282: 'Potongan platform perbelanjaan',
		a3283: 'Pendapatan yuran penyenaraian (P)',
		a3284: 'Pendapatan yuran keluar (P)',
		a3285: 'Pesanan Pembelian',
		a3286: 'pembelian penuh',
		a3287: 'pembelian deposit',
		a3288: 'Deposit:',
		a3289: 'Bayaran akhir:',
		a3290: 'Bayaran akhir:',
		a3291: 'Peringatan untuk membayar baki',
		a3292: 'Mesej telah berjaya dihantar untuk memberikan pembeli bayaran baki',
		a3293: 'Pendapatan yuran pembelian produk',
		a3294: 'Sila muat naik carta saiz',
		a3295: 'Carta Saiz',
		a3296: 'Perbelanjaan yuran pembelian produk',
		a3297: 'Mata pengembalian telah ditolak',
		a3298: 'Perbelanjaan yuran agensi platform pengedaran',
		a3299: 'Pendapatan yuran agensi platform pengedaran',
		a3300: 'Mata pada masa ini tidak mencukupi, sila cas semula dan cuba lagi',
		a3301: 'Pendapatan caj semula bayaran',
		a3302: 'Perbelanjaan caj semula bayaran',
		a3303: 'Pengedaran berjaya, sila pergi ke "Saya seorang ejen" untuk menyemak',
		a3304: 'Sila sahkan sama ada anda ingin mengedarkan produk ini?',
		a3305: 'Imbas untuk memuat turun APP',
		a3306: 'APP platform pengedaran (Android)',
		a3307: 'Produk pengedaran pelbagai peringkat',
		a3308: 'Perbelanjaan Rebat Tahap 1 Pengedar',
		a3309: 'Pendapatan Rebat Tahap 1 Pengagihan',
		a3310: 'Perbelanjaan rebat sekunder pengagihan',
		a3311: 'Agihan pendapatan rebat sekunder',
		a3312: 'Pengagihan perbelanjaan rebat tiga peringkat',
		a3313: 'Pengagihan pendapatan rebat tiga peringkat',
		a3314: 'Statistik Taburan Pelbagai Peringkat',
		a3315: 'Kuantiti ejen am',
		a3316: 'Amaun pembelian ejen am',
		a3317: 'Komisen hasil kasar',
		a3318: 'Cari Akaun Ejen',
		a3319: 'Tahap ejen',
		a3320: 'Akaun ejen',
		a3321: 'Penganjur peringkat pertama',
		a3322: 'Penganjur Sekunder',
		a3323: 'Penganjur peringkat ketiga',
		a3324: 'Jumlah pembelian',
		a3325: 'Jumlah komisen',
		a3326: 'Analisis proksi',
		a3327: 'Jumlah pembelian',
		a3328: 'Komisen',
		a3329: 'mengubah kedai',
		a3330: 'Token stok produk',
		a3331: 'Token Penghantaran Pesanan AS',
		a3332: 'Token penghantaran pesanan kawasan Eropah',
		a3333: 'Mata wang kedai',
		a3334: 'Sila isi ID kedai',
		a3335: 'Sila isi nama kedai',
		a3336: 'Sila pilih jenis kedai',
		a3337: 'Amerika Syarikat',
		a3338: 'United Kingdom',
		a3339: 'Jerman',
		a3340: 'Itali',
		a3341: 'Perancis',
		a3342: 'Sepanyol',
		a3343: 'Separuh dihosting',
		a3344: 'Penuh dihoskan',
		a3345: 'Kedai tempatan',
		a3346: 'Kedai Tema Hong Kong',
		a3347: 'Kedai utama bukan Hong Kong',
		a3348: 'Keadaan logistik',
		a3349: 'Memesan dalam talian',
		a3350: 'Tidak ada pesanan dalam talian',
		a3351: 'Pengurusan Galeri',
		a3352: 'Galeri gambar tersuai',
		a3353: 'Cipta gambar',
		a3354: 'Tiada versi',
		a3355: 'Cipta jenis induk',
		a3356: 'Nama Layout',
		a3357: 'Jenis tata letak',
		a3358: 'Model Layout',
		a3359: 'Model saiz',
		a3360: 'Nama warna',
		a3361: 'Saiz',
		a3362: 'Warna',
		a3363: 'Sila masukkan nama tata letak',
		a3364: 'Sila pilih jenis tataletak',
		a3365: 'Sila masukkan nombor versi',
		a3366: 'Sila muat naik imej',
		a3367: 'Sila masukkan model saiz',
		a3368: 'Sila masukkan nama warna',
		a3369: '1、DiangXiaosheng - Provide cross-border localization of overseas warehouse and distribution solutions',
		a3370: '2、DiangXiaosheng - Focus on small and medium parts of the United States/Southeast Asia localization services',
		a3371: 'Sila isi kod jemputan, untuk pengguna jemputan dalam sahaja, boleh menghubungi Microsignal Perkhidmatan Pelanggan:shopsbu001',
		a3372: 'Senarakkan pautan produk',
		a3373: 'Platform sedang memproses',
		a3374: 'Pencarian kumpulan tidak boleh melebihi 200!',
		a3375: 'Pemusnahan dalam giliran ke TEMU',
		a3376: 'Memuat naik produk dalam jumlah besar ke TEMU',
		a3377: 'Muat turun templat import',
		a3378: 'Klik Muat Turun Templat untuk Menyusun Produk dalam Kuantiti untuk Dibawa ke Backend TEMU',
		a3379: 'Muat naik fail produk yang disusun',
		a3380: `1. Templat ini hanya sesuai untuk kategori yang bukan pakaian, dan untuk masa ini hanya membuka untuk tiga kategori berikut: mat penahan licin bilik mandi; tuala pantai; selimut kecil dan selimut rehat siang.<br>
                            2. Kategori barang dan templat atribut mempunyai hubungan yang sesuai, perlu diisi mengikut aturan templat yang sepadan.
                            3. Pemeriksaan panjang judul produk: { A. Had panjang 100[cat1Id=1(CD dan piringan hitam)] B. Had panjang 200[cat1Id=653(bekalan pejabat), cat1Id=25439(keratan dan permainan)]
                            C. Had panjang 500 [cat1Id=2542 (elektronik)] D. Kecuali 4 kategori di atas, had panjang 250.
                            4. Klasifikasi produk: A. Tapak penghadang licin bilik mandi [11802] B. Handuk pantai [11809] C. Selimut kecil, selimut rehat tengah hari [11901] Sila salin klasifikasi di atas untuk diisi. `,
		a3381: "[PENGAJIAN PENTING!!!] Sila pastikan data borang yang anda muat naik adalah tepat dan tidak ada kesalahan.' ",
		a3382: 'Selepas borang pemusimasjukan dipaparkan dalam kuantiti besar, sistem akan memproses secara automatik dan tidak dapat dihentikan atau dibatalkan. ',
		a3383: 'Sila semak dengan teliti isi borang dan pastikan tiada kesalahan sebelum menghantar, untuk mengelakkan kehilangan disebabkan oleh kesilapan data. ',
		a3384: 'Platform tidak bertanggung jawab atas kesan yang disebabkan oleh data tidak tepat atau kesalahan operasi. ',
		a3385: 'Mula memasukkan',
		a3386: 'Merekod masuk',
		a3387: 'Nama fail',
		a3388: 'Jumlah keseluruhan fail',
		a3389: 'Menunggu untuk dilaksanakan',
		a3390: 'Dalam pelaksanaan',
		a3391: 'Telah dilaksanakan',
		a3392: 'Sudah berhenti',
		a3393: 'Kemajuan Pelaksanaan',
		a3394: 'Jumlah kejayaan pemasangan',
		a3395: 'Rekod kegagalan pemasangan',
		a3396: 'masa mula',
		a3397: 'Masa tamat',
		a3398: 'Hentikan',
		a3399: 'Galeri Produk Standard',
		a3400: 'Pemetaan haba platform',
		a3401: 'Pilih kumpulan',
		a3402: 'Penghantaran dalam kuantiti kepada galeri platform',
		a3403: 'Pengumpulan Gambar',
		a3404: 'Mencipta kumpulan',
		a3405: 'Sila masukkan nama kumpulan',
		a3406: 'Kandungan disesuaikan',
		a3407: 'Huruf Besar',
		a3408: 'kecil',
		a3409: 'Sila muat naik fail dengan hujung .xlsx! ',
		a3410: 'Fail sedang dimuat naik, jangan tutup halaman ini dan tunggu sistem memaklumkan jayanya! ',
		a3411: 'Adakah perlu berhenti memasang? Selepas berhenti, tidak dapat terus memasang, perlu hantar semula borang? ',
		a3412: 'Adakah mahu menghentikan pemapian dan memadamkan jadual ini? ',
		a3413: 'Jadual ini telah siap dimuat naik, adakah anda ingin memadamkan rekod ini? ',
		a3414: 'Adakah untuk memadamkan jadual ini? ',
		a3415: 'bilangan keluaran yang tidak normal',
		a3416: 'Distributor price',
		a3417: 'Please enter the distribution price!',
		a3418: 'Muat turun gambar cetak ini',
		a3419: 'Mengunduh dan mencetak dalam jumlah besar',
		a3420: 'Gambar sedang dibuat',
		a3421: 'Tiada gambar yang perlu dimuat turun untuk masa ini',
		a3422: 'Gambar cetak memerlukan resolusi 150DPI, gambar cetak semasa disemak sebagai',
		a3423: 'DPI， Sila hantar semula! ',
		a3424: 'Muat Turun Borang Penghantaran dalam Kuantiti', 
		a3425: 'Sila tunggu sebentar, sistem sedang memeriksa secara automatik resolusi gambar cetak, maklumat logistik, dan sebagainya. Sila sabar! ',
		a3426: 'Produk POD jika melibatkan pembelian beberapa benda dengan kod yang sama dan gambar yang sama, perlu menambah beberapa produk gudang, menyediakan beberapa gambar cetak, seperti pembelian 2 benda dengan kod yang sama, perlu menambah satu benda gudang masing-masing untuk mengemukakan 2 gambar cetak yang sama. ',
	}



}


export default zh

